// import tailwindcss from './app.css' with { type: 'css'};
const params = new URLSearchParams(window.location.search);
if (params.get('js') === 'false') {
  throw new Error('js is false');
}

window.BASE_URL = window.routes.api_base_uri;
// window.BASE_URL = 'https://move-api.test';
window.FABRICATORS_API_BASE_URL = window.routes.fabricators_api_base_uri;
window.PROXY_API_BASE_URL = window.routes.proxy_api_base_url;

const slugify = (str) => {
  return str
    .replace(/[^\w\s-]/g, '')
    .replaceAll(/[\s]+/g, '-')
    .toLowerCase();
};

String.prototype.slugify = function () {
  return this.replace(/[^\w\s-]/g, '')
    .replaceAll(/[\s]+/g, '-')
    .toLowerCase();
};

String.prototype.titleCase = function () {
  return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

const snakeCase = (str) => {
  return str.replace(/\s+/g, '_').toLowerCase();
};

async function getUserCountry() {
  try {
    const response = await fetch(window.location.origin + '/browsing_context_suggestions.json');
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    // Access the detected country handle (ISO code)
    const countryCode = data.detected_values.country.handle;
    console.log('Detected country code:', countryCode);
    return countryCode;
  } catch (error) {
    console.error('Error fetching browsing context suggestions:', error);
  }
}

// sort image by order 1 comes first, larger order comes second and null comes last
const imageOrder = (a, b) => {
  if (a.order === null && b.order === null) {
    return 0;
  }
  if (a.order === null) {
    return 1;
  }
  if (b.order === null) {
    return -1;
  }
  return b.order < a.order ? 1 : -1;
};

const latestAbortable = (fn) => {
  let controller = null;
  let callId = 0;

  return async (...args) => {
    const id = ++callId;
    controller?.abort();
    controller = new AbortController();

    try {
      const res = await fn(controller.signal, ...args);
      if (id !== callId) return;
      return res;
    } catch (e) {
      if (controller.signal.aborted) return;
      throw e;
    }
  };
};

const formatCurrency = (value) => {
  return value
    ? new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(value)
    : value;
};

function formDataToObject(formData) {
  const obj = {};

  for (const [key, value] of formData.entries()) {
    if (obj.hasOwnProperty(key)) {
      if (Array.isArray(obj[key])) {
        obj[key].push(value);
      } else {
        obj[key] = value;
      }
    } else {
      if (key.endsWith('[]')) {
        obj[key] = [value];
      } else {
        obj[key] = value;
      }
    }
  }

  return obj;
}

function dataURIToBlob(dataURI) {
  const splitDataURI = dataURI.split(',');
  const byteString = atob(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
}

const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

const actAsRadio = (target) => {
  if (target.checked) {
    target
      .closest('form')
      .querySelectorAll(`input[type="checkbox"][name="${target.name}"]`)
      .forEach((checkbox) => {
        if (checkbox !== target) {
          checkbox.checked = false;
        }
      });
  }
};

const serializeForm = (form) => {
  return Object.fromEntries(new FormData(form));
};

const getThumbImageSize = (imgElement) => {
  if (imgElement && imgElement.naturalWidth > 0 && imgElement.naturalHeight > 0) {
    return { width: imgElement.naturalWidth, height: imgElement.naturalHeight };
  }
  return null;
};

const probeImageSize = (src) => {
  return new Promise((resolve) => {
    const probe = new Image();
    probe.onload = () => resolve({ width: probe.naturalWidth, height: probe.naturalHeight });
    probe.onerror = () => resolve(null);
    probe.src = src;
  });
};

const applyImageSizeToOpenSlide = (pswp, item) => {
  const slide = pswp && pswp.currSlide;
  if (!slide || slide.data !== item) {
    return;
  }
  slide.width = item.width;
  slide.height = item.height;
  slide.calculateSize();
  slide.zoomAndPanToInitial();
  slide.updateContentSize(true);
  slide.applyCurrentZoomPan();
};

const seedImageSize = (item, thumbEl) => {
  if (!item || item.hasRealSize) {
    return;
  }
  const thumbSize = getThumbImageSize(thumbEl);
  if (thumbSize) {
    const scale = 1600 / thumbSize.width;
    item.width = 1600;
    item.height = Math.round(thumbSize.height * scale);
  } else {
    item.width = 1600;
    item.height = 1000;
  }
};

const probeAndPatchSlide = (pswp, item) => {
  if (!item || item.hasRealSize) {
    return;
  }
  probeImageSize(item.src).then((size) => {
    if (!size) {
      return;
    }
    item.hasRealSize = true;
    Object.assign(item, size);
    applyImageSizeToOpenSlide(pswp, item);
  });
};

const ensureSlideSize = (pswp) => {
  const slide = pswp && pswp.currSlide;
  if (!slide || !slide.data) {
    return;
  }
  if (slide.data.width && slide.data.height && (!slide.width || !slide.height)) {
    slide.width = slide.data.width;
    slide.height = slide.data.height;
    slide.calculateSize();
    slide.zoomAndPanToInitial();
    slide.updateContentSize(true);
    slide.applyCurrentZoomPan();
  }
  probeAndPatchSlide(pswp, slide.data);
};

const enableLazySlideLoading = (pswp, onChange) => {
  // Block initial asset loads for background/neighbor slides
  pswp.on('contentLoad', (e) => {
    const { content } = e;

    // If the layout engine tries to load an asset that is NOT the active slide, stop it.
    if (content.index !== pswp.currIndex) {
      e.preventDefault();
    }
  });
  pswp.on('change', () => {
    if (onChange) {
      onChange();
    }
    ensureSlideSize(pswp);
    const slide = pswp.currSlide;
    const activeContent = slide && slide.content;
    // Force the freshly opened slide to load assets if it was blocked earlier.
    // Note: isLoading() is a method and isLoaded does not exist in this PSwP build,
    // and element is only created once the load path actually runs.
    if (activeContent && !activeContent.isLoading() && !activeContent.element) {
      activeContent.load();
    }
    // PhotoSwipe only attaches the image when slide.isActive && slide.heavyAppended,
    // and the heavy append no-ops when the element does not exist yet - re-check now.
    if (slide) {
      slide.appendHeavy();
      if (activeContent && activeContent.element && !activeContent.element.parentNode) {
        activeContent.append();
      }
    }
  });
};

const refreshSection = async (section, href = window.location.href, containerId) => {
  const sectionId = section.id.replace('shopify-section-', '');
  const url = new URL(href);
  const params = url.searchParams;
  params.set('section_id', sectionId);
  const html = await fetch(url.pathname + '?' + params.toString()).then((resp) => resp.text());
  const dom = new DOMParser().parseFromString(html, 'text/html');
  if (containerId) {
    section.querySelector(`[id="${containerId}"]`).innerHTML = dom.querySelector(`[id="${containerId}"]`).innerHTML;
  } else {
    section.innerHTML = dom.querySelector(`[id="${section.id}"]`).innerHTML;
  }
};

const getModal = () => {
  const modal = document.querySelector('customizer-modal');
  if (modal instanceof CustomizerModal) {
    return modal;
  }
  // throw new Error('Missing modal');
  return null;
};

class CartDrawer extends HTMLElement {
  static #section = 'move-cart-items';
  constructor() {
    super();
    this._isOpen = false;
  }

  connectedCallback() {
    this.init();
    this.bindTriggers();
    this.addEventListener('drawer:opened', this.fetchCartSection.bind(this));
    this.addEventListener('drawer:loading', this.showLoading.bind(this));
    this.addEventListener('drawer:loaded', this.hideLoading.bind(this));
  }

  showLoading() {
    this.classList.add('loading');
  }

  hideLoading() {
    this.classList.remove('loading');
  }

  async fetchCartSection() {
    const url = `${Shopify.routes.root}cart?section_id=${CartDrawer.#section}`;
    this.dispatchEvent(new CustomEvent('drawer:loading'));
    this.content.innerHTML = '';
    return await fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        return res;
      })
      .then((res) => res.text())
      .then((html) => {
        this.content.innerHTML = html;
      })
      .catch((error) => {
        console.error('Error fetching cart section:', error);
      })
      .finally(() => {
        this.dispatchEvent(new CustomEvent('drawer:loaded'));
      });
  }

  get isOpen() {
    return this._isOpen;
  }

  set isOpen(value) {
    this._isOpen = value;
    this.toggle(value);
  }

  init() {
    this.backdrop = this.querySelector('.cart-drawer__backdrop');
    this.content = this.querySelector('.cart-drawer__content');
  }

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }

  bindTriggers() {
    this._triggerListener = (event) => {
      if (event.target.dataset.toggle === 'cart' || event.target.closest('a')?.dataset?.toggle === 'cart') {
        event.preventDefault();
        this.toggle();
      }
    };
    document.addEventListener('click', this._triggerListener);
  }
  disconnectedCallback() {
    document.removeEventListener('click', this._triggerListener);
  }

  toggle(isOpen) {
    this._isOpen = isOpen ?? !this._isOpen;
    this.classList.toggle('hidden', !this._isOpen);
    this.classList.toggle('flex', this._isOpen);
    document.body.classList.toggle('overflow-hidden', this._isOpen);
    if (this._isOpen) {
      this.dispatchEvent(new CustomEvent('drawer:opened'));
    } else {
      this.dispatchEvent(new CustomEvent('drawer:closed'));
    }
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class MoveAccordion extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('header');
    this.article = this.querySelector('article');
    this.icon = this.header.querySelector('span');
    this.contentLoaded = false;
    this.header.addEventListener('click', this.toggle.bind(this));
    this.article.classList.toggle('hidden', !this.isOpend);
    if (this.isOpend) {
      this.loadContent();
    }
  }

  get isOpend() {
    return this.classList.contains('accordion-item-active');
  }

  loadContent() {
    if (this.contentLoaded || !this.article.hasAttribute('data-content')) return;
    this.contentLoaded = true;
    const parser = new DOMParser();
    const doc = parser.parseFromString(this.article.dataset.content, 'text/html');
    this.article.append(...doc.body.childNodes);
  }

  toggle() {
    if (this.isOpend) {
      this.classList.remove('accordion-item-active');
      setTimeout(() => {
        this.article.classList.add('hidden');
      }, 300);
    } else {
      this.loadContent();
      this.article.classList.remove('hidden');
      requestAnimationFrame(() => {
        this.classList.add('accordion-item-active');
      });
    }
    // this.icon.classList.toggle('bg-icon-accordion-minus');
    // this.icon.classList.toggle('bg-icon-accordion-plus');
  }
}
if (!customElements.get('move-accordion')) {
  customElements.define('move-accordion', MoveAccordion);
}

class MoveGallery extends HTMLElement {
  constructor() {
    super();
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.touchThreshold = 50;
    this.preview = this.querySelector('img');
    this.images = Array.from(this.querySelectorAll('img')).filter((image) => image !== this.preview);
    this.index = this.images.findIndex((image) => image.parentElement.classList.contains('selected'));
    this.prevBtn = this.querySelector('button:first-of-type');
    this.nextBtn = this.querySelector('button:last-of-type');

    this.prevBtn.addEventListener('click', this.prev.bind(this));
    this.nextBtn.addEventListener('click', this.next.bind(this));
    this.images.forEach((image) => image.addEventListener('click', this.select.bind(this)));
    this.addEventListener('touchstart', this.handleTouchStart.bind(this));
    // this.addEventListener('touchmove', this.handleTouchMove.bind(this));
    this.addEventListener('touchend', this.handleTouchEnd.bind(this));
  }

  handleTouchStart(event) {
    this.touchStartX = event.touches[0].clientX;
  }

  handleTouchEnd(event) {
    this.touchEndX = event.changedTouches[0].clientX;
    const dir = this.checkSwipeDirection();
    if (dir === 'left') {
      this.next();
    } else if (dir === 'right') {
      this.prev();
    }
  }

  checkSwipeDirection() {
    // Calculate the horizontal distance
    const diffX = this.touchEndX - this.touchStartX;

    if (Math.abs(diffX) > this.touchThreshold) {
      // Check if the distance is significant enough
      if (diffX < 0) {
        return 'left';
      } else {
        return 'right';
      }
    }
  }

  toggleThumbnail(image) {
    if (image instanceof HTMLImageElement) {
      image.parentElement.classList.toggle('selected');
    }
  }

  select(event) {
    this.toggleThumbnail(this.images[this.index]);
    this.index = this.images.indexOf(event.target);
    this.toggleThumbnail(this.images[this.index]);
    this.preview.src = this.images[this.index].dataset.originalSrc || this.images[this.index].src;
  }

  next() {
    this.toggleThumbnail(this.images[this.index]);
    this.index = (this.index + 1) % this.images.length;
    this.toggleThumbnail(this.images[this.index]);
    this.preview.src = this.images[this.index].dataset.originalSrc || this.images[this.index].src;
  }

  prev() {
    this.toggleThumbnail(this.images[this.index]);
    this.index = (this.index - 1 + this.images.length) % this.images.length;
    this.toggleThumbnail(this.images[this.index]);
    this.preview.src = this.images[this.index].dataset.originalSrc || this.images[this.index].src;
  }
}
if (!customElements.get('move-gallery')) {
  customElements.define('move-gallery', MoveGallery);
}

class MoveModal extends HTMLElement {
  constructor() {
    super();
    this.removers = [];
    this.backListener = this.close.bind(this);
  }

  connectedCallback() {
    this.bindTriggers();
    this.bindBack();
  }

  bindBack() {
    window.addEventListener('popstate', this.backListener);
  }

  unbindBack() {
    window.removeEventListener('popstate', this.backListener);
  }

  disconnectedCallback() {
    this.unbindTriggers();
    window.removeEventListener('popstate', this.backListener);
  }

  unbindTriggers() {
    if (this.removers.length) {
      this.removers.forEach((remove) => {
        remove();
      });
      this.removers = [];
    }
  }

  handleTriggerClick(trigger, event) {
    event.preventDefault();
    const section = trigger.dataset.section;
    if (section) {
      this.open(section, trigger);
    } else {
      this.close();
    }
  }

  bindTriggers() {
    this.unbindTriggers();
    const triggers = document.querySelectorAll('[data-toggle=modal][data-section]');
    triggers.forEach((trigger) => {
      const listener = this.handleTriggerClick.bind(this, trigger);
      this.removers.push(() => {
        trigger.removeEventListener('click', listener);
      });
      trigger.addEventListener('click', listener);
    });
  }

  open(section, source) {
    const notPrevented = this.dispatchEvent(
      new CustomEvent('modal:opening', { cancelable: true, detail: { section, source } }),
    );
    if (notPrevented) {
      this.bindBack();
      const url = (source?.dataset?.page ? source.dataset.page : window.location.pathname) + `?section_id=${section}`;
      fetch(url)
        .then((res) => {
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          return res;
        })
        .then((res) => res.text())
        .then((html) => {
          this.innerHTML = html;
        })
        .then(() => {
          document.body.classList.add('overflow-hidden');
          this.classList.remove('hidden');
          history.pushState('modal', '', location.href);
          this.bindTriggers();
          this.dispatchEvent(new CustomEvent('modal:opened'));
        })
        .catch((error) => {
          console.log(error);
          this.close();
        });
    }
  }

  close(source, force = false) {
    // console.log(source, force);
    if (!force) {
      force = this.dispatchEvent(new CustomEvent('modal:closing', { cancelable: true }));
    }
    if (force) {
      this.innerText = '';
      document.body.classList.remove('overflow-hidden');
      this.classList.add('hidden');
      if (history.state === 'modal') {
        this.unbindBack();
        history.back();
      }
      this.dispatchEvent(new CustomEvent('modal:closed'));
    }
  }
}
if (!customElements.get('move-modal')) {
  customElements.define('move-modal', MoveModal);
}

class MoveMMY extends HTMLElement {
  constructor() {
    super();
    this.allVehicles = [];
    this.saved = {
      make: '',
      model: '',
      year: '',
    };
    this.init = false;
    this.vehicleLoaded = Promise.withResolvers();
  }

  connectedCallback() {
    this.initSave();
    this.updateFromURL();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.submit.bind(this));
    this.makeSelect = this.querySelector('select[name=make]');
    this.modelSelect = this.querySelector('select[name=model]');
    this.yearSelect = this.querySelector('select[name=year]');
    this.makeSelect.disabled = true;
    this.modelSelect.disabled = true;
    this.yearSelect.disabled = true;
    this.fetchAllVehicles().then(() => {
      // this.extractVehiclesInfoFromUrl();
      this.extractVehicleFromCollection();
      this.updateFromURL();
      this.initMakes();
      this.dispatchEvent(new CustomEvent('vehicles:loaded', { detail: this.allVehicles, bubbles: true }));
    });
    this.addEventListener('vehicles:loaded', () => {
      this.vehicleLoaded.resolve(Boolean(this.selectedVehicle));
    });
    this.makeSelect.addEventListener('input', ({ target: { value } }) => {
      this.modelSelect.disabled = !value;
      if (this.init) {
        this.saved.make = '';
        this.saved.model = '';
      }
      this.initModels();
    });
    this.modelSelect.addEventListener('input', ({ target: { value } }) => {
      this.yearSelect.disabled = !value;
      if (this.init) {
        this.saved.year = '';
      } else {
        this.init = true;
      }
      this.initYears();
    });
    this.submitButton = this.querySelector('button[type=submit]');
    this.submitButton.disabled = true;
    this.form.addEventListener('input', this.determineSubmitButtonState.bind(this));
    this.updateVehicleInfo();
    document.addEventListener('vehicle:changed', (e) => {
      if (e.target !== this) {
        console.log('vehicle changed outside of ', this);
        this.handleVehicleChangedOutside(e.detail);
      }
    });
  }

  get onCollections() {
    const page_path = window.location.pathname.split('/').at(-2);
    return page_path === 'collections';
  }

  extractVehiclesInfoFromUrl() {
    const page_path = window.location.pathname.split('/').at(-2);
    // if (page_path === 'collections' && !JSON.parse(localStorage.getItem('vehicle'))) {
    if (page_path === 'collections') {
      const collection_handle = window.location.pathname.split('/').at(-1);
      const vehicle = this.allVehicles.find((vehicle) => vehicle.collection_handle === collection_handle);
      if (vehicle) {
        // localStorage.setItem('vehicle', JSON.stringify(vehicle));
        this.setSelectedVehicle(vehicle, false);
      }
    }
  }

  extractVehicleFromCollection() {
    const collectionId = document.querySelector('meta[name="collection_id"]')?.content;
    if (!collectionId) {
      return;
    }
    const vehicle = this.allVehicles.find((vehicle) => vehicle.shopify_collection_id === Number(collectionId));
    if (vehicle) {
      // this.storeVehicle(vehicle);
      // this.syncVehicle(vehicle);
      this.setSelectedVehicle(vehicle);
      this.initSave();
    }
  }

  updateFromURL() {
    const params = new URLSearchParams(window.location.search);
    let mmy = ['make', 'model', 'year'].reduce((acc, k) => ({ ...acc, [k]: params.get(k) }), {});
    const galleryPath = '/community/move-gallery';
    if (window.location.pathname.includes(galleryPath)) {
      const split = window.location.pathname.replace(galleryPath, '').split('/').filter(Boolean);
      Object.keys(mmy).map((k, i) => (mmy[k] = split[i] ?? ''));
    }
    const make = this.allVehicles.map((v) => v.make).find((m) => m.slugify() === mmy.make);
    const model = this.allVehicles.map((v) => v.model).find((m) => m.slugify() === mmy.model);
    const year = this.allVehicles.map((v) => v.year).find((m) => m.slugify() === mmy.year);
    if (make) {
      if (make !== this.saved.make) {
        this.saved.make = make;
      }
      if (model && model !== this.saved.model) {
        this.saved.model = model;
      } else if (!model) {
        this.saved.model = '';
      }
      if (year && year !== this.saved.year) {
        this.saved.year = year;
      } else if (!year) {
        this.saved.year = '';
      }
    }
  }

  softReset() {
    this.makeSelect.value = '';
    this.modelSelect.value = '';
    this.yearSelect.value = '';
    Array.from(this.modelSelect.options)
      .slice(1)
      .forEach((option) => {
        option.remove();
      });
    Array.from(this.yearSelect.options)
      .slice(1)
      .forEach((option) => {
        option.remove();
      });
    // this.makeSelect.dispatchEvent(new InputEvent('input'));
  }

  determineSelectedVehicle() {
    return this.allVehicles.find(
      (vehicle) =>
        vehicle.make === this.makeSelect.value &&
        vehicle.model === this.modelSelect.value &&
        vehicle.year === this.yearSelect.value,
    );
  }

  handleVehicleChangedOutside(vehicle) {
    this.init = false;
    this.storeVehicle(vehicle);
    this.syncVehicle(vehicle);
    this.initSave();
    this.initMakes();
  }

  syncVehicle(vehicle) {
    this.selectedVehicle = vehicle || null;
    if (this.modal) {
      this.modal.selectedVehicle = vehicle || null;
    }
    const customizer = document.querySelector('customizer-modal');
    if (customizer) {
      customizer.selectedVehicle = vehicle;
    }
    this.updateVehicleInfo();
  }

  determineSubmitButtonState() {
    this.submitButton.disabled = !['make', 'model', 'year'].every((key) => this.form.elements[key].value);
  }

  initSave() {
    try {
      const jsonString = localStorage.getItem('vehicle');
      if (jsonString) {
        const parsed = JSON.parse(jsonString);
        if (parsed) {
          this.saved.make = parsed.make;
          this.saved.model = parsed.model;
          this.saved.year = parsed.year;
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  flush() {
    this.form.reset();
    this.clearOptions(this.makeSelect);
    this.clearOptions(this.modelSelect);
    this.clearOptions(this.yearSelect);
    // localStorage.removeItem('vehicle');
  }

  clearOptions(select) {
    if (select instanceof HTMLSelectElement) {
      Array.from(select.options)
        .slice(1)
        .forEach((option) => {
          option.remove();
        });
    }
  }

  addOption(select, value, label, selected = false) {
    if (select instanceof HTMLSelectElement) {
      const option = document.createElement('option');
      option.value = value;
      option.label = label;
      option.selected = selected;
      select.options.add(option);
    }
  }

  initModels() {
    this.clearOptions(this.modelSelect);
    this.clearOptions(this.yearSelect);
    this.allVehicles
      .filter((vehicle) => vehicle.make === this.makeSelect.value)
      .reduce((acc, vehicle) => (acc.includes(vehicle.model) ? acc : [...acc, vehicle.model]), [])
      .forEach((model) => this.addOption(this.modelSelect, model, model, this.saved.model === model));
    this.modelSelect.dispatchEvent(new Event('input', { bubbles: true }));
  }

  initYears() {
    this.clearOptions(this.yearSelect);
    this.allVehicles
      .filter((vehicle) => vehicle.make === this.makeSelect.value && vehicle.model === this.modelSelect.value)
      .reduce((acc, vehicle) => (acc.includes(vehicle.year) ? acc : [...acc, vehicle.year]), [])
      .forEach((year) => this.addOption(this.yearSelect, year, year, this.saved.year === year));
    this.yearSelect.dispatchEvent(new Event('input', { bubbles: true }));
  }

  initMakes() {
    this.makeSelect.disabled = true;
    this.clearOptions(this.makeSelect);
    this.allVehicles
      .reduce((acc, vehicle) => (acc.includes(vehicle.make) ? acc : [...acc, vehicle.make]), [])
      .forEach((make) => {
        const selected = this.saved.make === make;
        this.addOption(this.makeSelect, make, make, selected);
      });
    this.makeSelect.disabled = false;
    this.makeSelect.dispatchEvent(new Event('input', { bubbles: true }));
  }

  async fetchAllVehicles() {
    const url = `${BASE_URL}/api/vehicles`;
    return fetch(url)
      .then((res) => res.json())
      .then((data) => {
        this.allVehicles = data;
      });
  }

  updateVehicleInfo() {
    try {
      const vehicle = JSON.parse(localStorage.getItem('vehicle'));
      document.getElementById('vehicle-info').textContent = `${vehicle.make} ${vehicle.model} ${vehicle.year}`;
    } catch (e) {}
  }

  storeVehicle(vehicle) {
    if (vehicle) {
      localStorage.setItem('vehicle', JSON.stringify(vehicle));
      // Calculate an expiration date far into the future (e.g., 10 years)
      // The browser will cap this value to its maximum limit (around 400 days in Chrome)
      const tenYearsInMilliseconds = 10 * 365 * 24 * 60 * 60 * 1000;
      const expirationDate = Date.now() + tenYearsInMilliseconds;
      cookieStore
        .set({
          name: 'vehicle',
          value: vehicle.sku,
          expires: expirationDate,
          path: '/',
          domain: 'movebumpers.com',
          sameSite: 'lax',
        })
        .catch(console.log);
    } else {
      localStorage.removeItem('vehicle');
      cookieStore.delete('vehicle');
    }
  }

  setSelectedVehicle(vehicle, store = true) {
    if (store) {
      this.storeVehicle(vehicle);
    }
    this.syncVehicle(vehicle);
    // Emit event
    this.dispatchEvent(new CustomEvent('vehicle:changed', { detail: vehicle, bubbles: true }));
  }

  get formData() {
    return Object.fromEntries(new FormData(this.form));
  }

  get vehicle() {
    const keys = ['make', 'model', 'year'];
    return this.allVehicles.find((vehicle) => keys.every((key) => vehicle[key] === this.formData[key]));
  }

  submit(e) {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(this.form));
    const keys = ['make', 'model', 'year'];
    const vehicle = this.allVehicles.find((vehicle) => keys.every((key) => vehicle[key] === data[key]));
    // console.log(vehicle);
    // if (vehicle) {
    // }
    this.setSelectedVehicle(vehicle);
    // window.location.href = `/collections/${vehicle.collection_handle}`;
    // this.modal.open('move-customizer-step-2-new');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const selectedVehicle = JSON.parse(localStorage.getItem('vehicle'));
  document.querySelectorAll('a[href*="/collections/all"]').forEach((a) => {
    if (selectedVehicle) {
      a.href = `/collections/${selectedVehicle.collection_handle}`;
    }
    a.classList.add('vehicle-collection-url');
  });
  document.querySelectorAll('a[href*="/collections/move-bumpers"]').forEach((a) => {
    if (selectedVehicle) {
      a.href = `/collections/${selectedVehicle.collection_handle}`;
    }
    a.classList.add('vehicle-collection-url');
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const moveMmy = document.querySelector('move-mmy');
  const selectedVehicle = JSON.parse(localStorage.getItem('vehicle'));
  if (moveMmy instanceof MoveMMY) {
    if (moveMmy.getAttribute('type') === 'vehicle') {
      moveMmy.addEventListener('vehicle:changed', ({ detail: vehicle }) => {
        const pathname = `/collections/${vehicle.collection_handle}`;
        if (location.pathname !== pathname) {
          window.location.href = pathname;
        }
      });
      if (
        selectedVehicle &&
        params.get('open') !== 'customizer' &&
        (location.pathname === '/collections/all' || location.pathname === '/collections/move-bumpers')
      ) {
        window.location.href = `/collections/${selectedVehicle.collection_handle}`;
      }
      if (selectedVehicle) {
        CustomizerStep2.RESET_FILTER_LOCATION = `/collections/${selectedVehicle.collection_handle}`;
        CustomizerStep3.CLOSE_REDIRECT_PATH = `/collections/${selectedVehicle.collection_handle}`;
      }
    } else if (moveMmy.getAttribute('type') === 'gallery') {
      // moveMmy.form.addEventListener(
      //   'input',
      //   debounce(() => {
      //     moveMmy.form.requestSubmit();
      //   }, 300),
      // );
      // moveMmy.form.addEventListener('input', (e) => {
      //   // console.log('input');
      //   const gallery = document.querySelector('move-customer-gallery');
      //   if (gallery instanceof MoveCustomerGallery) {
      //     gallery.setAttribute('vehicle', '');
      //     gallery.setAttribute('make', moveMmy.makeSelect.value || '');
      //     gallery.setAttribute('model', moveMmy.modelSelect.value || '');
      //     gallery.setAttribute('year', moveMmy.yearSelect.value || '');
      //     const url = new URL(window.location.href);
      //     if (moveMmy.makeSelect.value) {
      //       url.searchParams.set('make', moveMmy.makeSelect.value.slugify());
      //     } else {
      //       url.searchParams.delete('make');
      //     }
      //     if (moveMmy.modelSelect.value) {
      //       url.searchParams.set('model', moveMmy.modelSelect.value.slugify());
      //     } else {
      //       url.searchParams.delete('model');
      //     }
      //     if (moveMmy.yearSelect.value) {
      //       url.searchParams.set('year', moveMmy.yearSelect.value.slugify());
      //     } else {
      //       url.searchParams.delete('year');
      //     }
      //     history.pushState(null, '', url.toString());
      //     if (moveMmy.makeSelect.value && moveMmy.modelSelect.value && moveMmy.yearSelect.value) {
      //       moveMmy.form.requestSubmit();
      //     }
      //   }
      // });
      // moveMmy.addEventListener('vehicle:changed', ({ detail: vehicle }) => {
      //   document.querySelector('move-customer-gallery')?.setAttribute('vehicle', vehicle.sku);
      // });
    }
  }
});

if (!customElements.get('move-mmy')) {
  customElements.define('move-mmy', MoveMMY);
}

class CustomizerModal extends MoveModal {
  constructor() {
    super();
    this.selectedVehicle = null;
    this.selectedProduct = null;
    this.selectedCompanions = [];
    this.meta = null;
    this.cancelToken = null;
    this.fetching = false;
    this.section = '';
    this.listeners = {
      'modal:closed': this.onClose.bind(this),
      'modal:opening': this.onOpening.bind(this),
    };
  }

  get onPDP() {
    return window.location.pathname.includes('/products/');
  }

  get onCollections() {
    const page_path = window.location.pathname.split('/').at(-2);
    return page_path === 'collections';
  }

  async determineProductFromPage() {
    const slug = window.location.pathname.split('/').at(-1);
    const url = `${BASE_URL}/api/products`;
    const product = await this.fetchData(url).then((products) => {
      return products.find((product) => product.detail.shopify_handle === slug);
    });
    return product;
  }

  async fetchData(url) {
    if (this.cancelToken) {
      this.cancelToken.abort('New request');
    }
    this.cancelToken = new AbortController();
    this.fetching = true;
    try {
      return fetch(url, { signal: this.cancelToken.signal }).then((resp) => resp.json());
    } finally {
      this.fetching = false;
    }
  }

  connectedCallback() {
    super.connectedCallback();
    Object.entries(this.listeners).forEach(([event, listener]) => this.addEventListener(event, listener));
    try {
      this.selectedVehicle = JSON.parse(localStorage.getItem('vehicle'));
    } catch (e) {
      console.log(e);
    }
  }

  onOpening(e) {
    e.preventDefault();
    this.removeEventListener('modal:opening', this.listeners['modal:opening']);
    const section = e.detail.section;
    const source = e.detail.source;
    if (!this.selectedVehicle) {
      this.selectedVehicle = JSON.parse(localStorage.getItem('vehicle'));
    }
    // opened from header customize button
    if (source && source.classList.contains('btn-primary-header')) {
      this.open(section);
      return;
    }
    if (!this.selectedProduct) {
      if (this.onPDP) {
        this.determineProductFromPage().then((product) => {
          this.selectedProduct = product;
          localStorage.setItem('product', JSON.stringify(this.selectedProduct));

          if (this.selectedVehicle) {
            this.open('move-customizer-step-3-new');
          } else {
            this.open(section);
          }
        });
      } else {
        try {
          this.selectedProduct = JSON.parse(localStorage.getItem('product') ?? null);
        } catch (e) {
          console.log(e);
          this.selectedProduct = null;
        }
        this.open(section);
      }
    } else {
      this.open(section);
    }
  }

  flushSavedCustomizations() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('customization_id')) {
      params.delete('customization_id');
      const query = params.toString() ? `?${params.toString()}` : '';
      history.replaceState(null, null, window.location.pathname + query);
    }
  }

  onClose() {
    this.selectedVehicle = null;
    this.selectedProduct = null;
    this.selectedCompanions = [];
    this.meta = null;
    this.addEventListener('modal:opening', this.listeners['modal:opening']);

    this.flushSavedCustomizations();
  }
}
if (!customElements.get('customizer-modal')) {
  customElements.define('customizer-modal', CustomizerModal);
}
class CustomizerStep1 extends MoveMMY {
  constructor() {
    super();
    this.modal = this.getModal();
    this.modal.addEventListener('modal:closed', this.flush.bind(this));
  }
  getModal() {
    const modal = this.closest('customizer-modal');
    if (modal instanceof CustomizerModal) {
      return modal;
    }
    throw new Error('Missing modal');
  }
  submit(e) {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(this.form));
    const keys = ['make', 'model', 'year'];
    const vehicle = this.allVehicles.find((vehicle) => keys.every((key) => vehicle[key] === data[key]));
    this.setSelectedVehicle(vehicle);
    if (this.modal.onPDP) {
      this.modal.open('move-customizer-step-3-new');
    } else {
      // this.modal.open('move-customizer-step-2-new');
      location.reload();
    }
  }
}
if (!customElements.get('customizer-step1')) {
  customElements.define('customizer-step1', CustomizerStep1);
}
class CustomizerStep3 extends HTMLElement {
  PRIMARY_SUFFIX = ' PRIMARY';
  SECONDARY_SUFFIX = ' SECONDARY';
  overlayImageContainer;
  static CLOSE_REDIRECT_PATH = '/collections/move-bumpers';
  constructor() {
    super();
    this.openedGroups = new Set();
    this.form = this.querySelector('form');
    this.overlayStack = [];
    this.modal = this.getModal();
    this.saved = {
      skus: [...this.modal.selectedCompanions],
    };
    this.drawerElements = this.getDrawerElements();
    // toggle drawer
    this.drawerElements.drawerToggler.addEventListener('click', () => {
      this.drawerElements.drawerContent.classList.toggle('hidden');
      this.drawerElements.drawerBackdrop.classList.toggle('hidden');
    });
    this.mainImage = this.querySelector('img');
    this.initSave();
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.modalListeners = {
      'modal:opening': this.handleModalOpening.bind(this),
      'modal:closing': this.handleModalClosing.bind(this),
      'modal:closed': this.handleModalClosed.bind(this),
    };
    Object.entries(this.modalListeners).forEach(([event, listener]) => {
      this.modal.addEventListener(event, listener);
    });
    this.companions = [];
    this.mmyProduct = null;
    this.selectedCompanions = [];
    this.loadedImages = [];
    this.companionGroupsContainer = document.getElementById('companion-groups-container');
    this.submitButton = this.form.querySelector('button[type="submit"]');
    this.addedToCartModal = document.getElementById('added-to-cart-modal');
    this.initCompanions();
    this.cartDrawer = document.querySelector('cart-drawer');
    this.customTextImgUrl = null;
    if (this.modal.meta?.custom_text) {
      const url = `${window.routes.api_base_uri}/api/custom-text/${this.modal.selectedProduct.sku}/${this.modal.meta.custom_text}`;
      this.customTextImgUrl = url;
    }
    // this.renderOverlay = latestAbortable(this.renderOverlay.bind(this));
    this.handleCustomTextChange = debounce(this.handleCustomTextChange.bind(this), 500);
    this.form.addEventListener('input', this.handleChange.bind(this));
    this.handleChange = debounce(this.handleChange.bind(this), 1000);
  }

  handleModalOpening(e) {
    this.modal.addEventListener('modal:closing', this.modalListeners['modal:closing']);
  }

  handleModalClosed(e) {
    window.location.href = CustomizerStep3.CLOSE_REDIRECT_PATH;
  }

  handleModalClosing(e) {
    e.preventDefault();
    customConfirm({ confirmUrl: CustomizerStep3.CLOSE_REDIRECT_PATH }).then((value) => {
      if (value === 'confirm') {
        this.modal.removeEventListener('modal:closing', this.modalListeners['modal:closing']);
        this.flush();
        this.modal.close();
      } else if (value === 'save') {
        this.saveModal.showModal();
      } else {
        // Cancel
        if (history.state !== 'modal') {
          history.pushState('modal', '', location.href);
        }
      }
    });
  }

  setupHiResCanvas(canvas, displayWidth, displayHeight, scaleFactor = 2) {
    canvas.width = displayWidth * scaleFactor;
    canvas.height = displayHeight * scaleFactor;
    // canvas.style.width = displayWidth + 'px';
    // canvas.style.height = displayHeight + 'px';
    const ctx = canvas.getContext('2d');
    ctx.scale(scaleFactor, scaleFactor);
    return ctx;
  }

  connectedCallback() {
    this.saveBtn = this.querySelector('.btn-customizer-save');
    if (this.modal.onPDP) {
      const previousButton = this.querySelector('.btn-customizer-prev');
      previousButton.dataset.section = 'move-customizer-step-1';
    }
    window.addEventListener('resize', () => {
      this.renderOverlay();
    });
    const communityCarousel = document.querySelector('community-carousel');
    communityCarousel.setAttribute('vehicle', this.modal.selectedVehicle.sku);
    communityCarousel.setAttribute('product', this.modal.selectedProduct.sku);
    this.overlayImageContainer = document.querySelector('.overlay-image-container');
    this.canvas = this.querySelector('canvas');
    this.canvas.style.width = '100%';
    this.canvas.style.height = 'auto';

    this.saveModal = document.getElementById('save-modal');
    if (this.saveModal) {
      this.saveModal.querySelector('form[method=post]').addEventListener('submit', (e) => {
        e.preventDefault();
        this.handleSaveSubmit(e.target);
      });
      this.saveBtn.addEventListener('click', this.handleSave.bind(this));
    }
    this.customizerLoader = document.getElementById('customizer-loader');
    // window.addEventListener('click', this.closeModalAddedToCart)
  }
  // closeModalAddedToCart(event) {
  //   if (event.target.dataset.toggle === 'modal') {
  //       if (event.target.dataset.target === '#added-to-cart-modal') {
  //         this.hideAddedToCartModal();
  //       }
  //     }
  // }

  disconnectedCallback() {
    this.modal.removeEventListener('modal:closing', this.closeModalListener);
    window.removeEventListener('click', this.closeModalAddedToCart);
  }

  handleSaveSubmit(form) {
    const data = Object.fromEntries(new FormData(form));
    data.vehicle_sku = this.modal.selectedVehicle.sku;
    data.product_sku = this.modal.selectedProduct.sku;
    data.companion_skus = this.selectedCompanions.map(({ sku }) => sku);
    data.image = this.canvas.toDataURL('image/png');
    if (this.modal.meta) {
      data.meta = this.modal.meta;
    }
    const params = new URLSearchParams(window.location.search);
    const customizationId = params.get('customization_id');
    data.customization_id = customizationId;
    const url = `${BASE_URL}/api/customizations`;
    const submitBtn = form.querySelector('button[type="submit"]');
    submitBtn.disabled = true;
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        this.saveModal.close();
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        submitBtn.disabled = false;
      });
  }

  handleSave() {
    if (this.saveModal instanceof HTMLDialogElement) {
      this.saveModal.showModal();
    }
  }

  openCartDrawer() {
    this.modal.unbindBack();
    history.back();
    window.location.href = '/cart';
  }

  async initCompanions() {
    const sku = this.modal.selectedVehicle.sku + this.modal.selectedProduct.sku;
    const url = `${BASE_URL}/api/vehicles/${sku}/products`;
    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        this.mmyProduct = data;
        this.companions = data.companions;
        this.mainImage.src =
          data.detail?.customizer_image_url || data.detail?.images?.sort(imageOrder)?.at(0)?.url || '#';
        this.renderCompanions();
      })
      .catch((e) => {
        console.log(e);
        window.location.href = CustomizerStep3.CLOSE_REDIRECT_PATH;
      });
  }

  renderCompanions() {
    const formValues = serializeForm(this.form);
    const primaryOptions = this.getPrimaryOptions();
    let allSecondaryOptions = this.getAllSecondaryOptions();
    const groupTemplate = this.getCompanionGroupTemplate();
    const companionCardTemplate = groupTemplate.querySelector('.companion-card').cloneNode(true);
    const groupHelpTemplate = groupTemplate.querySelector('a:last-of-type').cloneNode(true);

    this.companionGroupsContainer.innerHTML = '';

    const renderGroup = (group, index, resolveTitle) => {
      const companionSku = formValues[group.key];
      const groupElement = groupTemplate.firstElementChild.cloneNode(true);
      groupElement.dataset.key = group.key;
      const groupTitle = groupElement.querySelector('header h5');
      const groupDescription = groupElement.querySelector('header p');

      const cardsContainer = groupElement.querySelector('.companion-cards-container');
      groupElement.querySelector('header').addEventListener('click', () => {
        cardsContainer.classList.toggle('!flex');
        this.openedGroups.has(group.key) ? this.openedGroups.delete(group.key) : this.openedGroups.add(group.key);
      });

      if (group.key === 'center_options_primary' && !this.initialized) {
        this.initialized = true;
        cardsContainer.classList.add('!flex');
      }

      if (this.openedGroups.has(group.key)) {
        cardsContainer.classList.add('!flex');
      }

      groupTitle.textContent = group.label;
      groupDescription.textContent = `Choose ${group.label}`;

      cardsContainer.innerHTML = '';
      if (group.companions.length === 1 && group.companions.some((c) => c.detail?.default_option)) {
        groupElement.style.display = 'none';
      }

      group.companions.forEach((companion) => {
        const companionCard = companionCardTemplate.cloneNode(true);
        const companionCardInput = companionCard.querySelector('input[type="checkbox"]');
        const companionCardImage = companionCard.querySelector('img');
        const companionCardTitle = companionCard.querySelector('p.item-title');
        const companionCardPrice = companionCard.querySelector('p.item-price');
        const companionCardCompareAtPrice = companionCard.querySelector('p.compare-at-price');

        companionCardInput.value = companion.sku;
        companionCardInput.name = group.key;
        companionCardInput.type = 'checkbox';
        if (Object.keys(formValues).length) {
          companionCardInput.checked = formValues[group.key] === companion.sku;
        } else {
          // Default selection if no option is selected and form is empty
          companionCardInput.checked = this.saved.skus.includes(companion.sku);
        }
        companionCardImage.src =
          companion.detail?.customizer_selection_image_url ||
          [...(companion.detail?.images || [])].shift()?.url ||
          companion.detail?.customizer_image_url ||
          '#';
        companionCardImage.dataset.customizerImage = companion.detail?.customizer_image_url || '';
        companionCardTitle.textContent = resolveTitle(companion);
        companionCard.dataset.name = companionCardTitle.textContent;
        companionCardPrice.textContent = formatCurrency(companion.detail?.price) || 'N/A';
        if (companion.detail?.compare_at_price && Number(companion.detail?.compare_at_price) > Number(companion.detail?.price)) {
          companionCardCompareAtPrice.textContent = formatCurrency(companion.detail?.compare_at_price) || 'N/A';
        } else {
          companionCardCompareAtPrice.remove();
        }

        const cardWrapper = document.createElement('div');
        cardWrapper.className = 'flex flex-col w-full gap-2';
        if (companionCardTitle.textContent === 'Custom Text') {
          if (this.customTextImgUrl) {
            companionCardImage.dataset.customizerImage = this.customTextImgUrl || '';
          }
          const customTextInput = document.createElement('input');
          customTextInput.required = companionCardInput.checked;
          customTextInput.placeholder = 'Enter Text (9 characters max)';
          customTextInput.classList.add('form-input');
          customTextInput.classList.toggle('hidden', !companionCardInput.checked);
          customTextInput.name = 'custom_text';
          customTextInput.maxLength = 9;
          customTextInput.enterKeyHint = 'Go';
          customTextInput.value = formValues['custom_text'] || this.modal.meta?.custom_text || '';

          customTextInput.addEventListener('keydown', (event) => {
            // if (this.loadingImages) {
            //   event.preventDefault();
            //   event.stopImmediatePropagation();
            //   return;
            // }
            if (event.key === 'Enter') {
              event.preventDefault();
              event.stopImmediatePropagation();
              this.canvas.scrollIntoViewIfNeeded();
              customTextInput.blur();
            }
          });

          customTextInput.addEventListener('input', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            const whitelistRegex = /^[a-zA-Z0-9\s]*$/;

            if (!whitelistRegex.test(event.target.value)) {
              // Strip out invalid characters immediately
              event.target.value = event.target.value.replace(/[^a-zA-Z0-9\s]/g, '');
            }

            this.handleCustomTextChange(event.target, companionCardImage, companion.detail?.customizer_image_url);
          });

          cardWrapper.appendChild(companionCard);
          cardWrapper.appendChild(customTextInput);
        } else {
          cardWrapper.appendChild(companionCard);
        }

        // Prevent duplicate
        if (
          cardsContainer.querySelector(`.product-companion-card[data-name='${companionCard.dataset.name}']`) === null
        ) {
          cardsContainer.appendChild(cardWrapper);
        }
        // cardsContainer.appendChild(cardWrapper);
      });

      this.companionGroupsContainer.appendChild(groupElement);
      // cardsContainer.appendChild(groupHelpTemplate.cloneNode(true));

      // Open group if there is selection other than default
      const checkedValue = cardsContainer.querySelector('input[type="checkbox"]:checked')?.value;
      if (Object.keys(formValues).length === 0 && checkedValue) {
        cardsContainer.classList.add('!flex');
      }

      // Default selection if no option is already checked in the group
      // const defaultValue = group.companions.find((c) => c.detail?.default_option)?.sku;
      // if (!checkedValue && defaultValue) {
      //   const defaultOption = cardsContainer.querySelector(`input[value="${defaultValue}"]`);
      //   if (defaultOption) {
      //     defaultOption.checked = true;
      //     this.handleChange({ target: defaultOption, skipRender: true });
      //   }
      // }
    };

    primaryOptions.forEach((group, index) => {
      renderGroup(group, index, (companion) => companion.detail?.selection1_text || companion.selection1 || 'N/A');
      const companionSku = serializeForm(this.form)[group.key];

      if (companionSku) {
        const primaryCompanion = this.companions.find((companion) => companion.sku === companionSku);
        const secondaryOptions = this.getSecondaryOptions(primaryCompanion);
        secondaryOptions.forEach((group, secIndex) => {
          if (group.companions.length) {
            renderGroup(
              group,
              secIndex,
              (companion) => companion.detail?.selection2_text || companion.selection2 || 'N/A',
            );
            this.selectDefaultOptions(secondaryOptions);
          }
        });
        allSecondaryOptions = allSecondaryOptions.filter((g) => !secondaryOptions.some((s) => s.key === g.key));
      }
    });
    allSecondaryOptions.forEach((group, index) => {
      renderGroup(group, index, (companion) => companion.detail?.selection2_text || companion.selection2 || 'N/A');
    });
    this.selectDefaultOptions(allSecondaryOptions);

    // Store opened groups
    Array.from(this.companionGroupsContainer.children).forEach((group, i) => {
      const cardsContainer = group.querySelector('.companion-cards-container');
      if (cardsContainer.classList.contains('!flex')) {
        this.openedGroups.add(group.dataset.key);
      }
      // const companionSku = formValues[group.querySelector('input').name];
      // // Open first group or has selected companion or previosly opened
      // if (i === 0 || companionSku || this.openedGroups.has(i)) {
      //   cardsContainer.classList.add('!flex');
      //   this.openedGroups.add(i);
      // }
    });

    // this.selectStandardCenterOptionByDefault(primaryOptions);
    this.selectDefaultOptions(primaryOptions);

    this.renderOverlay();
    // subtotal drawer
    this.renderDrawer();
    this.submitButton.disabled = !this.form.checkValidity();
  }

  selectDefaultOptions(options) {
    const formValues = Object.fromEntries(new FormData(this.form));
    // if (Object.keys(formValues).length) {
    //   return;
    // }

    options.forEach((group) => {
      const companion = group.companions.find((c) => c.detail?.default_option);
      if (companion) {
        const input = this.form.querySelector(`input[value="${companion.sku}"]`);

        if (input && formValues[input.name]) {
          return;
        }
        // const groupContainer = input?.closest(`[data-key="${group.key}"]`);
        // if (input && groupContainer) {
        if (input) {
          // if (group.companions.length < 2) {
          //   groupContainer.style.display = 'none';
          // }
          input.checked = true;
          this.handleChange({ target: input, skipRender: false });
        }
      }
    });
  }

  selectStandardCenterOptionByDefault(options) {
    const formValues = Object.fromEntries(new FormData(this.form));
    if (Object.keys(formValues).length) {
      return;
    }
    const centerOptions = options.find((option) => option.key === 'center_options_primary');
    if (centerOptions) {
      const companion = centerOptions.companions.find((c) => c.selection1 === 'STANDARD');
      if (companion) {
        const input = this.form.querySelector(`input[value="${companion.sku}"]`);
        const card = input?.closest('.companion-card');
        if (input && card) {
          const img = card.querySelector('img');
          img.src = img.dataset.customizerImage;
          // input.checked = true;
          // this.handleChange({ target: input, skipRender: true });
          card?.click();
        }
      }
    }
  }

  renderDrawer() {
    const {
      subtotalAmount,
      subtotalCount,
      customizationItemsContainer,
      productImage,
      productName,
      productPrice,
      customizationCount,
      getCustomizationItemElements,
    } = this.drawerElements;

    this.selectedCompanions = this.companions.filter(
      ({ sku }) => this.form.querySelector(`input[value="${sku}"]`)?.checked,
    );

    // drawer product
    productImage.src = this.mmyProduct?.detail?.images?.sort(imageOrder)?.at(0)?.url || '#';
    productName.textContent = this.mmyProduct?.detail?.title || 'N/A';
    productPrice.textContent = formatCurrency(this.mmyProduct?.detail?.price) || 'N/A';

    // update subtotal
    subtotalCount.textContent = this.selectedCompanions.length + 1;
    subtotalAmount.textContent = formatCurrency(
      this.selectedCompanions.reduce(
        (acc, companion) => acc + Number(companion.detail?.price || 0),
        Number(this.mmyProduct?.detail?.price) || 0,
      ),
    );

    // render customization items
    customizationItemsContainer.innerHTML = '';
    customizationCount.textContent = this.selectedCompanions.length;
    this.selectedCompanions.forEach((companion) => {
      const { customizationItem, itemImage, itemTitle, itemDescription, itemPrice, compareAtPrice } =
        getCustomizationItemElements(companion);

      itemImage.src =
        companion.detail?.customizer_selection_image_url ||
        [...(companion.detail?.images || [])].shift()?.url ||
        companion.detail?.customizer_image_url ||
        '#';

      itemDescription.textContent = companion.companion;
      // itemTitle.textContent = companion.detail?.selection1_text || companion.selection1 || 'N/A';
      itemTitle.textContent = companion.detail?.title || 'N/A';
      if (itemDescription.textContent !== itemTitle.textContent) {
        itemTitle.textContent = itemTitle.textContent.replace(itemDescription.textContent, '');
      }
      // console.log(companion.detail, companion, itemDescription.textContent)
      itemPrice.textContent = formatCurrency(companion.detail?.price) || 'N/A';
      if (compareAtPrice) {
        if (companion.detail?.compare_at_price && companion.detail?.compare_at_price > companion.detail?.price) {
          compareAtPrice.textContent = formatCurrency(companion.detail?.compare_at_price) || 'N/A';
        } else {
          compareAtPrice.remove();
        }
      }
      customizationItemsContainer.appendChild(customizationItem);
    });
  }

  getDrawerElements() {
    // subtotal drawer
    const drawer = document.querySelector('.subtotal-drawer');
    const drawerBackdrop = document.querySelector('.subtotal-backdrop');
    const drawerToggler = drawer.querySelector('button');
    const subtotalCount = drawer.querySelector('.subtotal-count');
    const subtotalAmount = drawer.querySelector('.subtotal-amount');
    const customizationCount = drawer.querySelector('.customization-count');
    const drawerContent = drawer.querySelector('.subtotal-content');
    const drawerProduct = drawer.querySelector('.subtotal-drawer-product');
    const productImage = drawerProduct.querySelector('img');
    const productName = drawerProduct.querySelector('h3>a');
    const productPrice = drawerProduct.querySelector('p:last-of-type');
    const customizationItemsContainer = drawer.querySelector('.customization-items-container');
    const customizationItemTemplate = customizationItemsContainer
      .querySelector('.customization-item-template')
      .content.cloneNode(true)
      .querySelector('.customization-item');
    return {
      drawer,
      drawerBackdrop,
      drawerToggler,
      subtotalCount,
      subtotalAmount,
      drawerContent,
      drawerProduct,
      productImage,
      productName,
      productPrice,
      customizationItemsContainer,
      customizationCount,
      getCustomizationItemElements: () => {
        const customizationItem = customizationItemTemplate.cloneNode(true);
        const itemImage = customizationItem.querySelector('img');
        const itemTitle = customizationItem.querySelector('h4');
        const itemDescription = customizationItem.querySelector('.item-description');
        const itemPrice = customizationItem.querySelector('.item-price');
        const compareAtPrice = customizationItem.querySelector('.compare-at-price');
        return { customizationItem, itemImage, itemTitle, itemDescription, itemPrice, compareAtPrice };
      },
    };
  }

  getCompanionGroupTemplate() {
    const template = document.getElementById('companion-group-template');
    if (template instanceof HTMLTemplateElement) {
      const node = template.content.cloneNode(true);
      if (node instanceof DocumentFragment) {
        return node;
      }
      throw new Error('Failed to clone companion group template');
    }
    throw new Error('Missing companion group template');
  }

  getPrimaryOptions() {
    if (!this.companions) {
      return [];
    }
    const mappings = this.companions.reduce((acc, companion) => {
      const key = companion.companion;
      const value = companion.detail?.selection1_text || companion.selection1;
      if (companion.selection2.toLowerCase() !== 'none') {
        return acc;
      }

      return {
        ...acc,
        [key]: Array.from(new Set([...(acc[key] || []), value])).filter((v) => v.toLowerCase() !== 'none'),
      };
    }, {});

    const order = [
      'Center Options',
      'Wing Options',
      'Mid Protection Options',
      'Full Protection Options',
      'Clevis Mounts Options',
    ];

    const primaryOptions = Object.entries(mappings)
      .map(([key, options]) => {
        return {
          key: snakeCase(key + this.PRIMARY_SUFFIX),
          options,
          companions: this.companions
            .filter((companion) => companion.companion === key)
            .filter(({ detail, selection1 }) => options.includes(detail.selection1_text || selection1))
            .filter(({ selection2 }) => selection2.toLowerCase() === 'none')
            .filter(({ detail, selection1 }, i, a) => {
              const index = a.findIndex(
                (t) => (t.detail?.selection1_text || t.selection1) === (detail?.selection1_text || selection1),
              );
              return index === i;
            })
            .sort((a, b) => a.sku.localeCompare(b.sku)),
          label: key,
          id: slugify(key + this.PRIMARY_SUFFIX),
        };
      })
      // Filter out (do not include) those which has no option or has only one option which is either "Standard" or "Included"
      .filter(
        ({ options, companions }) =>
          options.length > 1 ||
          companions.some((c) => c.detail?.default_option) ||
          (!options.map((o) => o.toLowerCase()).includes('standard') &&
            !options.map((o) => o.toLowerCase()).includes('included')),
      )
      // .filter(({ options }) => options.length > 0)
      .sort((a, b) => Math.abs(order.indexOf(a.label)) - Math.abs(order.indexOf(b.label)));

    const protectionOptions = primaryOptions.filter(({ key }) => key.includes('protection_options')).reverse();

    if (protectionOptions.length === 2) {
      protectionOptions.forEach((option) => {
        primaryOptions.splice(primaryOptions.indexOf(option), 1);
      });
      const protectionOption = {
        key: 'protection_options',
        id: 'protection-options',
        label: 'Protection Options',
        companions: protectionOptions.reduce((acc, option) => {
          return [...acc, ...option.companions];
        }, []),
        options: protectionOptions.reduce((acc, option) => {
          return [...acc, ...option.options];
        }, []),
      };
      primaryOptions.push(protectionOption);
    }

    return primaryOptions.sort((a, b) => Math.abs(order.indexOf(a.label)) - Math.abs(order.indexOf(b.label)));
  }

  getAllSecondaryOptions() {
    if (!this.companions) {
      return [];
    }
    const mappings = this.companions.reduce((acc, companion) => {
      const key = companion.companion;
      const primarySelection = companion.detail?.selection1_text || companion.selection1;
      const value = companion.detail?.selection2_text || companion.selection2;
      if (primarySelection === (companion.detail?.selection1_text || companion.selection1) && value) {
        return {
          ...acc,
          [key]: Array.from(new Set([...(acc[key] || []), value])).filter((v) => v.toLowerCase() !== 'none'),
        };
      }
      return acc;
    }, {});

    return Object.entries(mappings)
      .map(([key, options]) => {
        return {
          key: snakeCase(key + this.SECONDARY_SUFFIX),
          options,
          companions: this.companions
            .filter((companion) => companion.companion === key)
            .filter(({ selection2, detail, companion }) => {
              const value = detail.selection2_text || selection2;
              return options.includes(value) && companion === key;
            })
            .sort((a, b) => a.sku.localeCompare(b.sku)),
          label: 'Secondary ' + key,
          id: slugify(key + this.SECONDARY_SUFFIX),
        };
      })
      .filter(({ options }) => options.length > 0)
      .filter(
        ({ options, companions }) =>
          options.length > 1 ||
          companions.some((c) => c.detail?.default_option) ||
          (!options.map((o) => o.toLowerCase()).includes('standard') &&
            !options.map((o) => o.toLowerCase()).includes('included')),
      );
  }

  getSecondaryOptions(primaryCompanion) {
    if (!this.companions) {
      return [];
    }
    const mappings = this.companions.reduce((acc, companion) => {
      const key = companion.companion;
      const field = snakeCase(key + this.PRIMARY_SUFFIX);
      const primarySelection = companion.detail?.selection1_text || companion.selection1;
      const value = companion.detail?.selection2_text || companion.selection2;
      // console.log(selectedPrimary, primarySelection, value);
      if (
        key === primaryCompanion.companion &&
        primarySelection === (companion.detail?.selection1_text || companion.selection1) &&
        value
      ) {
        return {
          ...acc,
          [key]: Array.from(new Set([...(acc[key] || []), value])).filter((v) => v.toLowerCase() !== 'none'),
        };
      }
      return acc;
    }, {});

    return (
      Object.entries(mappings)
        .map(([key, options]) => {
          return {
            key: snakeCase(key + this.SECONDARY_SUFFIX),
            options,
            companions: this.companions
              .filter((companion) => companion.companion === key)
              .filter(({ selection2, selection1, detail }) => {
                return (
                  options.includes(detail.selection2_text || selection2) &&
                  (detail.selection1_text || selection1) ===
                    (primaryCompanion.detail?.selection1_text || primaryCompanion.selection1)
                );
              })
              .sort((a, b) => a.sku.localeCompare(b.sku)),
            label: 'Secondary ' + key,
            id: slugify(key + this.SECONDARY_SUFFIX),
          };
        })
        // .filter(({ options }) => options.length > 0)
        .filter(
          ({ options, companions }) =>
            options.length > 1 ||
            companions.some((c) => c.detail?.default_option) ||
            (!options.map((o) => o.toLowerCase()).includes('standard') &&
              !options.map((o) => o.toLowerCase()).includes('included')),
        )
    );
  }

  getModal() {
    const modal = this.closest('customizer-modal');
    if (modal instanceof CustomizerModal) {
      return modal;
    }
    throw new Error('Missing modal');
  }

  renderImageOnCanvas(overlayImage) {
    const canvasWidth = this.canvas.clientWidth;
    const canvasHeight = this.canvas.clientHeight;

    const imgWidth = overlayImage.width;
    const imgHeight = overlayImage.height;

    // Compute aspect ratios
    const canvasRatio = canvasWidth / canvasHeight;
    const imgRatio = imgWidth / imgHeight;

    let drawWidth, drawHeight;

    if (imgRatio > canvasRatio) {
      // Image is wider → fit width
      drawWidth = canvasWidth;
      drawHeight = canvasWidth / imgRatio;
    } else {
      // Image is taller → fit height
      drawHeight = canvasHeight;
      drawWidth = canvasHeight * imgRatio;
    }

    const dx = (canvasWidth - drawWidth) / 2;
    const dy = (canvasHeight - drawHeight) / 2;
    // this.context.drawImage(overlayImage, x, y, overlayImage.width, overlayImage.height);
    this.context.drawImage(overlayImage, dx, dy, drawWidth, drawHeight);
  }

  renderSelectedImages() {
    const pickOneOfType = [];
    const selectedImages = Array.from(this.companionGroupsContainer.querySelectorAll('input:checked'))
      .reduce((acc, checkbox) => {
        const name = checkbox.name.replace(/_primary|_secondary/gi, '').toLowerCase();
        if (pickOneOfType.includes(name)) {
          return [...acc.filter((c) => !c.name.toLowerCase().includes(name)), checkbox];
        }
        pickOneOfType.push(name);
        return [...acc, checkbox];
      }, [])
      .map((checkbox) => this.loadedImages.find((image) => image.dataset.sku === checkbox.value))
      .filter(Boolean);
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    selectedImages.forEach((image) => {
      this.renderImageOnCanvas(image);
    });
  }

  showLoader() {
    this.loadingImages = true;
    this.customizerLoader.classList.remove('hidden');
    this.customizerLoader.classList.add('grid');
  }

  hideLoader() {
    this.loadingImages = false;
    this.customizerLoader.classList.add('hidden');
    this.customizerLoader.classList.remove('grid');
  }

  loadImage(image) {
    return new Promise((resolve, reject) => {
      if (image instanceof HTMLImageElement) {
        if (image.complete) {
          resolve(image);
          return;
        } else {
          image.onload = () => {
            resolve(image);
          };
        }
        image.onerror = (e) => {
          reject(e);
        };
      }
    });
  }

  get customTextInput() {
    const input = this.querySelector('input[name="custom_text"]');
    if (input instanceof HTMLInputElement) {
      return input;
    }
    return null;
  }

  generateOverlayImg(img) {
    const overlayImage = document.createElement('img');
    overlayImage.setAttribute('crossorigin', 'anonymous'); // exporting
    overlayImage.src = img.dataset.customizerImage;
    overlayImage.dataset.sku = img.closest('label').querySelector('input').value;
    return overlayImage;
  }

  appendOverlayImages() {
    for (const image of this.overlayImages) {
      const overlayImage = this.overlayImageContainer.querySelector(`img[data-sku="${image.dataset.sku}"]`);
      if (!overlayImage) {
        this.overlayImageContainer.appendChild(image);
      } else if (overlayImage.src !== image.src) {
        overlayImage.remove();
        this.overlayImageContainer.appendChild(image);
      }
    }
  }

  async loadOverlayImages() {
    // console.log(this.loadedImages.find((image) => image.dataset.sku === '2123XG')?.src, '2123XG');
    this.overlayImages = [];
    this.failedImages = this.failedImages || [];
    this.overlayImages.push(this.mainImage);
    const candidateImages = Array.from(this.companionGroupsContainer.querySelectorAll('img'));
    for (const img of candidateImages) {
      if (!img.dataset.customizerImage) {
        continue;
      }
      if (this.loadedImages.some((loadedImage) => loadedImage.src === img.dataset.customizerImage)) {
        continue;
      }
      if (this.failedImages.some((failedImage) => failedImage.src === img.dataset.customizerImage)) {
        continue;
      }
      const overlayImage = this.generateOverlayImg(img);
      this.overlayImages.push(overlayImage);
    }

    const results = await Promise.allSettled(
      this.overlayImages.map((overlayImage) => {
        return this.loadImage(overlayImage);
      }),
    );

    results.forEach(({ status, value, reason }) => {
      if (status === 'fulfilled') {
        const overlayImage = value;
        this.loadedImages = this.loadedImages.filter((image) => image.dataset.sku !== overlayImage.dataset.sku);
        this.loadedImages.push(overlayImage);
      } else {
        const overlayImage = reason?.target;
        if (overlayImage) {
          console.log(overlayImage, overlayImage.src, 'failed to load overlay image');
          this.failedImages.push(overlayImage.cloneNode());
          overlayImage.remove();
        }
      }
    });
    return this.loadedImages;
  }

  async renderOverlay() {
    try {
      this.showLoader();
      if (!this.context) {
        this.context = this.setupHiResCanvas(this.canvas, this.canvas.clientWidth, this.canvas.clientHeight);
      }
      await this.loadOverlayImages();
      this.renderSelectedImages();
    } finally {
      this.hideLoader();
    }
  }

  handleCustomTextChange(input, companionCardImage, defaultImageUrl) {
    this.submitButton.disabled = !this.form.checkValidity();
    if (!this.modal.meta) {
      this.modal.meta = { custom_text: '' };
    }
    const customText = input.value.trim();
    // console.log(customText, 'this is the custom text');
    this.modal.meta.custom_text = customText;
    if (customText) {
      const url = `${window.routes.api_base_uri}/api/custom-text/${this.modal.selectedProduct.sku}/${customText}`;
      this.customTextImgUrl = url;
      companionCardImage.dataset.customizerImage = url;
    } else {
      this.customTextImgUrl = null;
      companionCardImage.dataset.customizerImage = defaultImageUrl;
    }
    this.renderOverlay();
  }

  handleChange({ target, skipRender = false }) {
    // const div = document.createElement('div');
    // div.className = 'absolute inset-0 flex items-center justify-center';
    // div.dataset.sku = target.value;
    // div.dataset.name = target.name;
    // const overlayImage = document.createElement('img');
    // overlayImage.src = target.parentElement.querySelector('img').dataset.customizerImage;
    // div.appendChild(overlayImage);

    // if (this.overlayStack.some((el) => el.dataset.sku === target.value)) {
    //   this.overlayImageContainer.removeChild(this.overlayStack.find((el) => el.dataset.sku === target.value));
    //   this.overlayStack = this.overlayStack.filter((el) => el.dataset.sku !== target.value);
    // } else {
    //   if (this.overlayStack.some((el) => el.dataset.name === target.name)) {
    //     this.overlayImageContainer.removeChild(this.overlayStack.find((el) => el.dataset.name === target.name));
    //     this.overlayStack = this.overlayStack.filter((el) => el.dataset.name !== target.name);
    //   }
    //   this.overlayImageContainer.appendChild(div);
    //   this.overlayStack.push(div);
    // }

    // if (this.overlayStack.some((el) => el.dataset.name === target.name)) {
    //   this.overlayImageContainer.removeChild(this.overlayStack.find((el) => el.dataset.name === target.name));
    //   this.overlayStack = this.overlayStack.filter((el) => el.dataset.name !== target.name);
    // } else {
    //   this.overlayImageContainer.appendChild(div);
    //   this.overlayStack.push(div);
    // }
    if (target.type === 'checkbox') {
      actAsRadio(target);
    }
    const valid = this.form.checkValidity();
    this.submitButton.disabled = !valid;
    if (target.name === 'center_options_primary') {
      this.customTextImgUrl = null;
      if (this.modal.meta?.custom_text) {
        this.modal.meta.custom_text = null;
      }
    }

    if (!skipRender) {
      this.renderCompanions();
    } else {
      this.renderOverlay();
      this.renderDrawer();
    }
  }

  get shouldUseCustomText() {
    return this.customTextInput && this.customTextInput.parentElement.querySelector('input[type=checkbox]')?.checked;
  }

  initSave() {
    const bumper_location = localStorage.getItem('bumper_location');
    if (bumper_location) {
      // this.saved = { bumper_location };
      // this.form.elements.bumper_location.value = bumper_location;
      // this.handleChange({ target: this.form.elements.bumper_location });
    }
  }

  flush() {
    this.form.reset();
    this.modal.selectedProduct = null;
    this.modal.selectedCompanions = [];
    localStorage.removeItem('product');
    localStorage.removeItem('companions');
  }

  async clearCart() {
    const url = `${Shopify.routes.root}cart/clear.js`;
    return fetch(url, {
      method: 'POST',
    }).then(async (resp) => {
      if (resp.ok) {
        const data = await resp.json();
        window.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: data,
          }),
        );
      }
    });
  }

  showAddedToCartModal() {
    this.addedToCartModal.classList.remove('hidden');
    this.addedToCartModal.classList.add('md:flex');
    const loadSection = async () => {
      const html = await fetch(Shopify.routes.root + 'cart?section_id=added-to-cart-modal').then((resp) => resp.text());
      const dom = new DOMParser().parseFromString(html, 'text/html');
      this.addedToCartModal.innerHTML = dom.querySelector(`#${this.addedToCartModal.id}`).innerHTML;
      this.viewCartButton = document.querySelector('.view-cart');
      this.viewCartButton.addEventListener('click', this.openCartDrawer.bind(this));
      this.addedToCartModal
        .querySelector('button[data-toggle="modal"][data-target="#added-to-cart-modal"]')
        .addEventListener('click', this.hideAddedToCartModal.bind(this));
    };
    loadSection();
  }

  hideAddedToCartModal() {
    this.addedToCartModal.classList.add('hidden');
    this.addedToCartModal.classList.remove('md:flex');
    this.modal.close(null, true);
  }

  async uploadFile(dataUrl) {
    const formData = new FormData();
    formData.append('file', dataURIToBlob(dataUrl), 'customizer-image.png');
    const url = `${BASE_URL}/api/files`;
    const response = await fetch(url, {
      method: 'POST',
      body: formData,
    });
    return response.json();
  }

  async handleSubmit(e) {
    e.preventDefault();
    this.submitButton.disabled = true;
    this.submitButton.classList.add('loading');
    const url = `${Shopify.routes.root}cart/add.js`;
    const [fileUrl] = await this.uploadFile(this.canvas.toDataURL('image/png'));

    const formData = {
      items: [
        {
          id: Number(this.modal.selectedProduct.detail?.shopify_variant_id),
          quantity: 1,
          properties: {
            Make: this.modal.selectedVehicle.make,
            Model: this.modal.selectedVehicle.model,
            Year: this.modal.selectedVehicle.year,
            _mmy: ['make', 'model', 'year'].map((key) => this.modal.selectedVehicle[key]).join(' '),
            ...this.selectedCompanions.reduce((acc, companion, index) => {
              acc[`_companion_${index + 1}`] = companion.detail?.title;
              return acc;
            }, {}),
            _companion_order: this.selectedCompanions.map(({ detail }) => detail?.title).join(','),
            _customizer_image: fileUrl,
            _vehicle: ['make', 'model', 'year'].map((key) => this.modal.selectedVehicle[key]).join(' '),
            _companions: JSON.stringify(this.selectedCompanions),
            _title: this.modal.selectedProduct.detail?.title?.replace(/\s+kit/gi, ''),
            _merchandise_id: this.modal.selectedProduct.detail?.shopify_variant_id,
            _expanded_items: this.selectedCompanions
              .map(({ detail }) => 'gid://shopify/ProductVariant/' + detail.shopify_variant_id)
              .join(','),
            _expanded_items_price: this.selectedCompanions.map(({ detail }) => detail.price).join(','),
            _companion_names: this.selectedCompanions.map(({ companion }) => companion || '').join(','),
            _companion_images: [
              this.modal.selectedProduct.detail?.images?.sort(imageOrder)?.at(0)?.url ||
                this.modal.selectedProduct?.images?.sort(imageOrder)?.at(0)?.url ||
                '',
            ]
              .concat(
                this.selectedCompanions.map(
                  ({ detail: { customizer_image_url, images } }) =>
                    images?.sort(imageOrder)?.at(0)?.url || customizer_image_url || '',
                ),
              )
              .join(','),
            _companion_selection: this.selectedCompanions
              .map(({ selection1, selection2 }) => `${selection1}|${selection2}`)
              .join(','),
            _companion_selection_text: this.selectedCompanions
              .map(({ detail: { selection1_text, selection2_text } }) => `${selection1_text}|${selection2_text}`)
              .join(','),
            _requires_welding: (
              this.modal.selectedProduct.fabrication === 'Weld It Yourself' ||
              this.modal.selectedProduct.tags.includes('WELD')
            ).toString(),
            _custom_text: this.shouldUseCustomText ? this.modal.meta?.custom_text || '' : '',
            _version: 'V2',
            _V2: true,
          },
        },
        // ...this.selectedCompanions
        //   .map(({ detail: { shopify_variant_id } }) => shopify_variant_id)
        //   .map((id) => ({
        //     id: Number(id),
        //     quantity: 1,
        //     properties: {
        //       _parent_variant_id: this.modal.selectedProduct.detail?.shopify_variant_id,
        //     },
        //   })),
      ],
    };

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        window.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: data,
          }),
        );
        if (data.items) {
          this.showAddedToCartModal();
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('loading');
      });
  }
}
if (!customElements.get('customizer-step3')) {
  customElements.define('customizer-step3', CustomizerStep3);
}

class CustomizerStep2 extends HTMLElement {
  static RESET_FILTER_LOCATION = '/collections/move-bumpers';
  constructor() {
    super();
    this._internals = this.attachInternals();
    this.saved = {
      product_id: '',
    };
    this.modal = this.getModal();
    this.products = [];
    this.selectedProduct = null;
    this.filters = {};
    this.filtersMeta = null;
    this.productsCancelToken = null;
    this.filtersCancelToken = null;
    this.loaded = false;
    this.loadingProducts = false;
    this.initSave();
    this.filterGroupVisiblityState = {};
  }

  get notInModal() {
    return !this.closest('customizer-modal');
  }

  get inModal() {
    return !this.notInModal;
  }
  get collectionTitle() {
    return this.dataset.collectionTitle;
  }

  get productIds() {
    return this.dataset.productIds.split(',').filter(Boolean);
  }

  setHeadings() {
    const h4 = this.querySelector('h4');
    const h3 = this.querySelector('h3');
    if (this.collectionTitle.match(/products/gi)) {
      h4.classList.remove('hidden');
      h3.innerHTML = 'Select your kit';
    } else {
      if (this.notInModal) {
        h4.classList.add('hidden');
        h3.innerHTML = this.collectionTitle;
      } else {
        h4.classList.remove('hidden');
        h3.innerHTML = 'Select your kit';
      }
    }
  }

  connectedCallback() {
    let template = null;
    this.setHeadings();
    this.productsCountLabel = this.querySelector('#products-count-label');
    this.productDetailModal = document.getElementById('product-detail-modal');
    this.filtersModal = document.getElementById('filters-modal');
    this.helpModal = document.getElementById('help-modal');
    this.filtersSideContainer = document.getElementById('filters-side-container');
    this.filterTemplates = this.getFilterTemplates();
    this.productsContainer = this.querySelector('#products-container');
    this.productTemplate = this.getProductTemplate();
    this.loaderTemplate = this.getLoaderTemplate();
    this.productForm = this.getProductForm();
    this.submitButton = this.getSubmitButton();
    this.filterButton = this.querySelector('button.filter-button');
    this.modalFooter = this.querySelector('.modal-footer');
    this.modalHeader = this.querySelector('.modal-header');
    this.sortSelector = this.querySelector('#sort-selector');
    this.captureShopifyImages();
    // this.gridViewButton = document.getElementById('grid-view-button');
    // this.listViewButton = document.getElementById('list-view-button');
    document.querySelector('move-mmy')?.addEventListener('vehicles:loaded', async (event) => {
      if (!this.loaded && !this.loadingProducts && (await event.target.vehicleLoaded.promise)) {
        this.loadProducts();
      }
    });

    if (this.notInModal) {
      this.modalHeader.classList.add('hidden');
      this.modalFooter.classList.add('hidden');
    }

    if (this.vehicle) {
      this.loadProducts();
    } else {
      Promise.all([this.fetchFilters(), this.fetchFiltersMeta()])
        .then(() => {
          this.renderFilters();
        })
        .catch((err) => {
          console.log('catched', err);
        });
    }
    // this.fetchFiltersMeta().then(() => {
    // });

    // this.gridViewButton.addEventListener('click', this.gridView.bind(this));
    // this.listViewButton.addEventListener('click', this.listView.bind(this));
    this.filterButton.addEventListener('click', this.toggleFilters.bind(this));
    this.productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleSubmit();
    });
    this.modal?.addEventListener('modal:closed', this.flush.bind(this));

    this.productForm.addEventListener('input', (e) => {
      actAsRadio(e.target);
      this.saved.product_id = this.getFormData(this.productForm).product_id;

      // Emit event
      const product = this.products.find((product) => Number(product.id) === Number(this.saved.product_id));
      this.setSelectedProduct(product);

      if (this.submitButton) {
        this.submitButton.disabled = !this.saved.product_id || !this.vehicle;
      }
      const moveMmy = document.querySelector('move-mmy');
      if (moveMmy && !this.vehicle) {
        moveMmy.querySelector('select').focus();
      }
      if (this.saved.product_id && this.vehicle) {
        this.handleSubmit();
      }
    });

    this.sortSelector.addEventListener('change', this.handleSort.bind(this));
    document.addEventListener('vehicle:changed', (e) => {
      this.loadProducts();
    });
    this.addEventListener('products:loaded', this.renderRatings.bind(this));
    this.filterTemplates.form.querySelectorAll('button.reset-btn').forEach((ele) => {
      ele.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.target.form.reset();
        this.handleResetFilters();
      });
    });
    this.filterTemplates.form.addEventListener('submit', this.loadProducts.bind(this));
    this.filterTemplates.form.addEventListener('input', this.handleFilterChange.bind(this));
  }

  captureShopifyImages() {
    this.shopifyProductImageMap = {};
    this.productsContainer.querySelectorAll('.product-card-extended').forEach((card) => {
      const anchor = card.tagName === 'A' ? card : card.querySelector('a');
      const slug = anchor.href.split('/').pop();
      const img = anchor.querySelector('img') || anchor.closest('.product-card-extended').querySelector('img');
      if (slug && img) {
        this.shopifyProductImageMap[slug] = img.src;
      }
    });
  }

  handleFilterChange() {
    if (this.filterTemplates.form.querySelectorAll('input[type=checkbox]:checked').length === 0) {
      this.handleResetFilters();
      return;
    }
    this.loadProducts();
  }

  handleSort() {
    this.loadProducts();
  }

  setSelectedProduct(product) {
    // Set selected product in modal and component
    if (this.modal) {
      this.modal.selectedProduct = product || null;
    }
    this.selectedProduct = product || null;

    // Uncheck all product checkboxes
    this.productsContainer.querySelectorAll('input[type="checkbox"]').forEach((input) => (input.checked = false));

    // Select the product in HTML via checkbox
    if (product) {
      this.productsContainer.querySelector(`input[name="product_id"][value="${product.id}"]`).checked = true;
    }

    // Toggle submit button
    if (this.submitButton) {
      this.submitButton.disabled = !product;
    }

    // Scroll to the selected product card
    const card = this.productsContainer.querySelector('.product-card-extended:has(:checked)');
    if (card) {
      card.scrollIntoView({ behavior: 'instant' });
    }

    // Update saved product ID
    this.saved.product_id = product?.id;

    // Store selected product in localStorage
    localStorage.setItem('product', JSON.stringify(product || null));
    localStorage.setItem('product_id', product?.id || null);

    // Emit event
    this.dispatchEvent(new CustomEvent('product:changed', { detail: { product } }));
  }

  checkIfDetailsAsideShouldOpen() {
    if (!this.modal?.performedProductDetailOpenCheck) {
      const url = new URL(window.location.href);
      const params = Object.fromEntries(url.searchParams);
      if (params['view-detail'] === '1') {
        const productHandle = url.pathname.split('/').at(-1);
        const product = this.products.find((product) => product.detail?.shopify_handle === productHandle);
        this.setSelectedProduct(product);
        if (product && product.detail) {
          this.openProductModal(product);
        }
      }
      if (this.modal) {
        // console.log('flag set')
        this.modal.performedProductDetailOpenCheck = true;
      }
    }
  }

  toggleFilters() {
    this.filtersModal.classList.toggle('hidden');
    document.body.classList.toggle('overflow-hidden');
    this.renderFilters();
  }

  closeProductModal() {
    this.productDetailModal.classList.remove('md:flex');
    this.productDetailModal.classList.add('hidden');
  }

  closeHelpModal() {
    this.helpModal.classList.remove('md:flex');
    this.helpModal.classList.add('hidden');
  }

  initSave() {
    if (this.notInModal) {
      return;
    }
    const product_id = localStorage.getItem('product_id');
    if (product_id) {
      this.saved = { product_id };
    }
    if (this.modal) {
      this.selectedProduct = this.modal.selectedProduct || null;
    } else {
      this.selectedProduct = JSON.parse(localStorage.getItem('product')) || null;
    }
  }

  flush() {
    this.productForm.reset();
    if (this.submitButton) {
      this.submitButton.disabled = true;
    }
    // localStorage.removeItem('product_id');
  }

  handleSubmit() {
    if (this.submitButton) {
      this.submitButton.disabled = true;
    }
    const data = Object.fromEntries(new FormData(this.productForm));
    this.setSelectedProduct(this.products.find((product) => Number(product.id) === Number(data.product_id)));
    if (this.modal) {
      this.modal.selectedProduct = this.selectedProduct;
      this.modal.open(this.submitButton?.dataset?.section || 'move-customizer-step-3-new');
    }
  }

  gridView() {
    this.productsContainer.classList.toggle('grid-cols-1', false);
    this.productsContainer.classList.toggle('grid-cols-2', true);
    this.gridViewButton.classList.toggle('active', true);
    this.listViewButton.classList.toggle('active', false);
  }

  listView() {
    this.productsContainer.classList.toggle('grid-cols-1', true);
    this.productsContainer.classList.toggle('grid-cols-2', false);
    this.gridViewButton.classList.toggle('active', false);
    this.listViewButton.classList.toggle('active', true);
  }

  openFilterAside() {
    const filterAside = this.querySelector('#filter-aside');
    filterAside.classList.toggle('hidden');

    filterAside.classList.add('transform', '-translate-x-full');
    requestAnimationFrame(() => {
      filterAside.classList.add('transition-transform', 'duration-500', 'ease-in-out');
      filterAside.classList.remove('-translate-x-full');
      filterAside.classList.add('translate-x-0');
    });

    const backdrop = document.createElement('div');
    backdrop.classList.add('fixed', 'inset-0', 'bg-black', 'opacity-50', 'z-10');
    this.appendChild(backdrop);

    backdrop.addEventListener('click', () => {
      filterAside.classList.add('-translate-x-full');
      filterAside.classList.remove('translate-x-0');
      setTimeout(() => {
        filterAside.classList.add('hidden');
        backdrop.remove();
        filterAside.classList.remove(
          'transform',
          '-translate-x-full',
          'transition-transform',
          'duration-500',
          'ease-in-out',
          'translate-x-0',
        );
      }, 500);
    });
  }

  async determineReloading() {
    let formData = this.getFormData(this.getMainFilterForm());
    if (Object.keys(formData).length) {
      return false;
    }
    const path = window.location.pathname.split('/').at(-1).toLowerCase();
    const determinedParts = {};
    const pathParts = path.split('-');
    for (const [key, values] of Object.entries(this.filters)) {
      const value = values.find((v) => pathParts.includes(v.toLowerCase()));
      if (value) {
        determinedParts[key] = determinedParts[key] ? [...determinedParts[key], value] : [value];
      }
    }
    // console.log(determinedParts);
    Object.entries(determinedParts).map(([key, values]) => {
      const value = values
        .sort((a, b) => pathParts.indexOf(a.toLowerCase()) - pathParts.indexOf(b.toLowerCase()))
        .at(0);
      const partIndex = pathParts.indexOf(value.toLowerCase());
      if (value && partIndex > -1 && partIndex < 2) {
        this.getMainFilterForm().querySelector(`input[name="${key}[]"][value*="${value}"]`).checked = true;
      }
    });
    formData = this.getFormData(this.getMainFilterForm());

    if (Object.entries(formData).length) {
      return true;
    }
    return false;
  }

  async loadProducts() {
    this.showLoader();
    try {
      await Promise.all([this.fetchFilters(), this.fetchFiltersMeta()]);
      this.renderFilters();
      if (await this.determineReloading()) {
        this.loadProducts();
        return;
      }

      await this.fetchProducts();
      this.loaded = true;
    } catch (e) {
      this.loaded = false;
      console.log(e);
      return;
    }
    this.renderProducts();
    this.checkIfDetailsAsideShouldOpen();
    this.dispatchEvent(new CustomEvent('products:loaded'));
  }

  renderRatings() {
    if (window.hasOwnProperty('yotpoWidgetsContainer')) {
      if (window.hasOwnProperty('yotpo')) {
        yotpo.initWidgets();
      } else {
        yotpoWidgetsContainer.initWidgets();
      }
    }
  }

  async countProducts() {
    const submitBtn = this.filterForm.querySelector('button[type="submit"]');
    submitBtn.disabled = true;
    submitBtn.innerHTML = '';
    const svg = this.getLoader().querySelector('svg');
    submitBtn.appendChild(svg);
    await this.fetchProducts();
    submitBtn.innerHTML = `Apply ${this.products.length}`;
    submitBtn.disabled = false;
  }

  get vehicle() {
    return this.modal.selectedVehicle;
  }

  async getQuery() {
    const query = this.mapToParams(this.filterTemplates.form);
    if (this.vehicle || (await (document.querySelector('move-mmy')?.vehicleLoaded?.promise || Promise.resolve(true)))) {
      query.append('vehicle_sku', this.vehicle.sku);
    } else {
      window.addEventListener(
        'scroll',
        () => {
          if (!this.vehicle) {
            this.modal.open('move-customizer-step-1');
          }
        },
        { once: true },
      );
      const handleModalClosing = (e) => {
        e.preventDefault();
        window.location.href = '/';
      };
      this.modal.addEventListener('modal:closing', handleModalClosing);
      // throw Error('Vehicle is not selected');
    }
    if (this.sortSelector.value) {
      query.append('sort_column', this.sortSelector.value);
      query.append('sort_order', this.sortSelector.selectedOptions[0].dataset.order);
    }
    for (const [idx, value] of this.productIds.entries()) {
      query.set(`product_ids[${idx}]`, value);
    }
    return query;
  }

  async fetchProducts() {
    const query = await this.getQuery();
    const url = `${BASE_URL}/api/products?${query.toString()}`;
    if (this.productsCancelToken) {
      this.productsCancelToken.abort('New request');
    }
    this.productsCancelToken = new AbortController();
    this.loadingProducts = true;
    try {
      const response = await fetch(url, { signal: this.productsCancelToken.signal });
      this.products = await response.json();
    } finally {
      this.loadingProducts = false;
    }
  }

  showLoader() {
    this.productsContainer.classList.toggle('loading', true);

    // this.clearProductsContainer();
    // this.productsContainer.classList.toggle('h-full', true);
    // const loader = this.getLoader();
    // const svg = loader.querySelector('svg');
    // svg.classList.replace('w-6', 'w-20');
    // svg.classList.replace('h-6', 'h-20');
    // this.productsContainer.appendChild(loader);
  }

  clearProductsContainer() {
    this.productsContainer.classList.toggle('loading', false);
    this.productsContainer.classList.toggle('h-full', false);
    this.productsContainer.innerHTML = '';
  }

  openProductModal(product) {
    let template = null;
    if ((template = this.productDetailModal.querySelector('template'))) {
      this.productDetailModal.append(template.content.cloneNode(true));
      this.productDetailModal
        .querySelector('button[data-toggle="modal"][data-target="#product-detail-modal"]')
        .addEventListener('click', this.closeProductModal.bind(this));
      template.remove();
    }
    const modal = this.productDetailModal;
    modal.classList.remove('hidden');
    modal.classList.add('md:flex');
    modal.querySelector('img').src = product.images?.sort(imageOrder)?.at(0)?.url;
    modal.querySelector('h3').textContent = product.detail?.title || product.title;
    modal.querySelector('.price-amount-value').textContent = formatCurrency(product.detail?.price) || 'N/A';

    const description = document.createElement('div');
    description.innerHTML = product.detail?.collection_popout;
    const productDetailContainer = modal.querySelector('.product-detail-container');
    productDetailContainer.innerHTML = '';
    productDetailContainer.appendChild(description);

    if (!product.companions.find((comp) => comp.selection1 === 'WINCH')) {
      modal.querySelector('.winch-badge').classList.add('hidden');
    } else {
      modal.querySelector('.winch-badge').classList.remove('hidden');
    }

    if (product.detail?.compare_at_price > product.detail?.price) {
      modal.querySelector('.save-badge').classList.remove('hidden');
      modal.querySelector('.save-badge').textContent = `Save ${formatCurrency(
        product.detail?.compare_at_price - product.detail?.price,
      )}`;
    } else {
      modal.querySelector('.save-badge').classList.add('hidden');
    }

    requestAnimationFrame(() => {
      modal.querySelector('.overflow-y-auto').scrollTo(0, 0);
    });
    // console.log(product);
    // modal.querySelector('p').textContent = product?.detail?.description || product?.description;
  }

  renderProducts() {
    this.clearProductsContainer();
    this.productsCountLabel.innerHTML = this.productsCountLabel.innerHTML.replace(/\d+/, this.products.length);
    this.products.forEach((product) => {
      const productNode = this.getProduct();
      const productCard = productNode.querySelector('div.product-card-extended');
      const saveBadge = productCard.querySelector('.save-badge');
      const winchBadge = productCard.querySelector('.winch-badge');
      const priceContainer = productCard.querySelector('.price-container');
      const ratingsContainer = productCard.querySelector('.yotpo-widget-instance');
      ratingsContainer.dataset.yotpoProductId = String(product.detail.shopify_id);

      const [centerIcon, protectionIcon, lightIcon, winchIcon] = productCard.querySelectorAll('.prouct-feature-icon');

      priceContainer.querySelector('span:first-child').textContent = formatCurrency(product.detail?.compare_at_price);
      priceContainer.querySelector('span:last-child').textContent = formatCurrency(product.detail?.price);
      if (product.detail?.compare_at_price > product.detail?.price) {
        saveBadge.textContent = `Save ${formatCurrency(product.detail?.compare_at_price - product.detail?.price)}`;
      } else {
        priceContainer.querySelector('span:first-child').remove();
        saveBadge.remove();
      }
      if (product.companions.find((comp) => comp.selection1 === 'WINCH')) {
        winchBadge.textContent = 'winch capable';
      } else {
        winchBadge.remove();
      }

      [centerIcon, protectionIcon, lightIcon, winchIcon].forEach((icon) => {
        icon.querySelectorAll('ul li').forEach((li) => {
          const { keyword, path } = li.dataset;
          if (!product.companions.some((comp) => new RegExp(keyword, 'gi').test(comp[path]))) {
            li.remove();
          }
        });
        if (icon.querySelectorAll('ul li').length === 0) {
          icon.remove();
        }
      });

      const title = ['series', 'location', 'fabrication', 'material', 'package'].map((key) => product[key]).join(' ');
      const headingEle = productCard.querySelector('h3');
      headingEle.querySelector('span:first-child').innerHTML = product?.detail?.collection_title || title;
      headingEle.querySelector('span:last-child').innerHTML = product?.detail?.collection_subtitle || '&nbsp;';
      const checkbox = productCard.querySelector('input[type="checkbox"]');
      checkbox.value = product.id;
      checkbox.name = 'product_id';
      // if (this.inModal) {
      //   checkbox.checked = String(this.saved.product_id) === String(product.id);
      // }
      const viewDetailAnchor = productCard.querySelector('a.view-product-details');
      viewDetailAnchor.href = product.detail?.shopify_handle
        ? // ? `/products/${product.detail?.shopify_handle}?view-detail=1`
          `/products/${product.detail?.shopify_handle}`
        : '#';
      const startBtn = productCard.querySelector('.start-btn');
      startBtn.href = viewDetailAnchor.href;
      productCard.addEventListener('click', function (e) {
        e.preventDefault();
        // forced to PDP page no matter what
        window.location.href = viewDetailAnchor.href;
        return;
        if (this.notInModal) {
          if (this.modal.onCollections) {
            window.location.href = viewDetailAnchor.href;
            return;
          }

          if (checkbox.checked) {
            checkbox.dispatchEvent(new Event('input', { bubbles: true }));
            return;
          }
        }
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('input', { bubbles: true }));
      });

      if (this.modal) {
        viewDetailAnchor.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.openProductModal(product);
        });
      }
      if (product?.images?.length) {
        // productCard.querySelector('img').src = product?.images?.sort(imageOrder)?.at(0)?.url;
        const productImageTag = productCard.querySelector('img');
        const productImageURL =
          product?.images?.find((img) => img.is_collection_image)?.url || product?.images?.sort(imageOrder)?.at(0)?.url;
        productImageTag.src = this.shopifyProductImageMap[viewDetailAnchor.href.split('/').pop()] ?? productImageURL;
      }
      this.productsContainer.appendChild(productNode);
    });
    if (!this.products.length) {
      this.productsContainer.innerHTML = `<div class="flex flex-col gap-8 items-center justify-center col-span-12">
        <p class="mt-20 text-theme-gray-500 text-lg">Sorry! This bumper kit is not available for your vehicle, but we do have <a href="https://www.movebumpers.com/collections/move-bumpers" class="underline">other options available.</a></p>
        <p>
          Can't find what you're looking for?
          <a
            target="_blank"
            href="https://www.movebumpers.com/tools/vehicles/explore-all-make-model-years"
            class="font-gothambold font-bold underline hover:no-underline"
            >Explore all make model years.</a
          >.
        </p>
      </div>`;
    }
    if (this.submitButton) {
      this.submitButton.disabled = !this.getFormData(this.productForm).product_id;
    }
    this.dispatchEvent(new CustomEvent('rendered:products'));
  }

  async fetchFiltersMeta() {
    if (!this.filtersMeta) {
      const metaUrl = `${BASE_URL}/api/product-filters/meta`;
      this.filtersMeta = await fetch(metaUrl)
        .then((res) => res.json())
        .catch((e) => {
          console.log(e);
        });
    }
    return this.filtersMeta;
  }

  async fetchFilters() {
    const query = await this.getQuery();
    const url = `${BASE_URL}/api/product-filters?${query.toString()}`;
    if (this.filtersCancelToken) {
      this.filtersCancelToken.abort('New request');
    }
    this.filtersCancelToken = new AbortController();
    const response = await fetch(url, { signal: this.filtersCancelToken.signal });
    this.filters = await response.json();
    return this.filters;
  }

  clearFilters() {
    // this.topFilterContainer.innerHTML = '';
    // this.mainFilterContainer.innerHTML = '';
    this.filterTemplates.filterGroupContainer.innerHTML = '';
  }

  renderTopFilter() {
    const formValues = this.getFormData(this.topFilterForm);
    this.filters.location?.map((item) => {
      const topFilter = this.getTopFilter();
      const checkbox = topFilter.querySelector('input[type="checkbox"]');
      const label = topFilter.querySelector('label');
      checkbox.value = item;
      checkbox.name = 'location[]';
      checkbox.id = `location-${item}`;
      label.htmlFor = `location-${item}`;
      checkbox.checked = formValues[checkbox.name]?.includes(checkbox.value);
      topFilter.querySelector('.filter-option-title').textContent = item;
      this.topFilterContainer.appendChild(topFilter);
    });
  }

  removeFilter(key, value) {
    const checkbox = this.filterTemplates.form.querySelector(`input[type="checkbox"][name="${key}"][value="${value}"]`);
    if (checkbox instanceof HTMLInputElement) {
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  openHelpModal(key) {
    let template = null;
    if ((template = this.helpModal.querySelector('template'))) {
      this.helpModal.append(template.content.cloneNode(true));
      this.helpModal
        .querySelector('button[data-toggle="modal"][data-target="#help-modal"]')
        .addEventListener('click', this.closeHelpModal.bind(this));
      template.remove();
    }
    this.helpModal.classList.remove('hidden');
    this.helpModal.classList.add('md:flex');
    const modalTitle = this.helpModal.querySelector('.modal-title');
    const modalHeading = this.helpModal.querySelector('.modal-heading');
    const modalDescription = this.helpModal.querySelector('.modal-description');
    const container = this.helpModal.querySelector('.modal-cards-container');
    this.modalCardTemplate = container.querySelector('.modal-card').cloneNode(true);

    const filterCategory = this.filtersMeta.find((item) => item.category === key);

    if (!filterCategory) {
      return;
    }

    modalTitle.innerHTML = `Choosing a ${key}`;
    modalHeading.innerHTML = filterCategory.heading;
    modalDescription.innerHTML = filterCategory.description;

    container.innerHTML = '';

    filterCategory.product_filters.map((productFilter) => {
      const card = this.modalCardTemplate.cloneNode(true);
      // console.log(card.innerHTML);
      const cardDescription = card.querySelector('.modal-card__description-container');
      const cardLogo = card.querySelector('img.modal-card__logo');
      const cardImage = card.querySelector('img.modal-card__image');

      cardDescription.innerHTML = productFilter.description;
      cardLogo.src = productFilter.thumbnail_url;
      cardImage.src = productFilter.image_url;
      cardImage.alt = productFilter.title;
      cardLogo.alt = productFilter.title;

      container.appendChild(card);
    });
  }

  renderFilters() {
    const { filterGroupContainer, chipsContainer, chipItem, form, filtersCount } = this.filterTemplates;
    const formData = this.getFormData(form);
    filterGroupContainer.innerHTML = '';

    chipsContainer.innerHTML = '';
    for (const [key, value] of Object.entries(formData)) {
      const chip = chipItem.cloneNode(true);
      chip.querySelector('label').textContent = value;
      chip.querySelector('button').addEventListener('click', () => this.removeFilter(key, value));
      chipsContainer.appendChild(chip);
    }
    const count = Object.keys(formData).length;
    if (count) {
      filtersCount.textContent = `(${count})`;
    } else {
      filtersCount.textContent = '';
    }

    for (const [key, value] of Object.entries(this.filters)) {
      if (key.toLowerCase() === 'material') {
        continue;
      }
      const {
        filterGroup,
        filterGroupHeading,
        filterItemsContainer,
        filterGroupSubHeading,
        filterItem,
        filterGroupHelp,
      } = this.getFilterGroupTemplates();
      if (undefined === this.filterGroupVisiblityState[key]) {
        if (key.toLowerCase() === 'series' || formData[`${key}[]`]?.length) {
          filterGroup.querySelector('details').open = true;
        }
      } else {
        filterGroup.querySelector('details').open = this.filterGroupVisiblityState[key];
      }
      const filterCategory = this.filtersMeta.find((item) => item.category.toLowerCase() === key.toLowerCase());
      if (!filterCategory) {
        continue;
      }
      filterGroupHeading.textContent = filterCategory.title || key;
      filterGroupSubHeading.textContent = filterCategory.short_description;
      filterGroupHelp.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.openHelpModal(key);
      });
      filterGroup.querySelector('summary').addEventListener('click', () => {
        const opened = !filterGroup.querySelector('details').open;
        this.filterGroupVisiblityState[key] = opened;
      });
      filterItemsContainer.innerHTML = '';
      value.forEach((option, index) => {
        const productFilter = filterCategory.product_filters.find(
          (item) => item.filter.toLowerCase() === option.toLowerCase(),
        );
        if (!productFilter) {
          return;
        }
        const item = filterItem.cloneNode(true);
        const checkbox = item.querySelector('input[type="checkbox"]');
        const label = item.querySelector('label');
        checkbox.value = option;
        checkbox.name = `${key}[]`;
        checkbox.id = `${key}-${option}`;
        checkbox.checked = formData[checkbox.name]?.includes(checkbox.value);
        // if (checkbox.checked) {
        //   filterGroup.querySelector('details').open = true;
        // } else {
        //   filterGroup.querySelector('details').open = this.filterGroupVisiblityState[key];
        // }
        label.htmlFor = checkbox.id;
        const labelBadge = label.querySelector('span>span:first-child');
        const labelTitle = label.querySelector('span>span:nth-child(2)');
        const labelSubTitle = label.querySelector('span>span:last-child');
        const labelImage = label.querySelector('img');
        if (productFilter.tags?.includes('Most Popular')) {
          labelBadge.textContent = 'Most Popular';
        } else {
          labelBadge.remove();
        }
        // labelImage.src = productFilter.image_url || images[key.toLowerCase()]?.[option.toLowerCase()] || '#';
        labelImage.src = productFilter.thumbnail_url;
        labelImage.alt = productFilter.title;
        labelTitle.textContent = productFilter.title;
        labelSubTitle.textContent = productFilter.short_description;
        filterItemsContainer.appendChild(item);
      });
      filterGroupHeading.appendChild(filterGroupSubHeading);
      filterGroupContainer.appendChild(filterGroup);
    }
    if (this.filtersModal.classList.contains('hidden')) {
      this.filtersSideContainer.innerHTML = '';
      this.filtersSideContainer.appendChild(this.filterTemplates.form);
    } else {
      this.filtersModal.innerHTML = '';
      this.filtersModal.appendChild(this.filterTemplates.form);
    }
    this.dispatchEvent(new CustomEvent('rendered:filters'));
  }

  getProduct() {
    const node = this.productTemplate.content.cloneNode(true);
    if (node instanceof DocumentFragment) {
      return node;
    }
    throw new Error('Failed to clone product template');
  }

  getLoader() {
    const node = this.loaderTemplate.content.cloneNode(true);
    if (node instanceof DocumentFragment) {
      return node;
    }
    throw new Error('Failed to clone loader template');
  }

  getFilterGroup() {
    const node = this.filterGroupTemplate.content.cloneNode(true);
    if (node instanceof DocumentFragment) {
      return node;
    }
    throw new Error('Failed to clone filter group template');
  }

  getFilterOption() {
    const node = this.filterOptionTemplate.content.cloneNode(true);
    if (node instanceof DocumentFragment) {
      return node;
    }
    throw new Error('Failed to clone filter option template');
  }

  getTopFilter() {
    const node = this.topFilterTemplate.content.cloneNode(true);
    if (node instanceof DocumentFragment) {
      return node;
    }
    throw new Error('Failed to clone top filter template');
  }

  getFilterGroupTemplate() {
    const template = this.querySelector('template#filter-group-template');
    if (template instanceof HTMLTemplateElement) {
      return template;
    }
    throw new Error('Missing filter group template');
  }

  getProductTemplate() {
    const template = document.getElementById('product-template');
    if (template instanceof HTMLTemplateElement) {
      return template;
    }
    throw new Error('Missing product template');
  }

  getFilterOptionTemplate() {
    const template = this.querySelector('template#filter-option-template');
    if (template instanceof HTMLTemplateElement) {
      return template;
    }
    throw new Error('Missing filter option template');
  }

  getTopFilterTemplate() {
    const template = this.querySelector('template#top-filter-template');
    if (template instanceof HTMLTemplateElement) {
      return template;
    }
    throw new Error('Missing top filter template');
  }

  getFilterGroupTemplates() {
    const filterGroup = this.filterTemplates.filterGroup.cloneNode(true);
    if (filterGroup instanceof HTMLElement) {
      const filterGroupHeading = filterGroup.querySelector('h2');
      const filterGroupSubHeading = filterGroupHeading.querySelector('span').cloneNode(true);
      const filterGroupHelp = filterGroup.querySelector('.filter-help');
      const filterItemsContainer = filterGroup.querySelector('.filter-items-container');
      const filterItem = filterGroup.querySelector('.filter-item').cloneNode(true);
      return {
        filterGroup,
        filterGroupHeading,
        filterGroupSubHeading,
        filterGroupHelp,
        filterItemsContainer,
        filterItem,
      };
    }
    throw new Error('Failed to clone filter group template');
  }

  handleResetFilters() {
    if (window.location.pathname != CustomizerStep2.RESET_FILTER_LOCATION) {
      window.location.href = CustomizerStep2.RESET_FILTER_LOCATION;
    } else {
      this.loadProducts();
    }
  }

  getFilterTemplates() {
    const template = document.getElementById('filters-template');
    if (template instanceof HTMLTemplateElement) {
      const node = template.content.cloneNode(true);
      if (node instanceof DocumentFragment) {
        const form = node.querySelector('form');
        const chipsContainer = form.querySelector('.filter-chips-container');
        const chipItem = form.querySelector('.filter-chip-item').cloneNode(true);
        const filtersCount = form.querySelector('.filters-count');
        const filterGroupContainer = form.querySelector('.filter-group-container');
        const filterGroup = form.querySelector('.filter-group').cloneNode(true);
        return {
          node,
          form,
          chipsContainer,
          chipItem,
          filtersCount,
          filterGroupContainer,
          filterGroup,
        };
      }
      throw new Error('Failed to clone filters template');
    }
    throw new Error('Missing filters template');
  }

  getLoaderTemplate() {
    const template = document.getElementById('loader-template');
    if (template instanceof HTMLTemplateElement) {
      return template;
    }
    throw new Error('Missing loader template');
  }

  getTopFilterForm() {
    const form = this.querySelector('form.top-filter-form');
    if (form instanceof HTMLFormElement) {
      return form;
    }
    throw new Error('Missing top filter form');
  }

  getMainFilterForm() {
    const form = this.querySelector('form.main-filter-form');
    if (form instanceof HTMLFormElement) {
      return form;
    }
    throw new Error('Missing main filter form');
  }

  getProductForm() {
    const form = this.querySelector('form.product-form');
    if (form instanceof HTMLFormElement) {
      return form;
    }
    throw new Error('Missing product form');
  }

  getModal() {
    const modal = document.querySelector('customizer-modal');
    if (modal instanceof CustomizerModal) {
      return modal;
    }
    // throw new Error('Missing modal');
  }

  getSubmitButton() {
    const button = this.querySelector('button[type="submit"][form="products-container"]');
    if (button instanceof HTMLButtonElement) {
      return button;
    }
    // throw new Error('Missing submit button');
  }

  mapToParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData);
  }

  getFormData(form) {
    return Object.fromEntries(new FormData(form));
  }
}
if (!customElements.get('customizer-step2')) {
  customElements.define('customizer-step2', CustomizerStep2);
}
class CustomizerBreadcrumbs extends HTMLElement {
  static observedAttributes = ['items'];
  static #items = [];
  static #links = {};
  #listeners = [];
  constructor() {
    super();
    // this.attachShadow({ mode: 'open' });
    // this.attachStyles();
  }

  get inModal() {
    return this.closest('customizer-modal') instanceof CustomizerModal;
  }

  parseItems() {
    CustomizerBreadcrumbs.#items = JSON.parse(this.getAttribute('items'));
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'items') {
      CustomizerBreadcrumbs.#items = JSON.parse(newValue);
      this.render();
    }
  }

  attachStyles() {
    // this.shadowRoot.adoptedStyleSheets = [tailwindcss];
    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', document.querySelector('link[rel="stylesheet"][href*="app.css"]').getAttribute('href'));
    this.shadowRoot.appendChild(link);
  }

  template() {
    return '';
  }

  #createBreadcrumbItem(string) {
    const breadcrumbItem = document.createElement('a');
    breadcrumbItem.setAttribute('href', CustomizerBreadcrumbs.#links[string]);
    breadcrumbItem.classList.add('breadcrumb-item');
    breadcrumbItem.setAttribute('part', 'breadcrumb-item');
    breadcrumbItem.innerHTML = string;
    return breadcrumbItem;
  }

  render() {
    if (CustomizerBreadcrumbs.#items.length > 0) {
      CustomizerBreadcrumbs.#items.forEach((item) => {
        const breadcrumbItem = this.#createBreadcrumbItem(item);
        // this.shadowRoot.appendChild(breadcrumbItem);
        this.appendChild(breadcrumbItem);
      });
    }
  }

  #render() {
    if (!this.inModal) {
      return;
    }
    this.determineItems();
    // this.shadowRoot.innerHTML = '';
    this.innerHTML = '';
    if (this.render) {
      return this.render();
    }
    const template = document.createElement('template');
    template.innerHTML = this.template();
    if (template instanceof HTMLTemplateElement) {
      const node = template.content.cloneNode(true);
      if (node instanceof DocumentFragment) {
        // this.shadowRoot.appendChild(node);
        this.appendChild(node);
      }
    }
  }

  determineItems() {
    if (this.getAttribute('items') !== null) {
      this.parseItems();
      return;
    }
    const selectedVehicle = this.modal?.selectedVehicle || JSON.parse(localStorage.getItem('vehicle'));
    const selectedProduct = this.modal?.selectedProduct || JSON.parse(localStorage.getItem('product'));
    const items = [];
    if (selectedVehicle && !this.customizerStep1) {
      const title = ['make', 'model', 'year'].map((key) => selectedVehicle[key]).join(' ');
      items.push(title);
      CustomizerBreadcrumbs.#links[title] = '/collections/move-bumpers';
    }
    if (selectedProduct && !this.customizerStep1 && !this.customizerStep2) {
      const title =
        selectedProduct.detail?.title ||
        ['series', 'location', 'material'].map((key) => selectedProduct[key]).join(' ');
      items.push(title);
      CustomizerBreadcrumbs.#links[title] = selectedProduct?.detail?.shopify_handle
        ? `/products/${selectedProduct?.detail?.shopify_handle}`
        : '#';
    }
    CustomizerBreadcrumbs.#items = items;
  }

  get items() {
    return CustomizerBreadcrumbs.#items;
  }

  set items(value) {
    CustomizerBreadcrumbs.#items = value;
    this.#render();
  }

  get customizerStep1() {
    const ele = this.modal?.querySelector('customizer-step1');
    if (ele instanceof CustomizerStep1) {
      return ele;
    }
    return null;
  }

  get customizerStep2() {
    const ele = this.modal?.querySelector('customizer-step2');
    if (ele instanceof CustomizerStep2) {
      return ele;
    }
    return null;
  }

  get modal() {
    const ele = this.closest('customizer-modal');
    if (ele instanceof CustomizerModal) {
      return ele;
    }
    return null;
  }

  connectedCallback() {
    this.bindEventListeners();
    this.#render();
  }

  disconnectedCallback() {
    this.unbindEventListeners();
    CustomizerBreadcrumbs.#items = [];
  }

  reboundEventListeners() {
    this.unbindEventListeners();
    this.bindEventListeners();
  }

  bindEventListeners() {
    this.#listeners = [];
    const handleProductChanged = () => {
      this.#render();
    };
    const handleVehicleChanged = () => {
      this.#render();
    };
    this.customizerStep2?.addEventListener('product:changed', handleProductChanged);
    this.customizerStep1?.addEventListener('vehicle:changed', handleVehicleChanged);

    this.#listeners.concat([
      () => this.customizerStep2?.removeEventListener('product:changed', handleProductChanged),
      () => this.customizerStep1?.removeEventListener('vehicle:changed', handleVehicleChanged),
    ]);
  }

  unbindEventListeners() {
    this.#listeners.forEach((remove) => {
      remove();
    });
  }
}
if (!customElements.get('customizer-breadcrumbs')) {
  customElements.define('customizer-breadcrumbs', CustomizerBreadcrumbs);
}

class CommunityCarousel extends HTMLElement {
  static observedAttributes = ['vehicle', 'product'];
  #pagination;

  constructor() {
    super();
    // this._internals = this.attachInternals();
    this.#pagination = this.emptyPagination();
  }

  emptyPagination() {
    return {
      current_page: 1,
      data: [],
      first_page_url: '',
      last_page_url: '',
      next_page_url: '',
      prev_page_url: '',
      total: 0,
      from: 0,
      to: 0,
      per_page: 15,
    };
  }

  init() {
    this.container = this.querySelector('.community-bumper-card').parentElement;
    this.itemTemplate = this.querySelector('.community-bumper-card').cloneNode(true);
  }

  connectedCallback() {
    this.init();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'vehicle' || name === 'product') {
      this.fetchVehicleGallery().then(this.render.bind(this));
    }
  }

  render() {
    this.container.innerHTML = '';
    this.#pagination.data
      .flatMap((item) => item.images.map((image) => ({ ...image, submission: item })))
      .sort((b, a) =>
        a.featured - b.featured === 0
          ? a.submission.featured_count - b.submission.featured_count
          : a.featured - b.featured,
      )
      .forEach((image) => {
        const itemElement = this.itemTemplate.cloneNode(true);
        itemElement.querySelector('img').setAttribute('src', image.image_url || '#');
        itemElement.querySelector('h3').textContent = [image.submission.make, image.submission.model].join(' ');
        itemElement.querySelector('p').textContent = [
          image.submission.year,
          image.product.series,
          image.product.location,
          image.product.fabrication,
        ]
          .filter(Boolean)
          .join(' | ')
          .toLowerCase();
        this.container.appendChild(itemElement);
      });
  }

  async fetchVehicleGallery() {
    const vehicle = this.getAttribute('vehicle');
    const product = this.getAttribute('product');
    if (!vehicle) {
      return;
    }
    const url = `${BASE_URL}/api/vehicles/${vehicle}/gallery/${product || ''}?featured=true`;
    const response = await fetch(url);
    const data = await response.json();
    this.#pagination = data;
  }
}
if (!customElements.get('community-carousel')) {
  customElements.define('community-carousel', CommunityCarousel);
}

class MoveGalleryForm extends MoveMMY {
  static observedAttributes = ['class'];

  constructor() {
    super();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'class') {
      if (this.classList.contains('hidden')) {
        document.dispatchEvent(new CustomEvent('gallery-form:hidden'));
      } else {
        document.dispatchEvent(new CustomEvent('gallery-form:shown'));
      }
    }
  }

  async connectedCallback() {
    super.connectedCallback();
    const filtersMeta = await this.fetchFiltersMeta();
    this.seriesList = filtersMeta.find((meta) => meta.category === 'series')?.product_filters || [];
    this.locationList = filtersMeta.find((meta) => meta.category === 'location')?.product_filters || [];
  }

  submit(e) {
    super.submit(e);
    const url = `${BASE_URL}/api/vehicles/${this.selectedVehicle.sku}/gallery`;
    const formData = new FormData(this.form);
    const productSkus = Array.from(formData.getAll('product_sku[]'));
    formData.delete('product_sku[]');
    productSkus.forEach((sku) => {
      if (sku === 'Unknown') {
        formData.append('product_sku[]', '');
      } else {
        formData.append('product_sku[]', sku);
      }
    });
    console.log(formDataToObject(formData));
    this.submitButton.disabled = true;
    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
      },
    })
      .then(async (res) => {
        if (!res.ok) {
          throw (await res.json()) || { message: 'Something went wrong' };
        }
        return res.json();
      })
      .then((data) => {
        console.log(data);
        alert('Photos submitted successfully');
        this.form.reset();
        toggleForm();
      })
      .catch((e) => {
        console.log(e);
        alert(e.message);
      })
      .finally(() => {
        this.submitButton.disabled = false;
      });
  }

  determineSubmitButtonState() {
    const isValid = this.form.checkValidity();
    this.form.querySelector('button[type=submit]').disabled = !isValid;
  }

  async fetchFiltersMeta() {
    const metaUrl = `${BASE_URL}/api/product-filters/meta`;
    return await fetch(metaUrl)
      .then((res) => res.json())
      .catch((e) => {
        console.log(e);
      });
  }
}

if (!customElements.get('move-gallery-form')) {
  customElements.define('move-gallery-form', MoveGalleryForm);
}

class MoveDropzone extends HTMLElement {
  static formAssociated = true;
  static observedAttributes = ['max-files', 'max-size'];
  imageUrls = new Map();
  constructor() {
    super();
    this._internals = this.attachInternals();
    this.files = [];
    this.input = document.createElement('input');
    this.input.type = 'file';
    this.input.accept = 'image/*';
    this.input.multiple = true;
    this.input.className = 'hidden';
    this.products = [];
  }

  get form() {
    return this._internals.form;
  }

  get galleryForm() {
    let galleryForm = this.closest('move-gallery-form');
    if (galleryForm instanceof MoveGalleryForm) {
      return galleryForm;
    }
    throw new Error('MoveDropzone must be inside a move-gallery-form');
  }

  async fetchProducts() {
    const vehicle = this.galleryForm.determineSelectedVehicle();
    if (!vehicle) {
      throw new Error('Vehicle not found');
    }
    const query = new URLSearchParams({
      vehicle_sku: vehicle.sku,
    });
    const url = `${BASE_URL}/api/products?${query.toString()}`;
    const response = await fetch(url);
    const data = await response.json();
    this.products = data;
    this.dispatchEvent(new CustomEvent('products:loaded'));
  }

  connectedCallback() {
    this.galleryForm.yearSelect.addEventListener('change', this.fetchProducts.bind(this));
    document.addEventListener('gallery-form:shown', this.fetchProducts.bind(this));
    document.addEventListener('vehicle:changed', this.fetchProducts.bind(this));
    document.addEventListener('vehicles:loaded', this.fetchProducts.bind(this));
    this.addEventListener('products:loaded', this.renderPreview.bind(this));
    this.form.addEventListener('reset', () => {
      Array.from(this.imageUrls.values()).forEach((url) => {
        URL.revokeObjectURL(url);
      });
      this.imageUrls.clear();
      this.files = [];
      this.renderPreview();
    });
    // Setup dropzone
    if (this.hasAttribute('required')) {
      if (this.files.length === 0) {
        this._internals.setValidity(
          {
            valueMissing: true,
          },
          'Please upload at least one image',
        );
      }
    }
    this.classList.add('group');
    this.dropzone = document.createElement('div');
    this.dropzone.className = 'move-dropzone group-invalid:border-red-600';
    this.dropzone.innerHTML = `
    <svg width="100" height="100" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 184.69 184.69" style="enable-background:new 0 0 184.69 184.69;" xml:space="preserve">
                        <g>
                            <g>
                                <g>
                                    <path style="fill:#a7b7b4;" d="M149.968,50.186c-8.017-14.308-23.796-22.515-40.717-19.813
				        C102.609,16.43,88.713,7.576,73.087,7.576c-22.117,0-40.112,17.994-40.112,40.115c0,0.913,0.036,1.854,0.118,2.834
				        C14.004,54.875,0,72.11,0,91.959c0,23.456,19.082,42.535,42.538,42.535h33.623v-7.025H42.538
				        c-19.583,0-35.509-15.929-35.509-35.509c0-17.526,13.084-32.621,30.442-35.105c0.931-0.132,1.768-0.633,2.326-1.392
				        c0.555-0.755,0.795-1.704,0.644-2.63c-0.297-1.904-0.447-3.582-0.447-5.139c0-18.249,14.852-33.094,33.094-33.094
				        c13.703,0,25.789,8.26,30.803,21.04c0.63,1.621,2.351,2.534,4.058,2.14c15.425-3.568,29.919,3.883,36.604,17.168
				        c0.508,1.027,1.503,1.736,2.641,1.897c17.368,2.473,30.481,17.569,30.481,35.112c0,19.58-15.937,35.509-35.52,35.509H97.391
				        v7.025h44.761c23.459,0,42.538-19.079,42.538-42.535C184.69,71.545,169.884,53.901,149.968,50.186z"></path>
                                </g>
                                <g>
                                    <path style="fill:#a7b7b4;" d="M108.586,90.201c1.406-1.403,1.406-3.672,0-5.075L88.541,65.078
				        c-0.701-0.698-1.614-1.045-2.534-1.045l-0.064,0.011c-0.018,0-0.036-0.011-0.054-0.011c-0.931,0-1.85,0.361-2.534,1.045
				        L63.31,85.127c-1.403,1.403-1.403,3.672,0,5.075c1.403,1.406,3.672,1.406,5.075,0L82.296,76.29v97.227
				        c0,1.99,1.603,3.597,3.593,3.597c1.979,0,3.59-1.607,3.59-3.597V76.165l14.033,14.036
				        C104.91,91.608,107.183,91.608,108.586,90.201z"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
        <p>Drag and drop images here or click to upload</p>
        <p class="text-sm text-gray-500">(Maximum ${this.getAttribute('max-files')} images, ${this.getAttribute(
          'max-size',
        )} each)</p>
      `;
    this.preview = document.createElement('div');
    this.preview.className = 'preview';
    this.appendChild(this.input);
    this.appendChild(this.dropzone);
    this.appendChild(this.preview);

    this.dropzone.addEventListener('click', () => this.input.click());
    this.dropzone.addEventListener('dragover', (e) => {
      e.preventDefault();
      this.dropzone.classList.add('dragover');
    });
    this.dropzone.addEventListener('dragleave', (e) => {
      e.preventDefault();
      this.dropzone.classList.remove('dragover');
    });
    this.dropzone.addEventListener('drop', (e) => {
      e.preventDefault();
      this.dropzone.classList.remove('dragover');
      const files = Array.from(e.dataTransfer.files).filter((f) => f.type.startsWith('image/'));
      this.handleFiles(files);
    });
    this.input.addEventListener('change', (e) => {
      const files = Array.from(this.input.files).filter((f) => f.type.startsWith('image/'));
      this.handleFiles(files);
      this.input.value = '';
    });
    this.renderPreview();
  }

  handleFiles(files) {
    const maxFiles = this.getAttribute('max-files');
    const maxFileSize = this.getAttribute('max-size');
    const totalFiles = files.length + this.files.length;
    if (totalFiles > maxFiles) {
      const message = `Maximum ${maxFiles} files allowed`;
      this._internals.setValidity(
        {
          rangeOverflow: true,
        },
        message,
      );
      this._internals.reportValidity();
      return;
    }
    const humanSizeUnit = maxFileSize.replace(/[^a-zA-Z]/g, '').toLowerCase();
    const multiplierMap = {
      gb: 1024 * 1024 * 1024,
      mb: 1024 * 1024,
      kb: 1024,
      b: 1,
    };
    const sizeInBytes = maxFileSize.replace(/[^0-9]/g, '') * multiplierMap[humanSizeUnit];
    if (files.some((file) => file.size > sizeInBytes)) {
      const message = `Maximum file size is ${maxFileSize}`;
      this._internals.setValidity(
        {
          tooLong: true,
        },
        message,
      );
      this._internals.reportValidity();
      return;
    }
    this._internals.setValidity({});
    this._internals.reportValidity();
    this.files = this.files.concat(files);
    this.updateForm();
    this.renderPreview();
  }

  updateForm() {
    const formData = new FormData();
    this.files.forEach((file, idx) => {
      formData.append(`images[]`, file);
    });
    this._internals.setFormValue(formData);
    if (this.hasAttribute('required')) {
      if (this.files.length === 0) {
        this._internals.setValidity(
          {
            valueMissing: true,
          },
          'Please upload at least one image',
        );
        this._internals.reportValidity();
      }
    }
  }

  removeImage(index) {
    URL.revokeObjectURL(this.imageUrls.get(this.files[index]));
    this.imageUrls.delete(this.files[index]);
    this.preview.firstChild.children[index].remove();
    this.files.splice(index, 1);
    this.updateForm();
    this.renderPreview();
  }

  getImageUrl(file) {
    let url = this.imageUrls.get(file);
    if (url) {
      return url;
    }
    url = URL.createObjectURL(file);
    this.imageUrls.set(file, url);
    return url;
  }

  renderPreview() {
    const formData = formDataToObject(new FormData(this.form));
    this.preview.innerHTML = '';
    if (this.files.length === 0) {
      this.preview.innerHTML = '<p class="text-gray-400 text-sm">No images selected.</p>';
      return;
    }
    const previewGrid = document.createElement('div');
    previewGrid.className = 'move-dropzone-preview-grid';
    this.files.forEach((file, idx) => {
      const imgWrapper = document.createElement('div');
      imgWrapper.className = 'move-dropzone-img-wrapper';
      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/></svg>';
      removeBtn.className = 'move-dropzone-remove-btn';
      removeBtn.addEventListener('click', () => this.removeImage(idx));
      const img = document.createElement('img');
      img.src = this.getImageUrl(file);
      img.alt = file.name;
      img.className = 'move-dropzone-img';
      imgWrapper.innerHTML = `<!-- <select name="series[]" class="form-select" required>
      <option value="" ${
        formData[`series[]`]?.[idx] === '' ? 'selected' : ''
      }>Series</option>${this.galleryForm.seriesList
        .map((series) => {
          return `<option ${series.filter === formData[`series[]`]?.[idx] ? 'selected' : ''} value="${series.filter}">${
            series.title
          }</option>`;
        })
        .join('')}
      </select> -->
      <select name="product_sku[]" class="form-select" ${this.products.length === 0 ? 'disabled' : ''}>
        <option value="" ${formData[`product_sku[]`]?.[idx] === '' ? 'selected' : ''}>Select Product</option>
        <option value="Unknown" ${formData[`product_sku[]`]?.[idx] === 'Unknown' ? 'selected' : ''}>Unknown</option>
        ${this.products
          .map((product) => {
            return `<option value="${product.sku}" ${
              product.sku === formData[`product_sku[]`]?.[idx] ? 'selected' : ''
            }>${product.title}</option>`;
          })
          .join('')}
      </select>
      <!-- <select name="location[]" class="form-select" required>
      <option value="" ${
        formData[`location[]`]?.[idx] === '' ? 'selected' : ''
      }>Location</option>${this.galleryForm.locationList
        .map(
          (location) =>
            `<option ${location.filter === formData[`location[]`]?.[idx] ? 'selected' : ''} value="${
              location.filter
            }">${location.title}</option>`,
        )
        .join('')}
      </select> -->`;
      imgWrapper.prepend(img);
      imgWrapper.prepend(removeBtn);
      previewGrid.appendChild(imgWrapper);
    });
    this.preview.appendChild(previewGrid);
  }
}
if (!customElements.get('move-dropzone')) {
  customElements.define('move-dropzone', MoveDropzone);
}

import PhotoSwipe from './photoswipe.esm.min.js';
class MoveCustomerGalleryV2 extends HTMLElement {
  static observedAttributes = ['vehicle', 'product', 'make', 'model', 'year'];
  #internals;

  constructor() {
    super();
    this.#internals = this.attachInternals();
    this.page = Number(new URLSearchParams(location.search).get('page') ?? 1);
    this.url = null;
    this.pswp = null;
    this.options = {
      index: 0,
      dataSource: [],
    };
    this.emmitReload = debounce(() => {
      this.dispatchEvent(new CustomEvent('reload'));
    }, 100);
    this.loadMoreObserver = new IntersectionObserver(this.determineLoadMore.bind(this));
    this.pageObserver = new IntersectionObserver(this.handlePageIntersect.bind(this));
  }

  get initialised() {
    return this.#internals.states.has('initialised');
  }

  set initialised(value) {
    if (value) {
      this.#internals.states.add('initialised');
      this.classList.add('initialised');
    } else {
      this.#internals.states.delete('initialised');
      this.classList.remove('initialised');
    }
  }

  get loading() {
    return this.classList.contains('loading');
  }

  get container() {
    const ele = this.querySelector('.gallery-container');
    if (ele instanceof HTMLDivElement) {
      return ele;
    }
    return null;
  }

  get loaderTemplate() {
    return this.querySelector('template#loader').content.cloneNode(true);
  }

  get mmy() {
    const mmy = document.querySelector('move-mmy[type=gallery]');
    if (mmy instanceof MoveMMY) {
      return mmy;
    }
    return null;
  }

  connectedCallback() {
    this.bindEventListeners();
    this.vehicleLookup();
    this.initPhotoSwipe(this.container);
    this.observeInfiniteLoad();
    this.observePage();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // console.log(name, oldValue, newValue);
    if (this.initialised && oldValue != newValue) {
      this.emmitReload();
    }
  }

  bindEventListeners() {
    this.addEventListener('reload', this.handleReload.bind(this));

    if (!this.mmy) {
      return;
    }
    this.mmy.form.addEventListener('input', debounce(this.handleMMYInput.bind(this), 100));

    // this.mmy.addEventListener('vehicle:changed', ({ detail: vehicle }) => {
    //   this.handleVehicleChanged(vehicle);
    // });
  }

  handleReload() {
    this.options = {
      index: 0,
      dataSource: [],
    };
    if (!this.loading) {
      this.container.innerHTML = '';
    }
    this.builtUrl();
    this.loadItems();
  }

  handleVehicleChanged(vehicle) {
    this.setAttribute('vehicle', vehicle.sku);
  }

  handleMMYInput() {
    if (!this.initialised) {
      this.initialised = true;
      if (this.getAttribute('make')) {
        return;
      } else if (!this.mmy.vehicle) {
        return;
      } else {
        if (!location.pathname.split('/').includes('all')) {
          this.container.innerHTML = '';
        } else {
          this.mmy.makeSelect.value = '';
          this.mmy.modelSelect.value = '';
          this.mmy.yearSelect.value = '';
          return;
        }
      }
    }
    this.setAttribute('vehicle', '');
    this.setAttribute('make', this.mmy.makeSelect.value || '');
    this.setAttribute('model', this.mmy.modelSelect.value || '');
    this.setAttribute('year', this.mmy.yearSelect.value || '');
    this.builtUrl();

    if (this.mmy.makeSelect.value && this.mmy.modelSelect.value && this.mmy.yearSelect.value) {
      this.mmy.form.requestSubmit();
    }
  }

  showLoader() {
    while (this.container.querySelectorAll('.loader-card').length < this.dataset.limit) {
      this.container.append(this.loaderTemplate.cloneNode(true));
    }
    this.classList.add('loading');
  }

  hideLoader() {
    this.container.querySelectorAll('.loader-card').forEach((el) => el.remove());
    this.classList.remove('loading');
  }

  determineLoadMore([entry]) {
    if (entry.isIntersecting) {
      if (Number(this.dataset.hasMore) && entry.target === this.container.lastElementChild) {
        const page = this.page + 1;
        this.builtUrl(page);
        this.loadItems();
        this.loadMoreObserver.disconnect();
      }
    }
  }

  handlePageIntersect([entry]) {
    if (entry.isIntersecting) {
      const params = new URLSearchParams(location.search);
      const currentPage = Number(params.get('page'));
      const page = Number(entry.target.dataset.page);
      this.navigate(page);
    }
  }

  vehicleLookup() {
    if (!this.mmy && !this.getAttribute('vehicle')) {
      try {
        const vehicle = JSON.parse(localStorage.getItem('vehicle'));
        if (vehicle && vehicle.sku) {
          this.setAttribute('vehicle', vehicle.sku);
        }
      } catch (e) {}
    }
  }

  render(container) {
    if (!(container instanceof HTMLDivElement)) {
      return false;
    }
    Array.from(container.children).forEach((item) => {
      this.container.appendChild(item);
    });
    this.observeInfiniteLoad();
    this.observePage();
    if (this.container.childElementCount === 0 && this.emptyTemplate) {
      this.container.appendChild(this.emptyTemplate);
    }
  }

  observePage() {
    const item = Array.from(this.container.children).at(this.dataset.limit / -2);
    this.pageObserver.observe(item);
  }

  observeInfiniteLoad() {
    this.loadMoreObserver.disconnect();
    if (this.container && this.container.querySelector('.community-bumper-card')) {
      this.loadMoreObserver.observe(this.container.lastElementChild);
    }
  }

  loadItems() {
    this.showLoader();
    this.fetchVehicleGallery()
      .then((container) => {
        this.initPhotoSwipe(container);
        this.render(container);
      })
      .finally(this.hideLoader.bind(this));
  }

  initPhotoSwipe(container) {
    const items = Array.from(container.querySelectorAll('.community-bumper-card'));
    items.forEach((item) => {
      const itemImage = item.querySelector('img');
      this.options.dataSource.push({
        src: itemImage.dataset.url,
        alt: itemImage.alt,
        ...(itemImage.src ? { msrc: itemImage.src } : {}),
      });
    });
    items.forEach((item) => {
      item.querySelector('button[data-open-modal]').addEventListener('click', () => {
        const itemImage = item.querySelector('img');
        this.openPhotoSwipe(
          this.options.dataSource.findIndex((img) => img.src === itemImage.dataset.url),
          itemImage,
        );
      });
    });
  }

  openPhotoSwipe(startIndex, thumbEl) {
    if (startIndex === -1) {
      return;
    }
    this.pswp = new PhotoSwipe({
      dataSource: this.options.dataSource,
      index: startIndex,
      preload: [0, 0],
      loop: false,
      preloadFirstSlide: false,
      preloaderDelay: 100,
    });
    seedImageSize(this.options.dataSource[startIndex], thumbEl);
    enableLazySlideLoading(this.pswp);
    this.pswp.init();
    ensureSlideSize(this.pswp);
  }

  builtUrl(page = 1) {
    this.page = page;
    const vehicle = this.getAttribute('vehicle') || '';
    const product = this.getAttribute('product') || '';
    const make = this.getAttribute('make') || '';
    const model = this.getAttribute('model') || '';
    const year = this.getAttribute('year') || '';
    const params = new URLSearchParams();
    params.set('limit', this.dataset.limit);
    params.set('page', page);
    if (!vehicle) {
      this.url = `/community/move-gallery/${[make, model, year].filter(Boolean).map(slugify).join('/')}?${params.toString()}`;
    } else {
      if (product) {
        this.url = `/tools/vehicles/${vehicle}/gallery/${product}?${params.toString()}`;
      } else {
        this.url = `/tools/vehicles/${vehicle}/gallery?${params.toString()}`;
      }
    }
    if (this.initialised || !location.pathname.split('/').includes('all')) {
      this.navigate(page);
    }
  }

  navigate(page) {
    try {
      const url = new URL(window.location.origin + this.url);
      Array.from(url.searchParams.keys()).forEach((param) => url.searchParams.delete(param));
      url.searchParams.set('page', page);
      history.pushState(null, '', url.toString());
    } catch (e) {
      console.log(e);
    }
  }

  async fetchVehicleGallery() {
    if (!this.url) {
      this.builtUrl();
    }
    if (this.abortController) {
      this.abortController.abort('New request');
    }
    this.abortController = new AbortController();
    const response = await fetch(this.url, { signal: this.abortController.signal });
    const html = await response.text();
    const dom = new DOMParser().parseFromString(html, 'text/html');
    this.dataset.hasMore = dom.querySelector('move-customer-gallery-v2').dataset.hasMore;
    document.querySelector('h1').innerHTML = dom.querySelector('h1').innerHTML;
    document.querySelector('.breadcrumb-container').innerHTML = dom.querySelector('.breadcrumb-container').innerHTML;
    return dom.querySelector('move-customer-gallery-v2 .gallery-container');
  }
}
if (!customElements.get('move-customer-gallery-v2')) {
  customElements.define('move-customer-gallery-v2', MoveCustomerGalleryV2);
}
class MoveCustomerGallery extends HTMLElement {
  static observedAttributes = ['vehicle', 'product', 'make', 'model', 'year'];

  constructor() {
    super();
    this.pagination = this.emptyPagination;
    this.items = [];
    this.url = null;
    this.pswp = null;
    this.limit = 8;
    this.options = {
      index: 0,
      dataSource: [],
    };
    this.addEventListener('reload', () => {
      this.options = {
        index: 0,
        dataSource: [],
      };
      if (!this.loading) {
        this.container.innerHTML = '';
      }
      this.builtUrl();
      console.log('reloading with url', this.url);
      this.loadItems();
    });
    this.emmitReload = debounce(() => {
      this.dispatchEvent(new CustomEvent('reload'));
    }, 100);
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this));
  }

  get loading() {
    return this.classList.contains('loading');
  }

  handleIntersection([entry]) {
    // determine intersecting
    if (entry.isIntersecting && this.pagination.next_page_url) {
      this.url = this.pagination.next_page_url;
      console.log('loading more');
      this.loadItems();
      this.observer.disconnect();
    }
  }

  vehicleLookup() {
    if (!this.getAttribute('vehicle')) {
      try {
        const vehicle = JSON.parse(localStorage.getItem('vehicle'));
        if (vehicle && vehicle.sku) {
          this.setAttribute('vehicle', vehicle.sku);
        }
      } catch (e) {}
    }
  }

  get emptyPagination() {
    return {
      current_page: 1,
      data: [],
      first_page_url: '',
      last_page_url: '',
      next_page_url: '',
      prev_page_url: '',
      total: 0,
      from: 0,
      to: 0,
      per_page: 15,
    };
  }

  get container() {
    return this.querySelector('.gallery-container');
  }

  get loaderTemplate() {
    return this.querySelector('template#loader').content.cloneNode(true);
  }

  get itemTemplate() {
    return this.querySelector('template#gallery-card').content.cloneNode(true);
  }

  get emptyTemplate() {
    return this.querySelector('template#gallery-empty')?.content?.cloneNode(true);
  }

  get modal() {
    return this.querySelector('dialog');
  }

  connectedCallback() {
    this.bindOutsideEvents();
    if (!document.querySelector('move-mmy')) {
      this.vehicleLookup();
    }
  }

  bindOutsideEvents() {
    const moveMmy = document.querySelector('move-mmy[type=gallery]');
    if (!moveMmy) {
      return;
    }
    moveMmy.form.addEventListener('input', (e) => {
      this.setAttribute('vehicle', '');
      this.setAttribute('make', moveMmy.makeSelect.value || '');
      this.setAttribute('model', moveMmy.modelSelect.value || '');
      this.setAttribute('year', moveMmy.yearSelect.value || '');
      const url = new URL(window.location.href);
      if (moveMmy.makeSelect.value) {
        url.searchParams.set('make', moveMmy.makeSelect.value.slugify());
      } else {
        url.searchParams.delete('make');
      }
      if (moveMmy.modelSelect.value) {
        url.searchParams.set('model', moveMmy.modelSelect.value.slugify());
      } else {
        url.searchParams.delete('model');
      }
      if (moveMmy.yearSelect.value) {
        url.searchParams.set('year', moveMmy.yearSelect.value.slugify());
      } else {
        url.searchParams.delete('year');
      }
      history.pushState(null, '', url.toString());
      if (moveMmy.makeSelect.value && moveMmy.modelSelect.value && moveMmy.yearSelect.value) {
        moveMmy.form.requestSubmit();
      }
    });

    moveMmy.addEventListener('vehicle:changed', ({ detail: vehicle }) => {
      document.querySelector('move-customer-gallery')?.setAttribute('vehicle', vehicle.sku);
    });
  }

  showLoader() {
    while (this.container.querySelectorAll('.loader-card').length < this.limit) {
      this.container.append(this.loaderTemplate.cloneNode(true));
    }
    this.classList.add('loading');
  }

  hideLoader() {
    this.container.querySelectorAll('.loader-card').forEach((el) => el.remove());
    this.classList.remove('loading');
    this.classList.add('initialised');
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // console.log(name, oldValue, newValue);
    if (oldValue != newValue) {
      this.emmitReload();
    }
  }

  renderItem(item) {
    item.images.forEach((image) => {
      const itemElement = this.itemTemplate.cloneNode(true);
      const itemImage = itemElement.querySelector('img');
      itemElement.querySelector('button[data-open-modal]').addEventListener('click', () => {
        this.openPhotoSwipe(
          this.options.dataSource.findIndex((img) => img.src === (image.lightbox_url || image.image_url)),
          itemImage,
        );
      });

      itemImage.setAttribute('src', image.preview_url || '#');
      itemElement.querySelector('h3').innerHTML =
        `<a href="/pages/gallery?make=${item.make.slugify()}&model=${item.model.slugify()}">${[item.make, item.model].join(' ')}</a>`;
      itemElement.querySelector('p').innerHTML = [
        `<a href="/pages/gallery?${['make', 'model', 'year'].map((p) => `${p}=${item[p].slugify()}`).join('&')}">${item.year}</a>`,
        item.series,
        image.product?.location,
        image.product?.fabrication,
      ]
        .filter(Boolean)
        .join(' | ')
        .toLowerCase();
      this.container.appendChild(itemElement);
    });
  }

  render() {
    console.log('rendering');
    // this.container.innerHTML = '';
    this.pagination.data.forEach((item) => {
      this.renderItem(item);
    });
    if (this.pagination.data.length) {
      this.observer.observe(this.container.lastElementChild);
    } else {
      this.observer.disconnect();
    }
    if (this.pagination.data.length === 0) {
      this.container.innerHTML = '';
      if (this.emptyTemplate) {
        this.container.appendChild(this.emptyTemplate);
      }
    }
    // this.renderPagination();
  }

  renderPagination() {
    const paginationElement = this.querySelector('.pagination');
    paginationElement.innerHTML = '';

    // Create container for pagination
    const paginationContainer = document.createElement('div');
    paginationContainer.className = 'flex items-center gap-2';

    // Previous button
    const prevButton = document.createElement('button');
    prevButton.textContent = 'Previous';
    prevButton.disabled = !this.pagination.prev_page_url;
    prevButton.className = 'page-button';
    prevButton.addEventListener('click', () => {
      this.url = this.pagination.prev_page_url;
      this.loadItems();
    });
    paginationContainer.appendChild(prevButton);

    // Calculate page numbers to show
    const currentPage = this.pagination.current_page;
    const totalPages = Math.ceil(this.pagination.total / this.pagination.per_page);
    let pages = [];

    if (totalPages <= 8) {
      // Show all pages if less than or equal to 8
      pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      // Show first 3, current page with 2 before and after, and last 3
      const start = Math.max(1, currentPage - 2);
      const end = Math.min(totalPages, currentPage + 2);

      // Add first page
      pages.push(1);

      // Add ellipsis if needed
      if (start > 2) {
        pages.push('...');
      }

      // Add middle pages, skipping page 1 if already added
      for (let i = start; i <= end; i++) {
        if (i !== 1 && i !== totalPages) {
          pages.push(i);
        }
      }

      // Add ellipsis if needed
      if (end < totalPages - 1) {
        pages.push('...');
      }

      // Add last page
      pages.push(totalPages);
    }

    if (pages.length === 0) {
      // paginationContainer.innerHTML = '';
      // if (this.getAttribute('vehicle')) {
      //   this.setAttribute('vehicle', '');
      // }
      // document.querySelector('move-mmy').softReset();
      return;
    }

    // Create page number buttons
    pages.forEach((page) => {
      const button = document.createElement('button');
      button.textContent = page === '...' ? '...' : page;
      button.className = 'page-button';

      if (page === currentPage) {
        button.className += ' active';
        button.disabled = true;
      }

      if (page !== '...') {
        button.addEventListener('click', () => {
          this.builtUrl(page);
          this.loadItems();
        });
      }

      paginationContainer.appendChild(button);
    });

    // Next button
    const nextButton = document.createElement('button');
    nextButton.textContent = 'Next';
    nextButton.disabled = !this.pagination.next_page_url;
    nextButton.className = 'page-button';
    nextButton.addEventListener('click', () => {
      this.url = this.pagination.next_page_url;
      this.loadItems();
    });
    paginationContainer.appendChild(nextButton);

    paginationElement.appendChild(paginationContainer);
  }

  loadItems() {
    console.log('loading items');

    this.showLoader();
    this.fetchVehicleGallery()
      .then(() => {
        this.initPhotoSwipe();
        this.render();
      })
      .finally(this.hideLoader.bind(this));
  }

  openPhotoSwipe(startIndex, thumbEl) {
    if (startIndex === -1) {
      return;
    }
    this.pswp = new PhotoSwipe({
      dataSource: this.options.dataSource,
      index: startIndex,
      preload: [0, 0],
      loop: false,
      preloadFirstSlide: false,
      preloaderDelay: 100,
    });
    seedImageSize(this.options.dataSource[startIndex], thumbEl);
    enableLazySlideLoading(this.pswp);
    this.pswp.init();
    ensureSlideSize(this.pswp);
  }

  initPhotoSwipe() {
    // this.options.index = 0; // defines start slide index
    // this.options.dataSource = [];
    this.pagination.data
      .flatMap((item) => item.images)
      .forEach((galleryImage) => {
        this.options.dataSource.push({
          src: galleryImage.lightbox_url || galleryImage.image_url,
          alt: galleryImage.alt,
          ...(galleryImage.preview_url ? { msrc: galleryImage.preview_url } : {}),
          ...(galleryImage.width && galleryImage.height
            ? { width: galleryImage.width, height: galleryImage.height, hasRealSize: true }
            : {}),
        });
      });
  }

  builtUrl(page = 1) {
    const vehicle = this.getAttribute('vehicle') || '';
    const product = this.getAttribute('product') || '';
    const make = this.getAttribute('make') || '';
    const model = this.getAttribute('model') || '';
    const year = this.getAttribute('year') || '';
    const params = new URLSearchParams();
    params.set('limit', this.limit);
    params.set('page', page);
    if (!vehicle) {
      Object.entries({ make, model, year }).forEach(([key, value]) => {
        if (value) {
          params.set(key, value);
        }
      });
      this.url = `${BASE_URL}/api/vehicles/gallery?${params.toString()}`;
    } else {
      if (product) {
        this.url = `${BASE_URL}/api/vehicles/${vehicle}/gallery/${product}?${params.toString()}`;
      } else {
        this.url = `${BASE_URL}/api/vehicles/${vehicle}/gallery?${params.toString()}`;
      }
    }
    // console.log(`vehicle: ${vehicle}, product: ${product}, make: ${make}, model: ${model}, year: ${year}`);
    // console.log(this.url);
  }

  async fetchVehicleGallery() {
    if (!this.url) {
      this.builtUrl();
    }
    if (this.abortController) {
      this.abortController.abort('New request');
    }
    this.abortController = new AbortController();
    const response = await fetch(this.url, { signal: this.abortController.signal });
    const data = await response.json();
    this.pagination = data;
  }
}
if (!customElements.get('move-customer-gallery')) {
  customElements.define('move-customer-gallery', MoveCustomerGallery);
}
class MoveCustomerGallerySlider extends HTMLElement {
  static observedAttributes = ['vehicle', 'product', 'make', 'model', 'year', 'strategy'];

  constructor() {
    super();
    this.limit = 16;
    this.pagination = this.emptyPagination;
    this.items = [];
    this.url = null;
    this.pswp = null;
    this.hasPreRenderedItems = false;
    this.currentPage = 1;
    this.isLoadingMore = false;
    this.options = {
      index: 0,
      dataSource: [],
    };
    this.mmy = document.querySelector('move-mmy');
    this.addEventListener('reload', () => {
      this.pagination = this.emptyPagination;
      if (this.hasPreRenderedItems) {
        this.currentPage = 0;
        this.builtUrl();
        this.pagination.next_page_url = this.url;
      } else {
        this.container.innerHTML = '';
        this.currentPage = 1;
      }
      this.vehicleLookup();
      this.builtUrl();
      this.loadItems();
      this.hasPreRenderedItems = false;
    });
    this.emmitReload = debounce((vehicle) => {
      this.dispatchEvent(new CustomEvent('reload'));
    }, 300);
    this.addEventListener('click', this.handleClickOnViewImage.bind(this));
    this.mmy?.addEventListener('vehicle:changed', this.emmitReload.bind(this));
    this.addEventListener('reached.end', this.handleScrollEnd.bind(this));
  }

  handleClickOnViewImage({ target }) {
    const image = target.closest('.community-bumper-card')?.querySelector('img');
    if (target.dataset.hasOwnProperty('openModal') && image) {
      this.handleOpenImage(image);
    }
  }

  handleScrollEnd() {
    if (!this.isLoadingMore && this.pagination.next_page_url) {
      this.loadMoreItems();
    }
  }

  get slider() {
    return this.querySelector('edm-slider');
  }

  get sliderInner() {
    return this.querySelector('edm-slider .inner');
  }

  get hasExistingItems() {
    const slides = this.sliderInner?.querySelectorAll('.slide');
    return slides && slides.length > 0;
  }

  vehicleLookup() {
    if (this.getAttribute('strategy') === 'manual') {
      return;
    }
    this.incorporateVehicle() || this.determineVehicle();
  }

  get emptyPagination() {
    return {
      current_page: 1,
      data: [],
      first_page_url: '',
      last_page_url: '',
      next_page_url: '',
      prev_page_url: '',
      total: 0,
      from: 0,
      to: 0,
      per_page: this.limit,
    };
  }

  get container() {
    return this.querySelector('.gallery-container');
  }

  get loaderTemplate() {
    return this.querySelector('template#loader').content.cloneNode(true);
  }

  get itemTemplate() {
    return this.querySelector('template#gallery-card').content.cloneNode(true);
  }

  get emptyTemplate() {
    return this.querySelector('template#gallery-empty')?.content?.cloneNode(true);
  }

  get modal() {
    return this.querySelector('dialog');
  }

  connectedCallback() {
    this.vehicleLookup();
    if (this.hasExistingItems) {
      this.hasPreRenderedItems = true;
    }
  }

  async loadMoreItems() {
    if (this.isLoadingMore) return;
    this.isLoadingMore = true;

    try {
      this.currentPage++;
      this.builtUrl(this.currentPage);
      const response = await fetch(this.url);
      const data = await response.json();

      this.pagination.data = [...this.pagination.data, ...data.data];
      this.pagination.next_page_url = data.next_page_url;

      data.data.forEach((item) => {
        this.renderItem(item);
      });

      this.initPhotoSwipe();
      this.querySelector('edm-slider')?.init();
    } catch (e) {
      console.error('Failed to load more items:', e);
      this.currentPage--;
    } finally {
      this.isLoadingMore = false;
    }
  }

  determineVehicle() {
    try {
      const vehicle = JSON.parse(localStorage.getItem('vehicle'));
      if (vehicle && vehicle.sku) {
        if (this.getAttribute('vehicle') !== vehicle.sku) {
          this.setAttribute('vehicle', vehicle.sku);
        }
      }
    } catch (e) {}
  }

  incorporateVehicle() {
    if (this.mmy instanceof MoveMMY && this.mmy.selectedVehicle) {
      if (this.getAttribute('vehicle') !== this.mmy.selectedVehicle.sku) {
        this.setAttribute('vehicle', this.mmy.selectedVehicle.sku);
      }
      return true;
    }
    return false;
  }

  showLoader() {
    this.container.innerHTML = '';
    this.loader = this.container.appendChild(this.loaderTemplate.firstElementChild);
  }

  hideLoader() {
    this.container.removeChild(this.loader);
  }

  handleOpenImage(image) {
    const startIndex = this.options.dataSource.findIndex((img) => img.src === image.dataset.url);
    if (startIndex === -1) {
      return;
    }
    this.openPhotoSwipe(startIndex, image);
  }

  openPhotoSwipe(startIndex, thumbEl) {
    this.options.index = startIndex;
    seedImageSize(this.options.dataSource[startIndex], thumbEl);
    this.pswp = new PhotoSwipe({
      ...this.options,
      dataSource: this.options.dataSource,
      index: startIndex,
      preload: [0, 0],
      loop: false,
      preloadFirstSlide: false,
      preloaderDelay: 100,
    });
    enableLazySlideLoading(this.pswp, () => {
      this.options.index = this.pswp.currIndex;
    });
    this.pswp.init();
    ensureSlideSize(this.pswp);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.emmitReload();
  }

  renderItem(item) {
    item.images.forEach((image) => {
      const itemElement = this.itemTemplate.cloneNode(true);
      const itemImage = itemElement.querySelector('img');
      itemImage.setAttribute('src', image.preview_url || '#');
      itemImage.dataset.url = image.lightbox_url || image.image_url;
      const title = [item.vehicle?.make || item.make, item.vehicle?.model || item.model]
        .map((v) => String(v).titleCase())
        .join(' ');
      const description = [
        item.vehicle?.year || item.year,
        image.product?.series || item.series,
        image.product?.location,
        image.product?.fabrication,
      ]
        .filter(Boolean)
        .map((v) => String(v).titleCase())
        .join(' | ')
        .toLowerCase();
      itemElement.querySelector('p:first-child').textContent = title;
      itemElement.querySelector('p:last-child').textContent = description;
      itemImage.alt =
        `${item.vehicle?.make || item.make} ${item.vehicle?.model || item.model} ${item.vehicle?.year || item.year} with a ${image.product?.series || item.series} ${image.product?.location} ${image.product?.fabrication} bumper kit`.titleCase();
      this.container.querySelector('edm-slider .inner').appendChild(itemElement);
    });
  }

  render() {
    this.container.innerHTML = '<edm-slider><div class="inner"></div></edm-slider>';
    this.pagination.data.forEach((item) => {
      this.renderItem(item);
    });
    this.container.querySelector('edm-slider').init();
    if (this.pagination.data.length === 0) {
      this.container.innerHTML = '';
      if (this.emptyTemplate) {
        this.container.appendChild(this.emptyTemplate);
      }
    }
  }

  loadItems() {
    if (this.hasPreRenderedItems) {
      this.initPhotoSwipeFromExistingItems();
      this.querySelector('edm-slider')?.init();
      return;
    }
    this.showLoader();
    this.fetchVehicleGallery().then(() => {
      this.initPhotoSwipe();
      this.render();
    });
    // .finally(this.hideLoader.bind(this));
  }

  initPhotoSwipeFromExistingItems() {
    this.options.index = 0;
    this.options.dataSource = [];
    const slider = this.querySelector('edm-slider');
    if (!slider) return;

    slider.querySelectorAll('img').forEach((img) => {
      this.options.dataSource.push({
        src: img.dataset.url,
        alt: img.alt || 'Community Bumper Image',
        ...(img.src ? { msrc: img.src } : {}),
      });
    });
  }

  initPhotoSwipe() {
    if (!this.hasExistingItems) {
      this.options.index = 0; // defines start slide index
      this.options.dataSource = [];
    }
    this.pagination.data
      .flatMap((item) => item.images)
      .forEach((galleryImage) => {
        this.options.dataSource.push({
          src: galleryImage.lightbox_url || galleryImage.image_url,
          alt: galleryImage.alt,
          ...(galleryImage.preview_url ? { msrc: galleryImage.preview_url } : {}),
          ...(galleryImage.width && galleryImage.height
            ? { width: galleryImage.width, height: galleryImage.height, hasRealSize: true }
            : {}),
        });
      });
  }

  builtUrl(page = 1) {
    const vehicle = this.getAttribute('vehicle') || '';
    const product = this.getAttribute('product') || '';
    const make = this.getAttribute('make') || '';
    const model = this.getAttribute('model') || '';
    const year = this.getAttribute('year') || '';
    const params = new URLSearchParams();
    params.set('limit', this.limit);
    params.set('page', page);
    if (!vehicle) {
      Object.entries({ make, model, year }).forEach(([key, value]) => {
        if (value) {
          params.set(key, value);
        }
      });
      this.url = `${BASE_URL}/api/vehicles/gallery?${params.toString()}`;
    } else {
      if (product) {
        this.url = `${BASE_URL}/api/vehicles/${vehicle}/gallery/${product}?${params.toString()}`;
      } else {
        this.url = `${BASE_URL}/api/vehicles/${vehicle}/gallery?${params.toString()}`;
      }
    }
    return this.url;
  }

  async fetchVehicleGallery() {
    if (!this.url) {
      this.builtUrl();
    }
    if (this.abortController) {
      this.abortController.abort('New request');
    }
    this.abortController = new AbortController();
    const response = await fetch(this.url, { signal: this.abortController.signal });
    const data = await response.json();
    this.pagination = data;
  }
}
if (!customElements.get('move-customer-gallery-slider')) {
  customElements.define('move-customer-gallery-slider', MoveCustomerGallerySlider);
}

class FabricatorForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[type=submit]');
  }

  connectedCallback() {
    this.form.country.addEventListener('change', () => {
      const regions = JSON.parse(this.form.country.selectedOptions.item(0).dataset.regions);
      Array.from(this.form.state.options)
        .slice(1)
        .forEach((option) => option.remove());
      this.form.state.value = '';
      regions.forEach(([isoCode, region]) => {
        const option = document.createElement('option');
        option.value = isoCode;
        option.textContent = region;
        this.form.state.appendChild(option);
      });
    });
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.handleSubmit();
    });
  }

  get alert() {
    return this.querySelector('[role=alert]');
  }

  handleSubmit() {
    const url = `${FABRICATORS_API_BASE_URL}/register`;
    this.submitButton.disabled = true;
    fetch(url, {
      method: 'POST',
      body: new FormData(this.form),
      headers: {
        Accept: 'application/json',
      },
    })
      .then(async (resp) => {
        if (resp.ok) {
          return await resp.json();
        }
        throw await resp.json();
      })
      .then((resp) => {
        this.alert.classList.remove('hidden');
        this.alert.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.form.reset();
      })
      .catch((err) => {
        console.log(err);
        this.alert.classList.add('hidden');
        alert(err.message);
      })
      .finally(() => {
        this.submitButton.disabled = false;
      });
  }
}

if (!customElements.get('fabricator-form')) {
  customElements.define('fabricator-form', FabricatorForm);
}

class MoveSearchField extends HTMLElement {
  static formAssociated = true;
  static observedAttributes = ['value', 'placeholder', 'label', 'error', 'name'];
  #internals;
  constructor() {
    super();
    this.#internals = this.attachInternals();
  }

  get input() {
    return this.shadowRoot.querySelector('input');
  }

  get form() {
    return this.closest('form');
  }

  get label() {
    return this.shadowRoot.querySelector('label');
  }

  connectedCallback() {
    this.input.addEventListener('input', () => {
      this.#internals.setFormValue(this.input.value);
      this.form.submit();
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    try {
      this[`handle${name[0].toUpperCase() + name.slice(1)}Change`](newValue, oldValue, name);
    } catch (e) {
      console.log(e.message);
    }
  }

  handlePlaceholderChange(value) {
    this.input.setAttribute('placeholder', value);
  }

  handleValueChange(value) {
    this.input.value = value;
  }

  handleLabelChange(value) {
    this.input.setAttribute('aria-label', value);
    this.label.innerHTML = value;
  }

  handleNameChange(value) {
    this.input.setAttribute('name', value);
  }
}

if (!customElements.get('move-search-field')) {
  customElements.define('move-search-field', MoveSearchField);
}

document.addEventListener('DOMContentLoaded', () => {
  // const anchor = document.querySelector('.form__get-listed a');
  // if (anchor) {
  //   anchor.href = '/pages/fabricator-register?view=fabricator-register';
  // }
  document.querySelectorAll('.profile-block').forEach((block) => {
    block.addEventListener('click', () => {
      block.classList.toggle('is-active');
    });
  });
  document.querySelector('.zendesk-button').addEventListener('click', (e) => {
    e.preventDefault();
    zE.activate();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const fabricatorSection = document.querySelector('.fabricator');
  if (!fabricatorSection) return;

  const mapEl = document.getElementById('map');
  const fabricatorItems = document.querySelectorAll('[data-fabricator-item]');
  const markers = [];
  let map;
  let infoWindow = null;

  function createMap() {
    map = new google.maps.Map(mapEl, {
      center: { lat: 20.5937, lng: 78.9629 }, // Default to center of India
      zoom: 5,
    });
  }

  function addMarker(element, lat, lng, bubbleContent) {
    const position = new google.maps.LatLng(lat, lng);

    const marker = new google.maps.Marker({
      position,
      map,
      icon: {
        url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
      },
    });

    const bubble = new google.maps.InfoWindow({
      content: bubbleContent,
    });

    marker.addListener('click', () => {
      if (infoWindow) infoWindow.close();
      infoWindow = bubble;
      bubble.open(map, marker);
    });

    markers.push({ marker, element, position });
  }

  function panToMarker(position) {
    map.panTo(position);
    map.setZoom(10); // or adjust as needed
  }

  function fitMapToMarkers() {
    const bounds = new google.maps.LatLngBounds();
    markers.forEach(({ position }) => bounds.extend(position));
    map.fitBounds(bounds);
  }

  createMap();

  // Loop through each fabricator item and create marker
  fabricatorItems.forEach((item) => {
    const lat = parseFloat(item.querySelector('.address').dataset.lat);
    const lng = parseFloat(item.querySelector('.address').dataset.long);
    const bubbleContent = item.querySelector('[data-map-bubble]').innerHTML;

    addMarker(item, lat, lng, bubbleContent);

    // Hover effect to pan to marker
    item.addEventListener('mouseover', () => {
      const markerData = markers.find((m) => m.element === item);
      if (markerData) panToMarker(markerData.position);
    });

    // Click on link to pan to marker
    const panToLink = item.querySelector('[data-pan-to]');
    if (panToLink) {
      panToLink.addEventListener('click', (e) => {
        e.preventDefault();
        const markerData = markers.find((m) => m.element === item);
        if (markerData) panToMarker(markerData.position);
      });
    }
  });

  fitMapToMarkers(); // Auto zoom to fit all markers
});

document.addEventListener('DOMContentLoaded', function () {
  const truckInfoForm = document.querySelector('.truck-info');
  const mmy = document.querySelector('move-mmy');

  if (truckInfoForm && mmy && mmy instanceof MoveMMY) {
    const makeSelect = document.querySelector('select#make');
    const modelSelect = document.querySelector('select#model');
    const yearSelect = document.querySelector('select#year');
    mmy.addEventListener('vehicles:loaded', () => {
      const makes = mmy.allVehicles
        .map((vehicle) => vehicle.make)
        .filter((value, index, self) => self.indexOf(value) === index);
      makeSelect.innerHTML = '<option value="">Select Make</option>';
      makes.forEach((make) => {
        const option = document.createElement('option');
        option.value = make;
        option.textContent = make;
        option.selected = make === JSON.parse(localStorage.getItem('vehicle'))?.make;
        makeSelect.appendChild(option);
      });

      makeSelect.addEventListener('input', () => {
        const selectedMake = makeSelect.value;
        const models = mmy.allVehicles
          .filter((vehicle) => vehicle.make === selectedMake)
          .map((vehicle) => vehicle.model)
          .filter((value, index, self) => self.indexOf(value) === index);

        modelSelect.innerHTML = '<option value="">Select Model</option>';
        models.forEach((model) => {
          const option = document.createElement('option');
          option.value = model;
          option.textContent = model;
          option.selected = model === JSON.parse(localStorage.getItem('vehicle'))?.model;
          modelSelect.appendChild(option);
        });
        modelSelect.dispatchEvent(new Event('input', { bubbles: true }));
      });

      modelSelect.addEventListener('input', () => {
        const selectedModel = modelSelect.value;
        const years = mmy.allVehicles
          .filter((vehicle) => vehicle.model === selectedModel)
          .map((vehicle) => vehicle.year)
          .filter((value, index, self) => self.indexOf(value) === index);

        yearSelect.innerHTML = '<option value="">Select Year</option>';
        years.forEach((year) => {
          const option = document.createElement('option');
          option.value = year;
          option.textContent = year;
          option.selected = year === JSON.parse(localStorage.getItem('vehicle'))?.year;
          yearSelect.appendChild(option);
        });
      });

      makeSelect.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }
});

async function fetchData(url) {
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  }).then((resp) => {
    if (resp.ok) {
      return resp.json();
    }
    throw new Error(resp.statusText);
  });
}

// Load existing customizations
document.addEventListener('DOMContentLoaded', async function () {
  const params = new URLSearchParams(window.location.search);
  const customizationId = params.get('customization_id');
  if (customizationId) {
    const customizerModal = document.querySelector('customizer-modal');
    if (customizerModal instanceof CustomizerModal) {
      const customization = await fetchData(`${BASE_URL}/api/customizations/${customizationId}`);
      customizerModal.selectedVehicle = customization.vehicle;
      customizerModal.selectedProduct = customization.product;
      customizerModal.selectedCompanions = customization.companion_skus;
      customizerModal.meta = customization.meta;
      customizerModal.open('move-customizer-step-3-new');
    }
  }
});

// Load customizer with query string
document.addEventListener('DOMContentLoaded', async function () {
  const params = new URLSearchParams(window.location.search);
  if (params.get('open') === 'customizer') {
    const customizerModal = document.querySelector('customizer-modal');
    if (customizerModal instanceof CustomizerModal) {
      const customization = await fetchData(`${BASE_URL}/api/customizer?${params.toString()}`);
      const mmyEle = document.querySelector('move-mmy');
      if (mmyEle instanceof MoveMMY) {
        mmyEle.storeVehicle(customization.vehicle);
      }
      customizerModal.selectedVehicle = customization.vehicle;
      customizerModal.selectedProduct = customization.product;
      customizerModal.selectedCompanions = customization.companion_skus;
      customizerModal.meta = customization.meta;
      customizerModal.open('move-customizer-step-3-new');
    }
  }
});

// Update product detail form
document.addEventListener('DOMContentLoaded', function () {
  try {
    if (!window.location.pathname.includes('products')) {
      return;
    }
    const productForm = document.querySelector('form.shopify-product-form:has(button[type=submit])');
    if (!productForm) {
      return;
    }
    const button = productForm.querySelector('button[type=submit]');
    // button.disabled = true;
    const vehicle = JSON.parse(localStorage.getItem('vehicle'));
    productForm.elements['properties[Make]'].value = vehicle?.make;
    productForm.elements['properties[Model]'].value = vehicle?.model;
    productForm.elements['properties[Year]'].value = vehicle?.year;
    productForm.elements['properties[_vehicle]'].value = vehicle?.make + ' ' + vehicle?.model + ' ' + vehicle?.year;
    productForm.elements['properties[_mmy]'].value = vehicle?.make + ' ' + vehicle?.model + ' ' + vehicle?.year;

    const fetchVehicleProduct = async () => {
      const sku = vehicle.sku + productForm.dataset.sku;
      const url = `${BASE_URL}/api/vehicles/${sku}/products`;
      return fetchData(url)
        .then((product) => {
          return product;
        })
        .catch((e) => {
          return null;
        });
    };
    fetchVehicleProduct().then((product) => {
      if (product) {
        // Update elements for cart
        // productForm.elements['properties[_title]'].value = product.title;
        productForm.elements['properties[_companions]'].value = JSON.stringify(product.companions);
        productForm.elements['properties[_companion_order]'].value = product.companions
          .map(({ detail }) => detail?.title)
          .join(',');
        productForm.elements['properties[_merchandise_id]'].value = product.detail?.shopify_variant_id;
        productForm.elements['properties[_expanded_items]'].value = product.companions
          .map(({ detail }) => 'gid://shopify/ProductVariant/' + detail.shopify_variant_id)
          .join(',');
        productForm.elements['properties[_expanded_items_price]'].value = product.companions
          .map(({ detail }) => detail?.price ?? '0.00')
          .join(',');
        productForm.elements['properties[_companion_names]'].value = product.companions
          .map(({ detail }) => detail?.title)
          .join(',');
        productForm.elements['properties[_companion_images]'].value = [
          product?.detail?.images?.sort(imageOrder)?.at(0)?.url || '',
        ]
          .concat(
            product.companions.map(
              ({ detail }) => detail?.images?.sort(imageOrder)?.at(0)?.url || detail?.customizer_image_url || '',
            ),
          )
          .join(',');
        productForm.elements['properties[_companion_selection]'].value = product.companions
          .map(({ selection1, selection2 }) => `${selection1}|${selection2}`)
          .join(',');
        productForm.elements['properties[_companion_selection_text]'].value = product.companions
          .map(({ detail: { selection1_text, selection2_text } }) => `${selection1_text}|${selection2_text}`)
          .join(',');
        productForm.elements['properties[_requires_welding]'].value = (
          product.fabrication === 'Weld It Yourself' || product.tags.includes('WELD')
        ).toString();

        button.disabled = false;

        // const submitButton = productForm.querySelector('button[type="submit"]');
        // const getStartedButton = productForm.querySelector('button[data-toggle="modal"]');
        // if (product.companions.length > 0) {
        //   submitButton?.classList?.add('hidden');
        //   getStartedButton?.classList?.remove('hidden');
        // } else {
        //   submitButton?.classList?.remove('hidden');
        //   getStartedButton?.classList?.add('hidden');
        // }
      }
    });
  } catch (e) {
    console.log(e, 'some error');
  }
});

// Ask vehicle info on collection page if not cookied
document.addEventListener('DOMContentLoaded', async function () {
  const path = window.location.pathname.split('/').at(-2).toLowerCase();
  const cookied = JSON.parse(localStorage.getItem('vehicle'));
  const params = new URLSearchParams(window.location.search);
  if ((path === 'collections' || path === 'products') && !cookied && window.templateSuffix === 'customizer') {
    if (path === 'collections') {
      const collectionId = document.querySelector('meta[name="collection_id"]')?.content;
      if (collectionId) {
        return;
      }
      // await fetch(`${BASE_URL}/api/vehicles?collection_id=${collectionId}`)
      //   .then((res) => res.json())
      //   .then(([vehicle]) => {
      //     if (vehicle) {
      //       localStorage.setItem('vehicle', JSON.stringify(vehicle));
      //     }
      //   });
    }
    const modal = document.querySelector('customizer-modal');
    window.addEventListener(
      'scroll',
      () => {
        const cookied = JSON.parse(localStorage.getItem('vehicle'));
        if (!cookied) {
          modal.open('move-customizer-step-1');
        }
      },
      { once: true },
    );
    const handleModalClosing = (e) => {
      e.preventDefault();
      window.location.href = '/';
    };
    modal.addEventListener('modal:closing', handleModalClosing);
    const handleModalOpening = () => {
      const step = modal.querySelector('customizer-step1');
      modal.querySelector('form button[type="submit"]').addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = modal.querySelector('form');
        const data = Object.fromEntries(new FormData(form));
        const keys = ['make', 'model', 'year'];
        const vehicle = step.allVehicles.find((vehicle) => keys.every((key) => vehicle[key] === data[key]));
        step.setSelectedVehicle(vehicle);
        window.location.reload();
      });
      modal.removeEventListener('modal:opening', handleModalOpening);
    };
    modal.addEventListener('modal:opened', handleModalOpening);
  }
});

class MoveMobileMenu extends HTMLElement {
  constructor() {
    super();
  }

  get header() {
    return this.closest('header');
  }

  get body() {
    return document.querySelector('body');
  }

  get toggleButtons() {
    return document.querySelectorAll('button.mobile-menu-toggle');
  }

  isOpened() {
    return this.body.classList.contains('mobile-menu-opened');
  }

  toggle() {
    this.body.classList.toggle('mobile-menu-opened');
  }

  connectedCallback() {
    this.toggleButtons.forEach((button) =>
      button.addEventListener('click', () => {
        this.toggle();
      }),
    );

    this.querySelectorAll('li:has(ul)').forEach((li) => {
      li.addEventListener('click', () => {
        if (!li.hasAttribute('open')) {
          li.setAttribute('open', 'open');
        }
      });
    });

    this.querySelectorAll('[data-toggle="list"]').forEach((toggler) => {
      toggler.addEventListener('click', (e) => {
        e.stopPropagation();
        toggler.closest('li').removeAttribute('open');
      });
    });
  }
}

if (!customElements.get('move-mobile-menu')) {
  customElements.define('move-mobile-menu', MoveMobileMenu);
}

class ReadMoreContent extends HTMLElement {
  stateName = 'expanded';
  container;
  #internals;
  constructor() {
    super();
    this.#internals = this.attachInternals();
    window.addEventListener('resize', () => {
      this.style.setProperty('--content-height', this.container.scrollHeight + 'px');
    });
  }

  hasMoreContent() {
    return this.container.clientHeight < this.container.scrollHeight;
  }

  toggleContent() {
    if (this.#internals.states.has(this.stateName)) {
      this.#internals.states.delete(this.stateName);
    } else {
      this.#internals.states.add(this.stateName);
    }
    requestAnimationFrame(() => this.determineToggleButtonState());
  }

  determineToggleButtonState() {
    this.setAttribute(
      'data-after-content',
      this.#internals.states.has(this.stateName)
        ? this.dataset.readLess || 'Read less'
        : this.dataset.readMore || 'Read more',
    );
  }

  makeContainer() {
    this.container = document.createElement('div');
    this.container.innerHTML = this.innerHTML;
    this.innerHTML = '';
    this.appendChild(this.container);
  }

  connectedCallback() {
    this.style.setProperty('--line-clamp', this.dataset.lineClamp || 3);
    this.style.setProperty('--line-height', this.dataset.lineHeight || '1.5em');
    this.makeContainer();
    this.style.setProperty('--content-height', this.container.scrollHeight + 'px');
    if (this.hasMoreContent()) {
      this.classList.add('has-more-content');
    }
    this.determineToggleButtonState();
    this.addEventListener('click', (e) => {
      if (e.target === this) {
        this.toggleContent();
      }
    });
  }
}

if (!customElements.get('read-more-content')) {
  customElements.define('read-more-content', ReadMoreContent);
}

class InfoSlider extends HTMLElement {
  constructor() {
    super();
  }

  get slides() {
    return Array.from(this.querySelectorAll('.slide'));
  }

  get currentSlide() {
    return this.querySelector('.slide.active');
  }

  getCurrentSlideIndex() {
    return this.slides.indexOf(this.currentSlide);
  }

  get slideCount() {
    return this.querySelectorAll('.slide').length;
  }

  next() {
    const currentIndex = this.getCurrentSlideIndex();
    const index = (currentIndex - 1 + this.slideCount) % this.slideCount;
    this.currentSlide.classList.remove('active');
    this.slides[index].classList.add('active');
    this.updateButtonState(index);
  }

  updateButtonState(index) {
    this.currentSlide.querySelector('.prev-btn').disabled = index === 0;
    this.currentSlide.querySelector('.next-btn').disabled = index === this.slideCount - 1;
  }

  previous() {
    const currentIndex = this.getCurrentSlideIndex();
    const index = (currentIndex - 1 + this.slideCount) % this.slideCount;
    this.currentSlide.classList.remove('active');
    this.slides[index].classList.add('active');
    this.updateButtonState(index);
  }

  connectedCallback() {
    this.slides.forEach((slide) => {
      slide.querySelector('.next-btn').addEventListener('click', this.next.bind(this));
      slide.querySelector('.prev-btn').addEventListener('click', this.previous.bind(this));
    });
  }
}

if (!customElements.get('info-slider')) {
  customElements.define('info-slider', InfoSlider);
}

async function customConfirm({ heading, body, buttonText, confirmUrl } = {}) {
  return new Promise((resolve, reject) => {
    const modal = document.getElementById('confirm-modal');
    try {
      if (heading) {
        modal.querySelector('h3').textContent = heading;
      }
      if (body) {
        modal.querySelector('p').innerHTML = body;
      }
      if (buttonText) {
        modal.querySelector('button[value=confirm]').textContent = buttonText;
      }
      modal.showModal();
    } catch (e) {
      reject(e);
    }
    if (confirmUrl) {
      const confirmButton = modal.querySelector('button[value=confirm]');
      if (confirmButton) {
        const a = document.createElement('a');
        a.href = confirmUrl;
        a.className = confirmButton.className;
        a.textContent = confirmButton.textContent;
        confirmButton.replaceWith(a);
      }
    }
    const handleClose = () => {
      resolve(modal.returnValue);
      modal.removeEventListener('close', handleClose);
    };
    modal.addEventListener('close', handleClose);
  });
}

async function askConsent({ heading, body, saveText, confirmText, confirmUrl } = {}) {
  return new Promise((resolve, reject) => {
    const modal = document.getElementById('ask-consent');
    try {
      if (heading) {
        modal.querySelector('p.heading').innerHTML = heading;
      }
      if (body) {
        modal.querySelector('p.body').innerHTML = body;
      }
      if (confirmText) {
        modal.querySelector('button[value=confirm]').innerHTML = confirmText;
      }
      if (saveText) {
        modal.querySelector('button[value=save]').innerHTML = saveText;
      }
      modal.showModal();
    } catch (e) {
      reject(e);
    }
    if (confirmUrl) {
      const confirmButton = modal.querySelector('button[value=confirm]');
      if (confirmButton) {
        const a = document.createElement('a');
        a.href = confirmUrl;
        a.className = confirmButton.className;
        a.textContent = confirmButton.textContent;
        confirmButton.replaceWith(a);
      }
    }
    const handleClose = () => {
      resolve(modal.returnValue);
      modal.removeEventListener('close', handleClose);
    };
    modal.addEventListener('close', handleClose, { once: true });
  });
}

class FitsOnVehicleCard extends HTMLElement {
  constructor() {
    super();
    this.modal = this.getModal();
  }

  getModal() {
    const m = document.querySelector('customizer-modal');
    if (m instanceof CustomizerModal) {
      return m;
    }
    return null;
  }

  get vehicle() {
    return this.modal.selectedVehicle;
  }

  connectedCallback() {
    this.determine();
    document.addEventListener('vehicle:changed', this.determine.bind(this));
  }

  determine() {
    this.fetchVehicleProduct()
      .then((product) => {
        if (product) {
          this.classList.add('active');
          this.classList.remove('inactive');
        } else {
          this.classList.add('inactive');
          this.classList.remove('active');
          document.querySelector('.product-page-button')?.remove();
          document.querySelector('shopify-payment-terms')?.remove();
        }
        this.querySelector('p:nth-child(2)').textContent =
          this.vehicle.make + ' ' + this.vehicle.model + ' ' + this.vehicle.year;
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async fetchVehicleProduct() {
    const sku = this.vehicle.sku + this.dataset.productSku;
    const url = `${BASE_URL}/api/vehicles/${sku}/products`;
    return fetchData(url)
      .then((product) => {
        return product;
      })
      .catch((e) => {
        return null;
      });
  }
}

if (!customElements.get('fits-on-vehicle-card')) {
  customElements.define('fits-on-vehicle-card', FitsOnVehicleCard);
}

class UpgradeOptions extends HTMLElement {
  static observedAttributes = ['product-sku'];

  constructor() {
    super();
    this.product = null;
  }

  // attributeChangedCallback(name, oldValue, newValue) {
  //   if (name === 'product-sku') {
  //     this.fetchVehicleProduct();
  //   }
  // }

  get vehicle() {
    try {
      return JSON.parse(localStorage.getItem('vehicle'));
    } catch (e) {
      return null;
    }
  }

  connectedCallback() {
    this.fetchVehicleProduct();
    this.template = this.querySelector('template').content.cloneNode(true);
    // document.addEventListener('vehicle:changed', this.fetchVehicleProduct.bind(this));
  }

  updateOptions() {
    this.innerHTML = '';
    const cards = this.template.cloneNode(true);
    const cardsToBeRemoved = [];
    for (const card of cards.children) {
      const list = card.querySelectorAll('ul li');
      const itemsToBeRemoved = [];
      for (const item of list) {
        const { keyword, path } = item.dataset;
        const isPresent = this.product.companions.some((comp) => new RegExp(keyword, 'gi').test(comp[path]));
        if (!isPresent) {
          itemsToBeRemoved.push(item);
        }
      }
      if (list.length === itemsToBeRemoved.length) {
        cardsToBeRemoved.push(card);
      }
      itemsToBeRemoved.forEach((item) => item.remove());
    }
    cardsToBeRemoved.forEach((card) => card.remove());
    if (cards.children.length > 0) {
      this.appendChild(cards);
    } else {
      this.closest('move-accordion').remove();
    }
  }

  async fetchVehicleProduct() {
    try {
      const sku = this.vehicle.sku + this.getAttribute('product-sku');
      const url = `${BASE_URL}/api/vehicles/${sku}/products`;
      this.product = await fetchData(url);
      this.updateOptions();
    } catch (e) {
      this.product = null;
      this.closest('move-accordion').remove();
    }
  }
}
if (!customElements.get('upgrade-options')) {
  customElements.define('upgrade-options', UpgradeOptions);
}

// import { EdmSlider } from './edm-slider.js';
if (customElements.get('edm-slider') === undefined) {
  customElements.define('edm-slider', EdmSlider);
}

async function updateCart(lineItemKey, quantity) {
  console.log(lineItemKey, quantity);
  const url = `${Shopify.routes.root}cart/change.js`;
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: lineItemKey,
      quantity: quantity,
    }),
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      } else {
        const data = await response.json();
        window.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: data,
          }),
        );
      }
    })
    .catch((error) => {
      console.error('Error updating line item:', error);
    });
}

window.addEventListener('cart:updated', ({ detail }) => {
  const countEle = document.querySelector('.cart-items-count');
  if (countEle) {
    countEle.dataset.count = detail.item_count;
  }
});

// cart
document.addEventListener('click', function (event) {
  let target;
  if (event.target.dataset.cartAction) {
    event.preventDefault();
    target = event.target;
  } else if (event.target.closest('[data-cart-action]')) {
    event.preventDefault();
    target = event.target.closest('[data-cart-action]');
  }
  if (target) {
    const action = target.dataset.cartAction;
    const lineItemKey = target.dataset.lineItem;
    const quantity = target.dataset.quantity;
    const section = target.closest('.shopify-section');
    const sectionId = section.id.replace('shopify-section-', '');
    const loadSection = async () => {
      const html = await fetch(Shopify.routes.root + 'cart?section_id=' + sectionId).then((resp) => resp.text());
      const dom = new DOMParser().parseFromString(html, 'text/html');
      Array.from(document.querySelectorAll('.move-cart-items-section')).forEach((s) => {
        let container = s.querySelector('.cart-items-overflow-container');
        const containerScrollX = container.scrollLeft;
        const containerScrollY = container.scrollTop;
        const windowScrollX = window.scrollX;
        const windowScrollY = window.scrollY;
        s.innerHTML = dom.querySelector(`[id="${section.id}"]`).innerHTML;
        container = s.querySelector('.cart-items-overflow-container');
        container?.scrollTo({ top: containerScrollY, left: containerScrollX, behavior: 'instant' });
        window.scrollTo({ top: windowScrollY, left: windowScrollX, behavior: 'instant' });
      });
    };

    switch (action) {
      case 'update':
        target.closest('.group').classList.add('loading');
        updateCart(lineItemKey, quantity).then(loadSection);
        break;
      case 'remove':
        // removeCart(lineItemKey);
        break;
    }
  }
});

class MoveInstructions extends MoveMMY {
  constructor() {
    super();
    this.products = [];
  }

  connectedCallback() {
    super.connectedCallback();
    this.productSelect = this.querySelector('select[name="product"]');
    this.loadProducts();
  }

  get container() {
    return this.querySelector('.container');
  }

  async loadProducts() {
    const url = `${BASE_URL}/api/products/kits`;
    this.products = await fetchData(url);
    this.updateProducts();
  }

  updateProducts() {
    this.productSelect.innerHTML = '';
    this.productSelect.appendChild(new Option('Product', ''));
    this.products.forEach((product) => {
      this.productSelect.appendChild(new Option(product.detail.title, product.id));
    });
  }

  determineSubmitButtonState() {
    return this.productSelect.value && super.determineSubmitButtonState();
  }

  get product() {
    return this.products.find((product) => Number(product.id) === Number(this.productSelect.value));
  }

  submit(e) {
    e.preventDefault();
    this.submitButton.disabled = true;
    this.container.innerHTML = 'Finding Instructions...';
    const url = `${BASE_URL}/api/vehicles/${this.vehicle.sku}/instructions/${this.product.sku}`;
    fetchData(url)
      .then(async (instruction) => {
        const anchors = [];
        if (instruction.product.instructions_pdf_url) {
          anchors.push(
            fetch(instruction.product.instructions_pdf_url).then(async (resp) => {
              const blob = await resp.blob();
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = instruction.product.instructions_pdf_url.split('/').pop();
              a.innerHTML = [instruction.product.detail?.title, 'General Instructions'].join(' ');
              return a;
            }),
          );
        }
        if (instruction.instructions_pdf_url) {
          anchors.push(
            await fetch(instruction.instructions_pdf_url).then(async (resp) => {
              const blob = await resp.blob();
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = instruction.instructions_pdf_url.split('/').pop();
              a.innerHTML = [
                instruction.vehicle.title,
                instruction.product.detail?.title,
                'Specific Instructions',
              ].join(' ');
              return a;
            }),
          );
        }
        anchors.push(
          new Promise((resolve) => {
            const a = document.createElement('a');
            a.innerHTML = 'How-To Build Videos';
            a.href = instruction.how_to_build_page_url;
            resolve(a);
          }),
        );
        Promise.all(anchors).then((anchors) => {
          this.container.innerHTML = '';
          anchors.forEach((anchor) => this.container.appendChild(anchor));
        });
      })
      .finally(() => {
        this.submitButton.disabled = false;
      });
  }
}

if (!customElements.get('move-instructions')) {
  customElements.define('move-instructions', MoveInstructions);
}
class MoveProductInstructions extends HTMLElement {
  #template;
  constructor() {
    super();
    this.mmy = document.querySelector('move-mmy');
    this.mmy.addEventListener('vehicle:changed', this.incorporateVehicle.bind(this));
    this.init = debounce(this.fetch.bind(this), 500);
    this.#template = this.querySelector('template').content.cloneNode(true);
  }

  get template() {
    if (this.#template instanceof window.DocumentFragment) {
      return this.#template;
    }
    return null;
  }

  connectedCallback() {
    this.incorporateVehicle() || this.determineVehicle();
  }

  determineVehicle() {
    try {
      const vehicle = JSON.parse(localStorage.getItem('vehicle'));
      if (vehicle && vehicle.sku) {
        this.setAttribute('vehicle', vehicle.sku);
        this.setAttribute('vehicle-title', vehicle.title);
      }
    } catch (e) {}
  }

  incorporateVehicle() {
    if (this.mmy instanceof MoveMMY && this.mmy.selectedVehicle) {
      this.setAttribute('vehicle', this.mmy.selectedVehicle.sku);
      this.setAttribute('vehicle-title', this.mmy.selectedVehicle.title);
      return true;
    }
    return false;
  }

  static get observedAttributes() {
    return ['product', 'vehicle'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.init();
  }

  fetch() {
    if (!this.getAttribute('vehicle') || !this.getAttribute('product')) {
      return;
    }
    this.classList.add('loading');
    this.innerHTML = 'Finding Instructions...';
    const url = `${BASE_URL}/api/vehicles/${this.getAttribute('vehicle')}/instructions/${this.getAttribute('product')}`;
    fetchData(url)
      .then(async (instruction) => {
        const anchors = [];
        if (instruction.product.instructions_pdf_url) {
          anchors.push(
            fetch(instruction.product.instructions_pdf_url).then(async (resp) => {
              const blob = await resp.blob();
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = instruction.product.instructions_pdf_url.split('/').pop();
              a.innerHTML = [instruction.product.detail?.title, 'General Instructions'].join(' ');
              return a;
            }),
          );
        }
        if (instruction.instructions_pdf_url) {
          anchors.push(
            await fetch(instruction.instructions_pdf_url).then(async (resp) => {
              const blob = await resp.blob();
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = instruction.instructions_pdf_url.split('/').pop();
              a.innerHTML = [
                instruction.vehicle.title,
                instruction.product.detail?.title,
                'Specific Instructions',
              ].join(' ');
              return a;
            }),
          );
        }
        anchors.push(
          new Promise((resolve) => {
            const a = document.createElement('a');
            a.innerHTML = 'How-To Build Videos';
            a.href = instruction.how_to_build_page_url;
            resolve(a);
          }),
        );
        Promise.all(anchors).then((anchors) => {
          this.render(anchors);
        });
      })
      .catch((e) => {
        this.closest('move-accordion').remove();
      })
      .finally(() => {
        this.classList.remove('loading');
      });
  }

  render(anchors) {
    this.innerHTML = '';
    this.appendChild(this.template.cloneNode(true));

    this.querySelector('h4 span:first-child').innerHTML = this.getAttribute('vehicle-title');
    this.querySelector('h4 span:last-child').innerHTML = this.getAttribute('product-title');

    this.querySelector('ul').innerHTML = '';

    // Append anchors to ul
    anchors.forEach((anchor) => {
      const li = this.template.querySelector('ul li').cloneNode(true);
      const a = li.querySelector('a');
      a.href = anchor.href;
      a.innerHTML = anchor.innerHTML;
      if (anchor.download) {
        a.download = anchor.download;
      }
      this.querySelector('ul').appendChild(li);
    });
  }
}

if (!customElements.get('move-product-instructions')) {
  customElements.define('move-product-instructions', MoveProductInstructions);
}

class MoveVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.productSelects = [];
  }

  connectedCallback() {
    this.productSelects = Array.from(this.querySelectorAll('select'));
    this.productSelects.forEach((select) => {
      select.addEventListener('change', this.handleSelectChange.bind(this, select));
    });
    this.radios = Array.from(this.querySelectorAll('input[type=radio]'));
    this.radios.forEach((radio) => {
      radio.addEventListener('change', this.handleRadioChange.bind(this, radio));
    });
  }

  async loadSection(section, variantId) {
    const params = new URLSearchParams();
    params.set('section_id', section.id.replace('shopify-section-', ''));
    if (variantId) {
      params.set('variant', variantId);
    }
    let url = `${location.origin}${location.pathname}?${params.toString()}`;
    return await fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        return res;
      })
      .then((res) => res.text())
      .then((html) => {
        const dom = new DOMParser().parseFromString(html, 'text/html');
        return dom;
      })
      .then((dom) => {
        const pageParams = new URLSearchParams(location.search);
        if (variantId) {
          pageParams.set('variant', variantId);
        }
        const pageUrl = `${location.origin}${location.pathname}?${pageParams.toString()}`;
        history.replaceState(null, '', pageUrl);
        section.innerHTML = dom.querySelector(`[id="${section.id}"]`).innerHTML;
      })
      .then(this.renderRatings)
      .catch((error) => {
        console.error('Error fetching cart section:', error);
      })
      .finally(() => {
        document.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: variantId }));
      });
  }

  renderRatings() {
    if (window.hasOwnProperty('yotpoWidgetsContainer')) {
      if (window.hasOwnProperty('yotpo')) {
        yotpo.initWidgets();
      } else {
        yotpoWidgetsContainer.initWidgets();
      }
    }
  }

  handleSelectChange(select) {
    if (select instanceof HTMLSelectElement) {
      const variantId = Array.from(select.selectedOptions).at(0).dataset.variantId;
      const section = this.closest('.shopify-section');
      this.loadSection(section, variantId);
    }
  }

  handleRadioChange(input) {
    if (input instanceof HTMLInputElement) {
      const variantId = input.dataset.variantId;
      const section = this.closest('.shopify-section');
      this.loadSection(section, variantId);
    }
  }
}

if (!customElements.get('move-variant-selects')) {
  customElements.define('move-variant-selects', MoveVariantSelects);
}

class MoveProductFilters extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.form.addEventListener('input', this.handleFormInput.bind(this));
    this.form.addEventListener('reset', debounce(this.handleFormInput.bind(this), 300));
    this.productsContainerId = 'products-container';
    this.filtersContainerId = 'filters-side-container';
    this.toggleFiltersButton = this.section.querySelector('.filter-button');
    this.filtersModal = this.section.querySelector('#filters-modal');
    this.toggleFiltersButton.addEventListener('click', this.toggleFilters.bind(this));
  }

  get section() {
    return this.form.closest('.shopify-section');
  }

  get productsContainer() {
    return this.section.querySelector(`#${this.productsContainerId}`);
  }

  get filtersContainer() {
    return this.section.querySelector(`#${this.filtersContainerId}`);
  }

  get loader() {
    return document.getElementById('loader-template').content.cloneNode(true);
  }

  toggleFilters() {
    if (this.filtersContainer.innerHTML.trim().length) {
      this.filtersModal.appendChild(this);
      this.filtersModal.classList.remove('hidden');
      document.body.classList.add('overflow-hidden');
    } else {
      this.filtersContainer.appendChild(this);
      this.filtersModal.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
    }
  }

  handleFormInput() {
    this.form.querySelector('.filter-count').textContent = this.form.querySelectorAll('input:checked').length;
    this.form.requestSubmit();
  }

  showLoader() {
    this.productsContainer.innerHTML = '';
    this.productsContainer.appendChild(this.loader);
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.showLoader();
    const formData = new FormData(this.form);
    const tags = formData.getAll('filter-tag').join('+');
    const parts = window.location.pathname.split('/').filter(Boolean);
    const params = new URLSearchParams(window.location.search);
    const href = window.location.origin + '/' + parts.slice(0, 2).concat(tags).join('/') + '?' + params.toString();
    if (!this.filtersContainer.innerHTML.trim().length) {
      this.toggleFilters();
    }
    await refreshSection(this.section, href, this.productsContainerId);
    this.renderRatings();
  }

  renderRatings() {
    if (window.hasOwnProperty('yotpoWidgetsContainer')) {
      if (window.hasOwnProperty('yotpo')) {
        yotpo.initWidgets();
      } else {
        yotpoWidgetsContainer.initWidgets();
      }
    }
  }
}

if (!customElements.get('move-product-filters')) {
  customElements.define('move-product-filters', MoveProductFilters);
}

// Incorporate the vehicle change to links
document.addEventListener('vehicle:changed', (e) => {
  const vehicle = e.target.selectedVehicle;
  document.querySelectorAll('.vehicle-collection-url').forEach((a) => {
    a.href = `/collections/${vehicle?.collection_handle || 'all'}`;
  });
  if (vehicle) {
    CustomizerStep2.RESET_FILTER_LOCATION = `/collections/${vehicle.collection_handle}`;
    CustomizerStep3.CLOSE_REDIRECT_PATH = `/collections/${vehicle.collection_handle}`;
  }
});

// analytics code
document.addEventListener('vehicle:changed', (e) => {
  if (!e.target.selectedVehicle) {
    return;
  }
  const url = BASE_URL + '/api/visitors/search';
  fetch(url, {
    method: 'post',
    keepalive: true,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      vehicle_id: e.target.selectedVehicle.sku,
    }),
  })
    .then((resp) => resp.json())
    .then(console.log)
    .catch((err) => {
      console.error(err);
    });
});
document.addEventListener('DOMContentLoaded', async () => {
  const country = await fetch('/browsing_context_suggestions.json')
    .then((response) => response.json())
    .then((data) => {
      const userCountryName = data.detected_values.country.name;
      const userCountryHandle = data.detected_values.country.handle;
      return userCountryHandle;
    });
  const url = BASE_URL + '/api/visitors';
  fetch(url, {
    method: 'post',
    keepalive: true,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      country,
    }),
  })
    .then((resp) => resp.json())
    .then(async ({ visitor }) => {
      // Calculate an expiration date far into the future (e.g., 10 years)
      // The browser will cap this value to its maximum limit (around 400 days in Chrome)
      const tenYearsInMilliseconds = 10 * 365 * 24 * 60 * 60 * 1000;
      const expirationDate = Date.now() + tenYearsInMilliseconds;
      try {
        return await cookieStore.set({
          name: 'visitor_id',
          value: visitor.id,
          expires: expirationDate,
          path: '/',
          domain: 'movebumpers.com',
          sameSite: 'lax',
        });
      } catch (error) {
        console.error(error);
      }
    });
});
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener(
    'click',
    (event) => {
      if (event.target.classList.contains('popup-icons-container') || event.target.closest('.popup-icons-container')) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
      if (event.target.classList.contains('prouct-feature-icon') || event.target.closest('.prouct-feature-icon')) {
        const icon = event.target.closest('.prouct-feature-icon') || event.target;
        if (icon) {
          const popover = icon.querySelector('.product-feature-popover');
          const right = popover.getBoundingClientRect().right;
          const offset = window.innerWidth - (right + 10);
          icon.style.setProperty('--left', Math.min(offset, 0) + 'px');
        }
      }
    },
    { capture: true },
  );
});

document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (form instanceof HTMLFormElement && form.id === 'cart-discount') {
    e.preventDefault();
    const btns = Array.from(form.elements.apply instanceof RadioNodeList ? form.elements.apply : [form.elements.apply]);
    const input = document.querySelector('input[name="discount"]:not([type="hidden"])');
    const checkbox = document.querySelector('form#cart').elements['default-checkbox'];
    if (!(input instanceof HTMLInputElement)) {
      return;
    }
    const code = input.value;
    // if (!code) {
    //   alert('Please enter a discount code');
    //   return;
    // }
    btns.forEach((btn) => {
      btn.disabled = true;
    });
    if (checkbox instanceof HTMLInputElement) {
      checkbox.disabled = true;
      checkbox.checked = false;
    }
    input.readOnly = true;
    const data = new FormData(form);
    const url = window.PROXY_API_BASE_URL + '/apply-discount-codes';
    const cart = await fetch('/cart.js').then((resp) => resp.json());
    await fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        discount_codes: data.getAll('discount').filter(Boolean),
        cart_token: cart.token,
      }),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((resp) => {
        if (resp.ok) {
          return resp.json();
        }
        throw new Error('Failed to apply discount codes');
      })
      .then(async ({ cartDiscountCodesUpdate: { cart, userErrors, warnings } }) => {
        // console.log(cart, userErrors, warnings);
        await Promise.all(
          Array.from(document.querySelectorAll('.move-cart-items-section')).map((section) => refreshSection(section)),
        );
        const input = document.querySelector('input[name="discount"]:not([type="hidden"])');
        if (!(input instanceof HTMLInputElement)) {
          return;
        }
        // input.value = code;
        const invalidCodes = cart.discountCodes.filter(({ applicable }) => !applicable).map(({ code }) => code);
        if (invalidCodes.includes(code)) {
          input.setCustomValidity('Please enter a valid code!');
          input.addEventListener(
            'input',
            () => {
              input.setCustomValidity('');
            },
            { once: true },
          );
        }
        window.invalidCodes = invalidCodes;
      })
      .catch(console.warn)
      .finally(() => {
        btns.forEach((btn) => {
          btn.disabled = false;
        });
        if (checkbox instanceof HTMLInputElement) {
          checkbox.disabled = false;
        }
        input.readOnly = false;
      });
  }
});

class CollectionBreadcrumbs extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
    <style>
    .breadcrumb-container {
      padding: 1rem 0;
      background-color: #f9fafb;
      border-bottom: 1px solid #e5e7eb;
    }

    .breadcrumb-list {
      display: flex;
      align-items: center;
      list-style: none;
      // margin: 0 2rem 0 2rem;
      gap: 1rem;
    }
    .breadcrumb-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 1rem;
      &:not(:last-child) {
        &::after {
          content: ' ';
        }
        &::after {
          height: 0.75rem;
        }
        &::after {
          width: 0.75rem;
        }
        &::after {
          background-image: var(--icon-customizer-breadcrumbs-arrow);
        }
        &::after {
          background-size: contain;
        }
        &::after {
          background-position: center;
        }
        &::after {
          background-repeat: no-repeat;
        }
      }
    }

    .breadcrumb-link {
      color: #6b7280;
      text-decoration: none;
      font-size: 0.875rem;
      transition: color 0.2s;
    }

    .breadcrumb-link:hover {
      color: #374151;
      text-decoration: underline;
    }

    .breadcrumb-current {
      color: #111827;
      font-weight: 500;
      font-size: 0.875rem;
    }

    .breadcrumb-separator {
      margin: 0 0.5rem;
      color: #9ca3af;
      display: flex;
      align-items: center;
    }

    @media (max-width: 768px) {
      .breadcrumb-list {
        padding: 0 1rem;
      }

      .breadcrumb-link,
      .breadcrumb-current {
        font-size: 0.75rem;
      }
    }
  </style>
    <nav class="breadcrumb-container" aria-label="Breadcrumb">
      <ol class="breadcrumb-list">
      </ol>
    </nav>
    `;
  }
  connectedCallback() {
    document.addEventListener('vehicle:changed', (event) => {
      const vehicle = event.detail;
      const list = this.shadowRoot.querySelector('.breadcrumb-list');
      list.innerHTML = `<li class="breadcrumb-item">
        <a href="/tools/vehicles/aftermarket-diy-bumper-kits" class="breadcrumb-link">Vehicles</a>
      </li>
      <li class="breadcrumb-item">
        <a href="/tools/vehicles/make/${vehicle.make.slugify()}-aftermarket-diy-bumper-kits" class="breadcrumb-link">${vehicle.make}</a>
      </li>
      <li class="breadcrumb-item">
        <a href="/tools/vehicles/${vehicle.make.slugify()}/${vehicle.model.slugify()}-aftermarket-diy-bumper-kits" class="breadcrumb-link">${vehicle.model}</a>
      </li>
      <li class="breadcrumb-item">
        <span class="breadcrumb-current">${vehicle.year}</span>
      </li>`;
    });
  }
}
if (!customElements.get('collection-breadcrumbs')) {
  customElements.define('collection-breadcrumbs', CollectionBreadcrumbs);
}

// Alert user if trying to buy North Light products from Canada
const alertWhenNorthLightBuyingFromCanada = () => {
  const consentButton = document.querySelector('.consent-for-country');
  if (consentButton) {
    consentButton.disabled = false;
    consentButton.addEventListener('click', async (e) => {
      e.preventDefault();
      const countryCode = consentButton.dataset.country;
      const vendor = consentButton.dataset.vendor;
      const countryName = consentButton.dataset.countryName;
      const userCountryCode = await getUserCountry();
      if (countryCode !== userCountryCode || vendor !== 'North Lights') {
        consentButton.form.requestSubmit();
        return;
      }
      askConsent({
        heading: 'Caution!',
        body: `This item cannot be shipped to ${countryName}. Would you still like to add it to your cart?`,
        saveText: 'Add To Cart',
      }).then((result) => {
        if (result === 'save') {
          consentButton.form.requestSubmit();
        }
      });
    });
  }
};
document.addEventListener('variant:changed', alertWhenNorthLightBuyingFromCanada);
document.addEventListener('DOMContentLoaded', alertWhenNorthLightBuyingFromCanada);

class ReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.initGallery();
    this.initCarousels();
  }

  initGallery() {
    this.querySelectorAll('.js-review-gallery').forEach((gallery) => {
      const images = JSON.parse(gallery.dataset.images || '[]');
      if (images.length === 0) return;

      gallery.addEventListener('click', (e) => {
        const clickedImg = e.target.closest('.js-photoswipe-img');
        if (!clickedImg) return;

        if (clickedImg.parentElement.tagName === 'A') {
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        const clickedSrc = clickedImg.dataset.src;
        const startIndex = images.findIndex((img) => img.original === clickedSrc);
        if (startIndex === -1) return;

        this.openPhotoSwipe(images, startIndex);
      });
    });
  }

  openPhotoSwipe(images, startIndex) {
    const dataSource = images.map((img) => ({
      src: img.original,
      alt: 'review photo',
      ...(img.src ? { msrc: img.src } : {}),
    }));
    seedImageSize(dataSource[startIndex]);

    const pswp = new PhotoSwipe({
      dataSource: dataSource,
      index: startIndex,
      showHideAnimationType: 'fade',
      bgOpacity: 0.9,
      padding: { top: 20, bottom: 20, left: 20, right: 20 },
      preload: [0, 0],
      loop: false,
      preloadFirstSlide: false,
      preloaderDelay: 100,
    });

    enableLazySlideLoading(pswp);
    pswp.init();
    ensureSlideSize(pswp);
  }

  initCarousels() {
    this.querySelectorAll('[data-product-group]').forEach((group) => {
      const index = group.querySelector('.carousel-track').dataset.carouselIndex;
      const track = document.getElementById('carousel-' + index);
      const slides = track.querySelectorAll('.carousel-slide');
      const dots = group.querySelectorAll('.carousel-dot');
      const prevBtn = group.querySelector('.js-carousel-prev');
      const nextBtn = group.querySelector('.js-carousel-next');
      const counter = group.querySelector('.js-carousel-counter');
      let current = 0;
      const total = slides.length;

      const goTo = (n) => {
        current = Math.max(0, Math.min(n, total - 1));
        track.style.transform = 'translateX(-' + current * 100 + '%)';
        dots.forEach((d, i) => {
          if (i === current) {
            d.classList.add('carousel-dot--active');
          } else {
            d.classList.remove('carousel-dot--active');
          }
        });
        if (prevBtn) prevBtn.disabled = current === 0;
        if (nextBtn) nextBtn.disabled = current === total - 1;
        if (counter) counter.textContent = current + 1 + ' of ' + total;
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', () => goTo(current - 1));
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => goTo(current + 1));
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => goTo(parseInt(dot.dataset.slide, 10)));
      });

      let touchStartX = 0;
      let touchEndX = 0;

      track.addEventListener(
        'touchstart',
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true },
      );

      track.addEventListener(
        'touchend',
        (e) => {
          touchEndX = e.changedTouches[0].screenX;
          const diff = touchStartX - touchEndX;
          if (Math.abs(diff) > 50) {
            if (diff > 0) {
              goTo(current + 1);
            } else {
              goTo(current - 1);
            }
          }
        },
        { passive: true },
      );
    });
  }
}
if (!customElements.get('reviews-carousel')) {
  customElements.define('reviews-carousel', ReviewsCarousel);
}

document.addEventListener('DOMContentLoaded', async function () {
  if (!window.location.pathname.includes('/products/')) {
    return;
  }
  const MAX_TRIES = 10;
  let attempts = 0;

  async function getModalContainer() {
    const modalContainer = document
      .querySelector('[data-nametag="shop-portal-provider"]')
      ?.shadowRoot?.querySelector('[data-testid="authorize-modal-container"]');

    if (modalContainer) {
      return modalContainer;
    }

    if (attempts >= MAX_TRIES) {
      console.error('Failed to find modal container after', MAX_TRIES, 'attempts');
      return null;
    }

    attempts++;
    await new Promise((resolve) => setTimeout(resolve, 500));
    return getModalContainer();
  }

  const modalContainer = await getModalContainer();
  if (modalContainer) {
    const observer = new MutationObserver(function (records) {
      if (modalContainer.classList.contains('visible')) {
        window.dispatchEvent(
          new CustomEvent('shop-pay-modal:opened', {
            detail: {
              container: modalContainer,
            },
            composed: true,
          }),
        );
      } else if (modalContainer.classList.contains('invisible')) {
        window.dispatchEvent(
          new CustomEvent('shop-pay-modal:closed', {
            detail: {
              container: modalContainer,
            },
            composed: true,
          }),
        );
      }
    });
    observer.observe(modalContainer, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }
});

window.addEventListener('shop-pay-modal:opened', ({ detail: { container } }) => {
  if (!window.location.pathname.includes('/products/')) {
    return;
  }
  const button = container.querySelector('[data-testid="sample-plans-modal-continue-to-checkout-button"]>button');
  const text = container.querySelector('[data-testid="sample-plans-modal-continue-to-checkout-button"]+div');
  const customizerBtn = document.querySelector('.product-page-button');
  const closeButton = container.querySelector('button[data-testid="authorize-modal-close-button"]');

  if (button instanceof HTMLButtonElement) {
    const customBtn = button.cloneNode(true);
    button.replaceWith(customBtn);
    customBtn.disabled = !customizerBtn;
    customBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      closeButton.click();
      customizerBtn.click();
    });
    customBtn.textContent = 'Get Started';
  }
  text?.remove();
});

window.addEventListener('load', function () {
  document.querySelector('video')?.play();
});

// Cart Form Submission Handling
// document.addEventListener('submit', (e) => {
//   if (e.target.id !== 'cart') return;
//   e.preventDefault();
//   const form = e.target;
//   const data = new FormData(form);
//   const coupons = data.getAll('discount').join(',');
//   console.log(Object.fromEntries(data));
//   form.querySelector('input[name="discount"]:not([type=hidden])').disabled = true;
//   form.querySelector('input[name="discount"][type=hidden]').value = coupons;
//   window.location.href = '/checkout?discount=' + encodeURIComponent(coupons);
// });
export { refreshSection };
